class LensAdvizorBtn extends HTMLElement {
    async connectedCallback() {
        this.productId = this.getAttribute("data-la-product-id")
        this.variantId = this.getAttribute("data-la-variant-id")
        this.flowId = this.getAttribute("data-la-flow-id") || ''
        this.productHandle = this.getAttribute("data-la-product-handle")
        const relatedScript = document.querySelector(`[data-lensadvizor-product="${this.productId}"]`)

        if (this.hasAttribute("data-la-product-json")) {
            this.productJSON = JSON.parse(this.getAttribute("data-la-product-json"))
        } else if (relatedScript) {
            this.productJSON = JSON.parse(relatedScript.innerHTML)
        } else {
            this.productJSON = await this.getProductJson()
        }

        this.addEventListener("click", e => this.launchLensAdvizorModal(e))
    }

    launchLensAdvizorModal(e) {
        const selectedVariantId = this.getAttribute("data-la-variant-id")
        const selectedVariant = this.productJSON.variants.find((variant) => variant.id == selectedVariantId)

        LensAdvizor.productAvailable = this.productJSON.available
        LensAdvizor.prices = {
            "frame": selectedVariant.price / 100,
            "lens": null,
            "addons": null,
            "subtotal": selectedVariant.price / 100
        }
        const lensAdvizorPrescriptionModal = document.querySelector("#lensadvizor-prescription-modal")
        const toolTipModal = document.querySelector("#la-tooltip-modal")
        const tooltipInformationModal = document.querySelector('#la-boxy-footer-modal')

        if (lensAdvizorPrescriptionModal) {
            lensAdvizorPrescriptionModal.remove()
        }
        if (toolTipModal) {
            toolTipModal.remove()
        }
        if (tooltipInformationModal) {
            tooltipInformationModal.remove()
        }

        LensAdvizor.handle = this.productJSON.handle
        LensAdvizor.productId = this.productId
        LensAdvizor.product = this.productJSON
        LensAdvizor.variantsJSON = this.productJSON.variants
        LensAdvizor.selectedOrDefaultVariant = selectedVariantId
        LensAdvizor.productTitle = this.productJSON.title
        LensAdvizor.collectionId = this.flowId
        LensAdvizor.productDefaultImage = this.productJSON.featured_image
        LensAdvizor.selectLensButtons = this.parentElement.querySelectorAll('lensadvizor-btn')
        LensAdvizor.initdata(LensAdvizor.products[this.productId])
        LensAdvizor.prescriptionTypes = []
        LensAdvizor.updateLensAdvizorVariants()

        const selectedLensAdvizorVariant = LensAdvizor.variants[LensAdvizor.selectedOrDefaultVariant]
        LensAdvizor.updateStyles(selectedLensAdvizorVariant.settings)
        LensAdvizor.collectionId = selectedLensAdvizorVariant.collection_id
        document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:open'));
        // Handle Collection id based upon the api from the backend and launch LensAdvizor based on the button clicked.
    }

    getProductJson() {
        const requestRoute = `${Shopify.routes.root}products/${this.productHandle}.js`;
        return window
        .fetch(requestRoute)
        .then((response) => {
            return response.json();
        })
        .catch((e) => {
            console.error(e);
        });
    }
}

class LensAdvizorQuickBuy extends LensAdvizorBtn {
    constructor() {
        super(LensAdvizorBtn, { delayRender: true });
        this.flowId = this.getAttribute("data-la-flow-id") || ''
        this.isQuickView = this.getAttribute("data-la-quick-view")
    }

    connectedCallback() {
        super.connectedCallback()
        if (this.isQuickView) {
            this.initBuy()
        }
    }

    initBuy() {
        if (window.LensAdvizor == undefined) {
            return setTimeout(() => {
                this.initBuy();
            }, 2000)
        }

        document.dispatchEvent(new CustomEvent('LensAdvizor:init-quick-buy:start'));
        
        const productFlows = [{
            productId: this.productId,
            flowId: this.flowId
        }]

        const settingsUrl = LensAdvizor.addQueryParamsToURL(LensAdvizor.API_URL + "/store/quick-buy-settings", {
            store: Shopify.shop,
            product_flows: JSON.stringify(productFlows),
            api_version: 2
        })

        fetch(settingsUrl)
        .then(res => res.json())
        .then(response => {
            LensAdvizor.products = {...LensAdvizor.products, ...response.products}
            LensAdvizor.options = response
            LensAdvizor.settings = response.settings;

            LensAdvizor.addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] [type=submit]')

            LensAdvizor.enableLunaPdTool = LensAdvizor.options.is_luna_domains_whitelisted && LensAdvizor.options.billing_plan.enable_luna_pd_tool

            if (LensAdvizor.enableLunaPdTool && !LensAdvizor.options.billing_plan.custom_settings.skipLunaInit) {
                LensAdvizor.Luna.importScript()
            }
            LensAdvizor.updateCustomJSandCss()
            LensAdvizor.addEventListeners()

            const product = response.products[this.productId]
            const selectedVariant = this.productJSON.variants.find((variant) => variant.id == this.variantId)
            let settings = {}

            if (product.assign_by == "product" && product && product.assigned_variants) {
                LensAdvizor.updateQuickBuyButton(this, product.assigned_variants[this.variantId].settings)
                settings = product.assigned_variants[this.variantId].settings
            } else if (product.assign_by == "collection" && selectedVariant.available) {
                LensAdvizor.updateQuickBuyButton(this, product.collection_settings)
                settings = product.collection_settings
            }

            if (product.assigned_variants && Object.keys(product.assigned_variants).length) {
                if (settings.showAddToCartButton) {
                    LensAdvizor.addToCartButtons.forEach(button => {
                        button.style.display = ''
                        button.classList.remove("la-visiblity-hidden")
                    })
                }
            }

            if (LensAdvizor.enableLunaPdTool && !LensAdvizor.options.billing_plan.custom_settings.skipLunaInit) {
                LensAdvizor.Luna.init(LensAdvizor)
            }

            document.dispatchEvent(new CustomEvent('LensAdvizor:init-quick-buy:complete'));
        })
        .catch(LensAdvizor.handleSettingsException.bind(LensAdvizor))
    }
}

class LensAdvizorSelfie extends HTMLElement {
    connectedCallback() {
        this.lensAdvizor = LensAdvizor
        this.render()
        this.videoElement = this.querySelector("video")
        this.canvasElement = this.querySelector("canvas")
        this.modal = this.querySelector('#la-selfie-modal')
        this.modalContent = this.querySelector('#la-selfie-modal-content')
        this.trigger = document.querySelector('#la-selfie-btn')
        this.lensAdvizorModal = document.querySelector('.la-prescription-modal-content')
        this.captureBtn = this.querySelector('.la-selfie-capture-btn');
        this.retryBtn = this.querySelector('.la-selfie-retry-btn');
        this.acceptBtn = this.querySelector('.la-selfie-accept-btn');
        this.loader = this.querySelector('#la-loader');
        this.input = this.querySelector('#la-selfie-field');
        this.snap = this.querySelector('.la-snap')
        this.addEventListeners()
        if (this.lensAdvizor.response.selfie) {
            this.input.removeAttribute("required")
        }
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.closeVideo.bind(this))
    }

    setInnerHtml(content) {
        this.innerHTML = content
    }

    render() {
        const content = `
            <div class="la-prescription-fields-wrapper la-selfie-wrapper" style="margin-bottom: 1.5rem">
                <h6 class="la-h6">${this.lensAdvizor.Translation.getTranslatedText("Selfie image capture")}</h6>
                <input type="text" ${this.getAttribute('required')} id="la-selfie-field" class="la-hidden" inputmode="none">
                <label id="la-selfie-btn" class="la-selfie-btn la-label-btn la-prescription-file-label">
                    ${this.lensAdvizor.svg.camera}
                    <span style="margin: auto">
                        Open Camera
                    </span>
                </label>
                <p class="la-information" id="la-selfie-upload-message">
                    ${this.lensAdvizor.response.selfie ? `${this.lensAdvizor.svg.check} <a href="${this.lensAdvizor.response.selfie.blob}" target="__blank">${this.lensAdvizor.response.selfie.originalName}</a>` : ''}
                </p>
            </div>
            <div id="la-selfie-modal" class="la-selfie-modal">
            <div class="la-selfie-modal-content" id="la-selfie-modal-content">
                <div class="la-selfie-modal-header">
                    <h2>Capture Selfie</h2>
                    <span class="la-selfie-modal-close">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO2aT2gcVRzHv7/ZaOYgIQtVMDezQVHBW0uLWy+biK2gB2ER9FZIwJZUPHRmAsERkZfJQWwwPQRvBZE9CFaMgrMQlFL/HLxVKpkN6LHiBg+6q8n+vOzgGmd33m/mbfHPfG67+95v3vvtvM9vZt4ABQUFBQUFBf9XSNJYKeVblnX/9PT0haWlpd/HNagsNBqNUhRFb1qW9avjOK5uP+0EKKV8Inq1/zFk5rrneW3xSMeA7/tTtm2/C+BpACCiQDcJWgk4MvmYXSJ6xnGcb2XDNYtSao6IrgF4ePB73SRYGgdImjwAzDHzdaXUvP5wzbK+vn6aiG7gyOQBgJmdIAjW0mKkJgDAvSN+KxPRJ0EQLGvEMYpSarHX6zUBHBvWhpnvSYszkdagUqkst1qtBwCcGdKkxMyXgyB49E7IsdFolPb29t5gZieladjpdF5Oi6flgL5kbgB4JO2g45TjUdmN4BYzn9IZh6QKzBLRlxhxyvUZixyHyS6Bdq/XO7mysvKdTlwdBwAAPM9rAXgOwG8pTY3LcZTsjnDAzHXdyQOCBACA67qfEdFLGk2NyVFHdjFEdNHzvFASX3QlODCoTc1EgIi2sshRILuYTdd1L0iOAQjPgJhKpbIM4GOdtsy82G63t5VSZd34vu9PtVqtDwST1zJ+EpkSUK/XDzudzvMAbmp2mSeir4IgSFvDUErN2bb9BdJNH3OLmeu+7x9otv8LmZZAjKAyxLT7ZTJxna6vr5/u9XrvS+JJjJ9EpjMgRlAZYobKUSK7PmLjJ5HrDIgJguAcM78jOnBfjuVyuSeUXdz/vOM4V2QjTYiTN0CMpDIMEC8F0TUDM1/xPO+88FiJ5FoCg0gqwwDzEE4eQNjtdi8K+wzFWAIyVIYs5DJ+EsaWQEyGyqBLbuMnYewMiMlQGXQwYvwkjCcAEN0zaJHlGl+X0jiCAkAYht/UarX7iOh4zlCbruu+ZmRQCYzlDIipVCrLRLSdI0Tma3xdxpqAfwNjTUAURRvMfDZHiHnbtt8yNqAExuaAIAjOAXjdQKgTCwsLt8Mw/NpArL9h/DoAANbW1p4A8CmAuw2FPGDmM+OoBMWFkMlgvu9PEdGHMD95AChblnVN8mRJB2MJaDQaJdu230P63kEeHiKihu/7qRs6uhhLQBRFGxi+ezSMEH/eEusyPzk5eVnYZyhGqkAW4xPRVrlcfmFmZubq/v7+JICqoO9xU5UhtwQzGP+QiF5xHGdj8Eul1CIRvQ3gLs04RipD8VA0a8cMxt8losdH/WOXLl36nJlPAdDdV8xdGTIlIIPxQ2Y+obNh6nnebqfTOQngI83YuSpDpgRIjN+X3VnJlrnv+z/Pzs4+S0SBZpfM9wxiBwgegSfKTopEjlkelYsSIDD+SNlJEchRXBmKFyR0GgmMry07KQI5iipDagJ0jZ9FdlIEctSuDKkNoijaIKJRxjciO13q9fohAFcp1UqRY1wZRr40obMEvh/xW5uZn7pTkx/E87wty7JqAH4c1oaIbqfF0X1V1iGio29d/tNflfUdx0l9nK51N9hsNq/XarUOEcUbmSEzP+m67g/yIZul2Wz+VK1Wr05MTDwG4EFAf/KA4Ha4nwQCcLPb7b64urr6S7Yhm2dnZ6dbrVYbpVLpGIDtcW6kFBQUFBQUFPx3+ANTr3SGfzU/zQAAAABJRU5ErkJggg==">
                    </span>
                </div>
                <div class="la-selfie-modal-body">
                    <video style="display: none;" playsinline autoplay muted></video>
                    <audio class="la-snap" src="https://cdn.shopify.com/s/files/1/0413/1160/0808/files/snap.mp3?v=1721644918" hidden></audio>
                    <canvas style="display: none;"></canvas>
                    <div class="la-lens-loader" id="la-loader" role="status"></div>
                    <div class="la-selfie-btn-container">
                        <button class="la-selfie-capture-btn" type="button" style="display: none;">
                            <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3.2"></circle><path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"></path></svg>
                        </button>
                        <button class="la-selfie-retry-btn" type="button" style="display: none;">
                            <svg focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></svg>
                        </button>
                        <button class="la-selfie-accept-btn" type="button" style="display: none;">
                            <svg class="MuiSvgIcon-root jss119" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path></svg>
                        </button>
                    <div>
                </div>
            </div>
        </div>`
        this.setInnerHtml(content)
    }

    handlePermissionDenied = () => {
        this.modalContent.querySelector('.la-selfie-modal-body').innerHTML = `<span style='padding: 4rem 1rem'>
            Camera permission deined! Please allow camera permission.
        </span>`
    }

    openVideo = () => {
        this.modal.style.display = "block";
        this.lensAdvizorModal.classList.add("la-selfie-modal-open");

        navigator.mediaDevices.getUserMedia({
            video: { facingMode: "user" },
            audio: false
        })
        .then((stream) => {
            this.videoElement.style.display = '';
            if ('srcObject' in this.videoElement) {
                this.videoElement.srcObject = stream;
            } else {
                this.videoElement.src = URL.createObjectURL(stream);
            }
            this.videoElement.onplaying = () => {
                this.captureBtn.style.display = ""
                this.loader.style.display = "none";
                this.canvasElement.setAttribute('width', this.videoElement.videoWidth);
                this.canvasElement.setAttribute('height', this.videoElement.videoHeight);
            }
            this.videoElement.play();
        })
        .catch(e => {
            console.log(e)
            this.handlePermissionDenied()
        })
    }

    addEventListeners() {
        this.trigger.addEventListener('click', this.openVideo.bind(this))
        this.querySelector('.la-selfie-modal-close').addEventListener('click', () => this.closeVideo())
        document.addEventListener('click', this.closeVideo.bind(this))
        this.captureBtn.addEventListener('click', this.capture.bind(this))
        this.retryBtn.addEventListener('click', this.retry.bind(this))
        this.acceptBtn.addEventListener('click', this.accept.bind(this))
    }

    closeVideo(evt) {
        if (evt && evt.target != this.modal) {
            return
        }

        this.lensAdvizorModal.classList.remove("la-selfie-modal-open")
        setTimeout(() => {
            this.modal.style.display = "none";
            this.captureBtn.style.display = "none";
            this.videoElement.pause();
            if (this.videoElement.srcObject) {
                const tracks = this.videoElement.srcObject.getTracks()
                tracks.forEach(track => track.stop())
                this.videoElement.srcObject = undefined;
            }
            this.loader.style.display = "";
            this.canvasElement.style.display = 'none';
            this.retryBtn.style.display = 'none';
            this.acceptBtn.style.display = 'none'
        }, 350)
    }

    capture() {
        this.snap.play()
        var context = this.canvasElement.getContext('2d');
        context.scale(-1, 1);
        context.drawImage(this.videoElement, 0, 0, -this.videoElement.videoWidth, this.videoElement.videoHeight);
        this.videoElement.style.display = 'none';
        this.canvasElement.style.display = '';
        this.captureBtn.style.display = "none";
        this.retryBtn.style.display = ''
        this.acceptBtn.style.display = ''
    }

    retry() {
        var context = this.canvasElement.getContext('2d');
        context.scale(-1, 1);
        context.restore();
        this.retryBtn.style.display = 'none';
        this.captureBtn.style.display = "";
        this.videoElement.style.display = '';
        this.canvasElement.style.display = 'none';
        this.acceptBtn.style.display = 'none'
    }

    getFormData = function (filename) {
        let formData = new FormData()
        formData.append("filename", filename)
        formData.append("domain", Shopify.shop)
        formData.append("content_type", 'image/png')
        return formData
    }

    getFile = async (filename) => {
        return new Promise((resolve, reject) => {
            this.canvasElement.toBlob(blob => {
                let uploadableFile = new File([blob], filename, {type: 'image/png'})
                resolve(uploadableFile)
            }, 'image/png', 1);
        })
    }

    accept = async function () {
        this.loader.style.display = "";
        const filename = `selfie-${new Date().getTime()}.png`
        let signedResponse = await fetch(`${this.lensAdvizor.API_URL}/selfie/upload/`, {
            method: 'POST',
            body: this.getFormData(filename),
            api_version: 2
        })
        signedResponse = await signedResponse.json()
        const resizedFile = await this.getFile()
        let uploadResponse = await fetch(signedResponse.uploadUrl, {
            method: 'PUT',
            mode: 'cors',
            body: resizedFile
        }).catch(err => {
            // Show error on Storefront
        });
        
        if (uploadResponse) {
            if ([200, 201].includes(uploadResponse.status)) {
                this.lensAdvizor.response.selfie = {
                    fileUrl: signedResponse.filename,
                    authenticateURL: signedResponse.authenticateURL,
                    originalName: filename,
                    type: 'image/png',
                    blob: URL.createObjectURL(resizedFile),
                    lastModified: null
                }
                const uploadInformation = this.querySelector("#la-selfie-upload-message")
                uploadInformation.innerHTML = `${this.lensAdvizor.svg.check} <a href="${this.lensAdvizor.response.selfie.blob}" target="__blank">${filename}</a>`
                this.input.removeAttribute("required")
                this.closeVideo()
            } else {
                this.input.setAttribute("required")
                this.lensAdvizor.response.selfie = null
                uploadInformation.innerHTML = `<span class="la-error">${this.lensAdvizor.Translation.getTranslatedText("Unable to upload selfie. Please try again.")}</span>`
            }
            this.closeVideo()
        }
    }

    async getSelfieUrl() {
    }

}

if (!window.customElements.get('lensadvizor-btn')) {
    window.customElements.define('lensadvizor-btn', LensAdvizorBtn);
}

if (!window.customElements.get('lensadvizor-quick-buy')) {
    window.customElements.define('lensadvizor-quick-buy', LensAdvizorQuickBuy);
}

if (!window.customElements.get('lensadvizor-selfie')) {
    window.customElements.define('lensadvizor-selfie', LensAdvizorSelfie);
}

LensAdvizor = {
    ...LensAdvizorBase,
    quickBuy: {},
    products: {},
    localStorage: {},
    selectLensButtons: [],
    quickBuyButtons: [],
    productForms: [],
    addToCartButtons: [],
    customAddOns: [],
    customProductIds: [],
    previousStep: null,
    stepCount: 4,
    currentStep: 'renderPrescriptionTypes',
    presentmentPrices: {},
    tooltips: [],
    previewIcon: "https://cdn.shopify.com/s/files/1/0413/1160/0808/files/1564488_eye_show_transparent_view_explore_icon_c6e65ce1-af8e-4daa-ac92-4c77c32175ff.png",
    poweredBy: `<p class="la-branding">
        <span>Powered By </span><img src="https://d15as34r88kmuk.cloudfront.net/media/lenzadvizor+500x500.png"> <strong>LensAdvizor</strong>
    </p>`,
    headerContent: `<div class="la-prescription-modal-header" id="la-prescription-modal-header">
        <span class="la-steeper-back" style="visibility: hidden">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAB0UlEQVR4nO3YMU7jQBQG4P+NEFofgALOQQPaggZxiy05wzjVVImn3ootKRF3gAvsJbZdiQSB8FBkHgWJFSWzITGJnTX/13hkxdHz07w/sQEiIiIiIiIiIiKiFTnn9r33V23X8Rmm7oXe+6Msy+5V9XKTBTVtr85FRVGcquotgMMN19O4tXfAYDC4BHCHDtw8sMYOcM7tZ1n283/f8vNWaoD3/gjAraqebLmexn3YgC7Ne8rSDOjavKdI6mSNeX8AMAIQAJTTtYi8AHhU1VcReQbwFGMMAJ5E5FlVXwE8isiLMSaMx+ORMSbEGEtr7UhE9PO3uNxCA3Zw3gOAId4bGwCUIhJijENjTDlpaLUWkaGqliISACyspw3O83wIzGXAjs77N8zVo6oQkeo4ew5AdUytZz4nwEwGfIV5T6kaMNkmscVaWlE1wFp7rarfAfxpsZ7GLYRgv98/MMbcADhroZ6UjYdgWZYPzrkA8Gcw3YCpoih+ALjCexL/k7V26ffssqX/BL9CLnz4OJzn+e8Y4zGA+wbqadxK7wN6vd7fEMK5iPhtF9S0tWc3lQudzYCUruVCrZeiXcqF2m+FJ7lwISK/NlkQERERERERERER0Ta9Ad9jKGih/W7NAAAAAElFTkSuQmCC">
        </span>
        <div class="la-progress-bar" style="display: none;">
            <div class="la-inner-bar" style="width: 25%"></div>
        </div>
        <span class="la-prescription-modal-close">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO2aT2gcVRzHv7/ZaOYgIQtVMDezQVHBW0uLWy+biK2gB2ER9FZIwJZUPHRmAsERkZfJQWwwPQRvBZE9CFaMgrMQlFL/HLxVKpkN6LHiBg+6q8n+vOzgGmd33m/mbfHPfG67+95v3vvtvM9vZt4ABQUFBQUFBf9XSNJYKeVblnX/9PT0haWlpd/HNagsNBqNUhRFb1qW9avjOK5uP+0EKKV8Inq1/zFk5rrneW3xSMeA7/tTtm2/C+BpACCiQDcJWgk4MvmYXSJ6xnGcb2XDNYtSao6IrgF4ePB73SRYGgdImjwAzDHzdaXUvP5wzbK+vn6aiG7gyOQBgJmdIAjW0mKkJgDAvSN+KxPRJ0EQLGvEMYpSarHX6zUBHBvWhpnvSYszkdagUqkst1qtBwCcGdKkxMyXgyB49E7IsdFolPb29t5gZieladjpdF5Oi6flgL5kbgB4JO2g45TjUdmN4BYzn9IZh6QKzBLRlxhxyvUZixyHyS6Bdq/XO7mysvKdTlwdBwAAPM9rAXgOwG8pTY3LcZTsjnDAzHXdyQOCBACA67qfEdFLGk2NyVFHdjFEdNHzvFASX3QlODCoTc1EgIi2sshRILuYTdd1L0iOAQjPgJhKpbIM4GOdtsy82G63t5VSZd34vu9PtVqtDwST1zJ+EpkSUK/XDzudzvMAbmp2mSeir4IgSFvDUErN2bb9BdJNH3OLmeu+7x9otv8LmZZAjKAyxLT7ZTJxna6vr5/u9XrvS+JJjJ9EpjMgRlAZYobKUSK7PmLjJ5HrDIgJguAcM78jOnBfjuVyuSeUXdz/vOM4V2QjTYiTN0CMpDIMEC8F0TUDM1/xPO+88FiJ5FoCg0gqwwDzEE4eQNjtdi8K+wzFWAIyVIYs5DJ+EsaWQEyGyqBLbuMnYewMiMlQGXQwYvwkjCcAEN0zaJHlGl+X0jiCAkAYht/UarX7iOh4zlCbruu+ZmRQCYzlDIipVCrLRLSdI0Tma3xdxpqAfwNjTUAURRvMfDZHiHnbtt8yNqAExuaAIAjOAXjdQKgTCwsLt8Mw/NpArL9h/DoAANbW1p4A8CmAuw2FPGDmM+OoBMWFkMlgvu9PEdGHMD95AChblnVN8mRJB2MJaDQaJdu230P63kEeHiKihu/7qRs6uhhLQBRFGxi+ezSMEH/eEusyPzk5eVnYZyhGqkAW4xPRVrlcfmFmZubq/v7+JICqoO9xU5UhtwQzGP+QiF5xHGdj8Eul1CIRvQ3gLs04RipD8VA0a8cMxt8losdH/WOXLl36nJlPAdDdV8xdGTIlIIPxQ2Y+obNh6nnebqfTOQngI83YuSpDpgRIjN+X3VnJlrnv+z/Pzs4+S0SBZpfM9wxiBwgegSfKTopEjlkelYsSIDD+SNlJEchRXBmKFyR0GgmMry07KQI5iipDagJ0jZ9FdlIEctSuDKkNoijaIKJRxjciO13q9fohAFcp1UqRY1wZRr40obMEvh/xW5uZn7pTkx/E87wty7JqAH4c1oaIbqfF0X1V1iGio29d/tNflfUdx0l9nK51N9hsNq/XarUOEcUbmSEzP+m67g/yIZul2Wz+VK1Wr05MTDwG4EFAf/KA4Ha4nwQCcLPb7b64urr6S7Yhm2dnZ6dbrVYbpVLpGIDtcW6kFBQUFBQUFPx3+ANTr3SGfzU/zQAAAABJRU5ErkJggg==">
        </span>
    </div>`,
    toolTipModalContent: `<div id="la-tooltip-modal" class="la-tooltip-modal">
        <div class="la-tooltip-modal-content">
            <div class="la-tooltip-modal-header">
                <h2></h2>
                <span class="close">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO2aT2gcVRzHv7/ZaOYgIQtVMDezQVHBW0uLWy+biK2gB2ER9FZIwJZUPHRmAsERkZfJQWwwPQRvBZE9CFaMgrMQlFL/HLxVKpkN6LHiBg+6q8n+vOzgGmd33m/mbfHPfG67+95v3vvtvM9vZt4ABQUFBQUFBf9XSNJYKeVblnX/9PT0haWlpd/HNagsNBqNUhRFb1qW9avjOK5uP+0EKKV8Inq1/zFk5rrneW3xSMeA7/tTtm2/C+BpACCiQDcJWgk4MvmYXSJ6xnGcb2XDNYtSao6IrgF4ePB73SRYGgdImjwAzDHzdaXUvP5wzbK+vn6aiG7gyOQBgJmdIAjW0mKkJgDAvSN+KxPRJ0EQLGvEMYpSarHX6zUBHBvWhpnvSYszkdagUqkst1qtBwCcGdKkxMyXgyB49E7IsdFolPb29t5gZieladjpdF5Oi6flgL5kbgB4JO2g45TjUdmN4BYzn9IZh6QKzBLRlxhxyvUZixyHyS6Bdq/XO7mysvKdTlwdBwAAPM9rAXgOwG8pTY3LcZTsjnDAzHXdyQOCBACA67qfEdFLGk2NyVFHdjFEdNHzvFASX3QlODCoTc1EgIi2sshRILuYTdd1L0iOAQjPgJhKpbIM4GOdtsy82G63t5VSZd34vu9PtVqtDwST1zJ+EpkSUK/XDzudzvMAbmp2mSeir4IgSFvDUErN2bb9BdJNH3OLmeu+7x9otv8LmZZAjKAyxLT7ZTJxna6vr5/u9XrvS+JJjJ9EpjMgRlAZYobKUSK7PmLjJ5HrDIgJguAcM78jOnBfjuVyuSeUXdz/vOM4V2QjTYiTN0CMpDIMEC8F0TUDM1/xPO+88FiJ5FoCg0gqwwDzEE4eQNjtdi8K+wzFWAIyVIYs5DJ+EsaWQEyGyqBLbuMnYewMiMlQGXQwYvwkjCcAEN0zaJHlGl+X0jiCAkAYht/UarX7iOh4zlCbruu+ZmRQCYzlDIipVCrLRLSdI0Tma3xdxpqAfwNjTUAURRvMfDZHiHnbtt8yNqAExuaAIAjOAXjdQKgTCwsLt8Mw/NpArL9h/DoAANbW1p4A8CmAuw2FPGDmM+OoBMWFkMlgvu9PEdGHMD95AChblnVN8mRJB2MJaDQaJdu230P63kEeHiKihu/7qRs6uhhLQBRFGxi+ezSMEH/eEusyPzk5eVnYZyhGqkAW4xPRVrlcfmFmZubq/v7+JICqoO9xU5UhtwQzGP+QiF5xHGdj8Eul1CIRvQ3gLs04RipD8VA0a8cMxt8losdH/WOXLl36nJlPAdDdV8xdGTIlIIPxQ2Y+obNh6nnebqfTOQngI83YuSpDpgRIjN+X3VnJlrnv+z/Pzs4+S0SBZpfM9wxiBwgegSfKTopEjlkelYsSIDD+SNlJEchRXBmKFyR0GgmMry07KQI5iipDagJ0jZ9FdlIEctSuDKkNoijaIKJRxjciO13q9fohAFcp1UqRY1wZRr40obMEvh/xW5uZn7pTkx/E87wty7JqAH4c1oaIbqfF0X1V1iGio29d/tNflfUdx0l9nK51N9hsNq/XarUOEcUbmSEzP+m67g/yIZul2Wz+VK1Wr05MTDwG4EFAf/KA4Ha4nwQCcLPb7b64urr6S7Yhm2dnZ6dbrVYbpVLpGIDtcW6kFBQUFBQUFPx3+ANTr3SGfzU/zQAAAABJRU5ErkJggg==">
                </span>
            </div>
            <div class="la-tooltip-modal-body"></div>
        </div>
    </div>`,
    modalContent: `<div id="lensadvizor-prescription-modal" class="la-prescription-modal la-fade">
        <div class="la-prescription-modal-wrapper" id="la-prescription-modal-wrapper">
            <div class="la-prescription-modal-image">
                <h3 id="la-prescription-modal-title" class="la-prescription-modal-title"></h3>
                <img src="" id="la-product-featured-image" />
            </div>
            <div class="la-prescription-modal-content">
                <div id="la-error-box" class="la-error-box"></div>
                <div class="la-prescription-modal-content-body">
                    <div class="la-lens-loader" id="la-loader-internal" role="status"></div>
                </div>
            </div>
        </div>
        <div class="la-lens-loader" id="la-loader" role="status" style="display:none"></div>
    </div>`,
    footerContent: `<div class="la-prescription-modal-footer">
        <div class="la-footer-row">
            <div class="la-footer-text la-translate">Frame</div>
            <div class="la-frame-price"></div>
        </div>
        <div class="la-footer-dynamic-prices"></div>
        <div class="la-seperator">---</div>
        <div class="la-footer-row la-subtotal">
            <div class="la-footer-text la-translate">Subtotal</div>
            <div class="la-subtotal-price"></div>
        </div>
        <div class="la-subtotal-footer-button" style="display: none">
            <button class="la-prescription-form-btn la-translate" form="la-prescription-form">
                Save and Continue
            </button>
        </div>
    </div>`,
    boxyFooterContent: `<div class="la-prescription-modal-footer la-prescription-boxy-footer">
        <div class="la-boxy-layout-modal-wrapper">
            <div class="la-boxy-layout-information">
                <div>
                    <button class="la-subtotal-modal-trigger">
                        <div class="la-footer-image-container">
                            <img src="" id="la-product-featured-image" />
                        </div>
                        <div class="la-footer-review">
                            <p id="la-footer-frame-title" class="la-prescription-modal-title la-footer-frame-title"></p>
                            <div class="la-subtotal-price-wrapper">
                                <div class="la-subtotal-price"></div>
                                <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.47902 0.0245237C5.32705 0.0245237 5.18143 0.0839586 5.07505 0.189431L0.172913 5.04915C-0.0457612 5.26591 -0.0421356 5.61386 0.180975 5.8263C0.404065 6.03873 0.76221 6.03524 0.980846 5.81847L5.47902 1.35922L9.97719 5.81847C10.1958 6.03526 10.5539 6.0388 10.7771 5.8263C11.0002 5.61384 11.0038 5.26591 10.7851 5.04915L5.88298 0.189431C5.77661 0.0839586 5.631 0.0245237 5.47902 0.0245237Z" fill="#999999"/>
                                </svg>
                            </div>
                        </div>
                    </button>
                </div>
                <div class="la-subtotal-footer-button" style="display: none">
                    <button class="la-prescription-form-btn la-translate" form="la-prescription-form">
                        Save and Continue
                    </button>
                </div>
            </div>
        <div>
    </div>`,
    boxyModalContent: `<div id="la-boxy-footer-modal" class="la-boxy-footer-modal">
        <div class="la-boxy-footer-modal-content">
            <div class="la-boxy-footer-modal-header">
                <span class="close">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAE50lEQVR4nO2aT2gcVRzHv7/ZaOYgIQtVMDezQVHBW0uLWy+biK2gB2ER9FZIwJZUPHRmAsERkZfJQWwwPQRvBZE9CFaMgrMQlFL/HLxVKpkN6LHiBg+6q8n+vOzgGmd33m/mbfHPfG67+95v3vvtvM9vZt4ABQUFBQUFBf9XSNJYKeVblnX/9PT0haWlpd/HNagsNBqNUhRFb1qW9avjOK5uP+0EKKV8Inq1/zFk5rrneW3xSMeA7/tTtm2/C+BpACCiQDcJWgk4MvmYXSJ6xnGcb2XDNYtSao6IrgF4ePB73SRYGgdImjwAzDHzdaXUvP5wzbK+vn6aiG7gyOQBgJmdIAjW0mKkJgDAvSN+KxPRJ0EQLGvEMYpSarHX6zUBHBvWhpnvSYszkdagUqkst1qtBwCcGdKkxMyXgyB49E7IsdFolPb29t5gZieladjpdF5Oi6flgL5kbgB4JO2g45TjUdmN4BYzn9IZh6QKzBLRlxhxyvUZixyHyS6Bdq/XO7mysvKdTlwdBwAAPM9rAXgOwG8pTY3LcZTsjnDAzHXdyQOCBACA67qfEdFLGk2NyVFHdjFEdNHzvFASX3QlODCoTc1EgIi2sshRILuYTdd1L0iOAQjPgJhKpbIM4GOdtsy82G63t5VSZd34vu9PtVqtDwST1zJ+EpkSUK/XDzudzvMAbmp2mSeir4IgSFvDUErN2bb9BdJNH3OLmeu+7x9otv8LmZZAjKAyxLT7ZTJxna6vr5/u9XrvS+JJjJ9EpjMgRlAZYobKUSK7PmLjJ5HrDIgJguAcM78jOnBfjuVyuSeUXdz/vOM4V2QjTYiTN0CMpDIMEC8F0TUDM1/xPO+88FiJ5FoCg0gqwwDzEE4eQNjtdi8K+wzFWAIyVIYs5DJ+EsaWQEyGyqBLbuMnYewMiMlQGXQwYvwkjCcAEN0zaJHlGl+X0jiCAkAYht/UarX7iOh4zlCbruu+ZmRQCYzlDIipVCrLRLSdI0Tma3xdxpqAfwNjTUAURRvMfDZHiHnbtt8yNqAExuaAIAjOAXjdQKgTCwsLt8Mw/NpArL9h/DoAANbW1p4A8CmAuw2FPGDmM+OoBMWFkMlgvu9PEdGHMD95AChblnVN8mRJB2MJaDQaJdu230P63kEeHiKihu/7qRs6uhhLQBRFGxi+ezSMEH/eEusyPzk5eVnYZyhGqkAW4xPRVrlcfmFmZubq/v7+JICqoO9xU5UhtwQzGP+QiF5xHGdj8Eul1CIRvQ3gLs04RipD8VA0a8cMxt8losdH/WOXLl36nJlPAdDdV8xdGTIlIIPxQ2Y+obNh6nnebqfTOQngI83YuSpDpgRIjN+X3VnJlrnv+z/Pzs4+S0SBZpfM9wxiBwgegSfKTopEjlkelYsSIDD+SNlJEchRXBmKFyR0GgmMry07KQI5iipDagJ0jZ9FdlIEctSuDKkNoijaIKJRxjciO13q9fohAFcp1UqRY1wZRr40obMEvh/xW5uZn7pTkx/E87wty7JqAH4c1oaIbqfF0X1V1iGio29d/tNflfUdx0l9nK51N9hsNq/XarUOEcUbmSEzP+m67g/yIZul2Wz+VK1Wr05MTDwG4EFAf/KA4Ha4nwQCcLPb7b64urr6S7Yhm2dnZ6dbrVYbpVLpGIDtcW6kFBQUFBQUFPx3+ANTr3SGfzU/zQAAAABJRU5ErkJggg==">
                </span>
            </div>
            <div class="la-boxy-footer-modal-body">
                <div class="la-boxy-layout-modal">
                    <div class="la-footer-row-wrapper">
                        <h3 class="la-translate">Frame</h3>
                        <div class="la-footer-row">
                            <div class="la-footer-text la-translate la-footer-frame-variant-title"></div>
                            <div class="la-frame-price"></div>
                        </div>
                    </div>
                    <div class="la-footer-row-wrapper la-d-none">
                        <h3 class="la-translate">Prescription</h3>
                        <div class="la-footer-row">
                            <div class="la-footer-text la-translate la-footer-frame-prescription"></div>
                        </div>
                    </div>
                    <div class="la-footer-row-wrapper la-d-none">
                        <h3 class="la-translate">Lens</h3>
                        <div class="la-footer-row la-footer-lens-wrapper">
                            <div class="la-footer-text la-translate la-footer-lens-prescription">Lens</div>
                            <div class="la-footer-lens-price"></div>
                        </div>
                    </div>
                    <div class="la-footer-row-wrapper la-d-none">
                        <h3 class="la-translate">Add-ons</h3>
                        <div class="la-footer-addon-wrapper"></div>
                    </div>
                    <div class="la-divider"></div>
                    <div class="la-footer-row la-subtotal">
                        <div class="la-footer-text la-translate">Subtotal</div>
                        <div class="la-subtotal-price"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    footerBtn: `<div class="la-prescription-modal-footer">
        <div class="la-subtotal-footer-button" style="display: none">
            <button class="la-prescription-form-btn la-translate" form="la-prescription-form">
                Save and Continue
            </button>
        </div>
    </div>`,
    loader: '<div class="la-lens-loader" id="la-loader" role="status"></div>',
    currencyLoaded: false,
    eventsAttached: false,
    triggerEvents: ["keydown", "mousemove", "touchmove", "touchstart", "touchend", "wheel"],
    propertiesToAdd: ['Lens Group', 'Prescription Type', 'Prescription Method', 'Frame', 'Paired With', 'Method', 'Lens'],
    customiseSelectLensButton: function(settings) {
        if (!settings) {
            var selectedOrDefaultVariant = this.variants[this.selectedOrDefaultVariant]
            if (!selectedOrDefaultVariant) {
                selectedOrDefaultVariant = this.variants[Object.keys(this.variants)[0]]
            }
            settings = selectedOrDefaultVariant.settings
        }

        this.selectLensButtons.forEach (button => button.innerHTML = this.Translation.getTranslatedText(settings.buttonText))
        this.addStyle('.la-select-lenses-btn', 'display', 'block')
        this.addStyle('.la-select-lenses-btn', 'background-color', settings.buttonBackgroundColor)
        this.addStyle('.la-select-lenses-btn', 'color', `${settings.buttonColor}`)
        this.addStyle('.la-select-lenses-btn', 'border-radius', `${settings.buttonBorderRadius}px`)
        this.addStyle('.la-select-lenses-btn:hover', 'background-color', settings.buttonBackgroundColor)
        this.addStyle('.la-select-lenses-btn:hover', 'opacity', 0.9)
        this.updateStyles(settings)
    },
    updateQuickBuyButton: function(button, settings) {
        button.innerHTML = settings.buttonText
        button.style.display = 'block'
        button.style.backgroundColor = settings.buttonBackgroundColor
        button.style.color = settings.buttonColor
        button.style.setProperty('background-color:hover', settings.buttonBackgroundColor)
        button.style.setProperty('opacity:hover', 0.9)
        this.updateStyles(settings)
    },
    updateStyles: function(settings) {
        this.addStyle('.la-label-btn:hover', 'border-color', settings.modalButtonBackgroundColor)

        this.addStyle('.la-accordion-head.active, .la-accordion-head:hover', 'border-color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-radio-button-container input[type=radio]:checked+label', 'border-color', settings.modalButtonBackgroundColor)

        this.addStyle('.la-lens-loader::after', 'border-color', settings.modalButtonBackgroundColor)
        this.addStyle('button.la-prescription-form-btn', 'background-color', settings.modalButtonBackgroundColor)
        this.addStyle('button.la-prescription-form-btn', 'color', settings.modalButtonColor)
        document.documentElement.style.setProperty('--lensadvizor-modal-btn-background-color', settings.modalButtonBackgroundColor);
        document.documentElement.style.setProperty('--lensadvizor-modal-btn-color', settings.modalButtonColor);

        this.addStyle('.la-label-btn-wrapper input[type="radio"]:checked + label', 'border-color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-option-inline-list .la-label-btn-wrapper input[type="radio"]:checked + .la-label-btn .la-label-image', 'border-color', settings.modalButtonBackgroundColor);
        this.addStyle('.la-horizontal-boxy-subtotal .la-label-btn', 'border-color', settings.modalButtonBackgroundColor);
        this.addStyle('.la-horizontal-boxy-subtotal .la-fields-wrapper', 'border-color', settings.modalButtonBackgroundColor);

        this.addStyle('.lens-recommendation-badge-wrapper .lens-recommendation-badge', 'background-color', settings.modalButtonBackgroundColor)
        this.addStyle('.lens-recommendation-badge-wrapper .lens-recommendation-badge', 'color', settings.modalButtonColor)

        this.addStyle('.la-progress-bar .la-inner-bar', 'background-color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-steps-list > li:before', 'background-color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-steps-list > li:before', 'color', settings.modalButtonColor)
        this.addStyle('.la-steps-list > li:before', 'border-color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-steps-list > li.is-active:before', 'color', settings.modalButtonBackgroundColor)
        this.addStyle('.la-step-item.is-completed .la-step-item-bar', 'background-color', settings.modalButtonBackgroundColor)
    },
    injectSelectLensButton: function() {
        var selectedOrDefaultVariant = this.variants[this.selectedOrDefaultVariant]
        if (!selectedOrDefaultVariant) {
            selectedOrDefaultVariant = this.variants[Object.keys(this.variants)[0]]
        }

        if (selectedOrDefaultVariant.settings.injectToMatchingButton === "extension" && !this.options.is_vintage_theme) {
            return this.customiseSelectLensButton()
        }

        this.addToCartButtons = []
        this.selectLensButtons.forEach(element => element.remove())

        var selectLensButton = document.createElement("lensadvizor-btn")
        selectLensButton.setAttribute('id', "la-select-lenses-btn")
        selectLensButton.setAttribute("data-lensadvizor-btn", "")
        selectLensButton.setAttribute("data-la-variant-id", this.selectedOrDefaultVariant)
        selectLensButton.setAttribute("data-la-flow-id", this.collectionId)
        selectLensButton.setAttribute("data-la-product-id", this.productId)
        selectLensButton.setAttribute("data-la-product-handle", this.handle)
        selectLensButton.classList.add("la-select-lenses-btn")
        selectLensButton.innerHTML = "Select Lens and Purchase"

        let addToCartSelector = ''
        if (selectedOrDefaultVariant.settings.uniqueCssClass != '' && ["default", "custom_css_class"].includes(selectedOrDefaultVariant.settings.buttonSearchRule)) {
            addToCartSelector += `.${selectedOrDefaultVariant.settings.uniqueCssClass}`
        }
        if (["default", "product-form"].includes(selectedOrDefaultVariant.settings.buttonSearchRule)) {
            addToCartSelector = addToCartSelector == '' ? addToCartSelector : addToCartSelector + ','
            addToCartSelector += 'form[action*="/cart/add"] [type=submit]'
        }

        if (this.customAddToCartSelector) {
            addToCartSelector += `,${this.customAddToCartSelector}`
        }

        this.addToCartButtons = document.querySelectorAll(addToCartSelector)

        if (this.addToCartButtons.length === 0) {
            return false;
        }

        let insertMethod = "before"
        if (selectedOrDefaultVariant.settings.showAddToCartButton) {
            insertMethod = selectedOrDefaultVariant.settings.lensAdvizorButtonPosition || "before"
            this.addToCartButtons.forEach(button => button.style.display = '')
            this.addStyle('form[action*="/cart/add"] [type=submit]', 'display', 'unset')
        } else {
            this.addToCartButtons.forEach(btn => btn.style.display = "none")
        }
        if (selectedOrDefaultVariant.settings.injectToMatchingButton) {
            this.addToCartButtons.forEach(btn => btn.insertAdjacentElement(insertMethod == "before" ? 'beforebegin' : 'afterend', selectLensButton.cloneNode(true)))
        } else {
            this.addToCartButtons[0].insertAdjacentElement(insertMethod == "before" ? 'beforebegin' : 'afterend', selectLensButton)
        }
        this.selectLensButtons = document.querySelectorAll('[data-lensadvizor-btn]')
        this.customiseSelectLensButton()
    },
    addEventListeners: function() {
        if (this.eventsAttached) {
            return false;
        }

        this.productForms.forEach (form => form.addEventListener('change', this.formVariantUpdate))
        document.addEventListener("LensAdvizor:selectLensModal:open", this.handleModalOpen.bind(this))
        document.addEventListener("LensAdvizor:selectLensModal:close", this.handleModalClose.bind(this))
        if (!this.currencyLoaded) {
            this.loadScript("https://cdn.shopify.com/s/files/1/0452/1076/3413/files/lensadvizor-currencies.js?v=1667645159")
            this.currencyLoaded = true
        }
        document.addEventListener("LensAdvizor:toolTip:open", this.handleToolTipOpen.bind(this))
        document.addEventListener("LensAdvizor:toolTip:close", this.handleToolTipClose.bind(this))
        document.addEventListener("LensAdvizor:footerInformation:toggle", this.handleFooterReviewToggle.bind(this))

        // -- Handle Browser Back Button START --
        // If the page is refreshed with the LensAdvizor modal open, handle that (init has finished at this time)
        const body = document.querySelector("body")
        if (!body.classList.contains("la-modal-open") && history.state == "LensAdvizor") {
            history.go(-1)
        }

        // When the modal closes, check state and set history back
        document.addEventListener("LensAdvizor:selectLensModal:close", () => {
            if (history.state == "LensAdvizor" && LensAdvizor.pageType == "product") {
                history.go(-1)
            }
        })

        // Listen for the browser back button, and if pressed, either go back a step in LensAdvizor or close the LensAdvizor modal
        window.addEventListener('popstate', function (event) {
            const body = document.querySelector("body")
            if (body.classList.contains("la-modal-open")) {
                if (LensAdvizor.stepIndex == 1) {
                    document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'))
                } else {
                    LensAdvizor.backBtns[0].click()
                    // Push the state back onto history because LensAdvizor is still open
                    history.pushState("LensAdvizor", document.title, location.href);
                }
            }
        });
        // -- Handle Browser Back Button END --
        document.addEventListener("LensAdvizor:component:WillMount", this.componentWillMount.bind(this))
        document.addEventListener("LensAdvizor:component:DidMount", this.componentDidMount.bind(this))
    },
    updateLensAdvizorVariants: function() {
        this.variants = {}
        if (this.options.assign_by !== "collection") {
            Object.keys(this.options.assigned_variants).forEach(variantId => {
                let variant = this.variantsJSON.find(variant => variant.id == variantId)
                if (variant && variant.available) {
                    let obj = this.options.assigned_variants[variantId]
                    this.variants[variantId] = {
                        price: variant.price / 100.00,
                        compare_at_price: variant.compare_at_price / 100.00,
                        collection_id: obj.collection_id,
                        settings: obj.settings,
                        json: variant,
                        image: variant.featured_image ? variant.featured_image.src : this.productDefaultImage
                    }
                }
            })
            return this.variants;
        }
        this.variantsJSON.forEach(variant => {
            if (variant.available) {
                this.variants[variant.id] = {
                    price: variant.price / 100.00,
                    compare_at_price: variant.compare_at_price / 100.00,
                    collection_id: this.collectionId,
                    settings: this.options.collection_settings,
                    json: variant,
                    image: variant.featured_image ? variant.featured_image.src : this.productDefaultImage
                }
            }
        })
        return this.variants
    },
    resetUserResponse: function() {
        this.response = {
            prescriptionType: null,
            prescription: null,
            selfie: null,
            lens: '',
            lensVariant: null,
            method: "",
            addOns: {},
            manually: ''
        }
        this.lenses = []
        this.prices.lens = null
        this.prices.addons = null
        this.customAddOns = []
        this.response.prescription = null
        this.response.selfie = null
        this.response.selectedPrescriptionType = null
        this.response.orderNote = ""
        this.navigationSteps = undefined
        this.setDefaultManualResponse()
    },
    setDefaultManualResponse: function() {
        if (!this.options.prescriptionConfig || this.options.prescriptionConfig.prescriptionEntryFormLocation !== 'before-review') {
            this.lenses = []
            this.prices.lens = null
            this.prices.addons = null
            this.response.prescription = null
            this.response.selfie = null
            this.response.orderNote = ""
        }
        this.response.manually = {
            sph: '',
            prismRequired: false,
            od_right: {sph: '0.00', cyl: '0.00', axis: '', add: null},
            os_left: {sph: '0.00', cyl: '0.00', axis: '', add: null},
            pd: { type: 'Single PD', value: null, right: null, left: null, lunaPdCount: 0 },
            segment_height: null, prism_value: false,
            prism_fields: {
                od_right: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null},
                os_left: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null},
            },
            provider: {
                customerName: "", dateOfBirth: "",
                doctorName: "", doctorAddress: "",
                doctorPhoneNo: ""
            },
            diopters: {
                od_right: '',
                os_left: '',
            }
        }
    },
    componentWillMount: function(event) {
        let customAddOnPriceBox = document.querySelector('#la-customaddon-price-box')
        if (customAddOnPriceBox) {
            customAddOnPriceBox.remove()
        }
        this.tooltips = []
        this.prices.customAddOnPrice = null
    },
    componentDidMount: function(event) {
        const toolTipElements = document.querySelectorAll("[data-la-tooltip]")
        if (toolTipElements.length) {
            toolTipElements.forEach((toolTipElement) => this.addTooltipEvent(toolTipElement))
        }
        this.updateFooterPrices()
    },
    addTooltipEvent: function(toolTipElement) {
        toolTipElement.addEventListener("click", function (e) {
            document.dispatchEvent(new CustomEvent('LensAdvizor:toolTip:open', {detail: { toolTipElement }}));
            e.preventDefault()
            e.stopPropagation()
            return false
        })
    },
    getPrismFields: function() {
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];
        if (selectedVariant.settings.layout.type == "horizontal-boxy") {
            return this.getBoxyPrismLayout(selectedVariant)
        }

        return `<div class="la-prescription-fields-wrapper">
            <h6 class="la-h6">
                ${this.Translation.getTranslatedText("OD (Right Eye)")}
            </h6>
            <div class="la-form-flex la-column-gap-1-5">
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Horizontal")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-horizontal" data-field="horizontal" data-eval="prism_fields.od_right" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        ${this.options.fieldValues.prismValues.map(value => `<option
                            value="${value.toFixed(2)}"
                            ${this.response.manually.prism_fields.od_right.horizontal == value.toFixed(2) ? "selected" : ""}
                        >${value.toFixed(2)}</option>`).join(",")}
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Base Direction")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_horizontal" data-field="base_direction_horizontal" data-eval="prism_fields.od_right" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        <option value="IN" ${this.response.manually.prism_fields.od_right.base_direction_horizontal == "IN" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("IN")}
                        </option>
                        <option value="OUT" ${this.response.manually.prism_fields.od_right.base_direction_horizontal == "OUT" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("OUT")}
                        </option>
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Vertical")}</label>
                    <select class="la-form-select la-prism-select" name="a-prism-odright-vertical" data-field="vertical" data-eval="prism_fields.od_right" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        ${this.options.fieldValues.prismValues.map(value => `<option
                            value="${value.toFixed(2)}"
                            ${this.response.manually.prism_fields.od_right.vertical == value.toFixed(2) ? "selected" : ""}
                        >${value.toFixed(2)}</option>`).join(",")}
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Base Direction")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_vertical" data-field="base_direction_vertical" data-eval="prism_fields.od_right">
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        <option value="UP" ${this.response.manually.prism_fields.od_right.base_direction_vertical == "UP" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("UP")}
                        </option>
                        <option value="DOWN" ${this.response.manually.prism_fields.od_right.base_direction_vertical == "DOWN" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("DOWN")}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="la-prescription-fields-wrapper">
            <h6 class="la-h6">${this.Translation.getTranslatedText("OS (Left Eye)")}</h6>
            <div class="la-form-flex la-column-gap-1-5">
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Horizontal")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-horizontal" data-field="horizontal" data-eval="prism_fields.os_left" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        ${this.options.fieldValues.prismValues.map(value => `<option
                            value="${value.toFixed(2)}"
                            ${this.response.manually.prism_fields.os_left.horizontal == value.toFixed(2) ? "selected" : ""}
                        >${value.toFixed(2)}</option>`).join(",")}
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Base Direction")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_horizontal" data-field="base_direction_horizontal" data-eval="prism_fields.os_left" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        <option value="IN" ${this.response.manually.prism_fields.os_left.base_direction_horizontal == "IN" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("IN")}
                        </option>
                        <option value="OUT" ${this.response.manually.prism_fields.os_left.base_direction_horizontal == "OUT" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("OUT")}
                        </option>
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Vertical")}</label>
                    <select class="la-form-select la-prism-select" name="a-prism-odright-vertical" data-field="vertical" data-eval="prism_fields.os_left" required>
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        ${this.options.fieldValues.prismValues.map(value => `<option
                            value="${value.toFixed(2)}"
                            ${this.response.manually.prism_fields.os_left.vertical == value.toFixed(2) ? "selected" : ""}
                        >${value.toFixed(2)}</option>`).join(",")}
                    </select>
                </div>
                <div class="la-form-item">
                    <label class="la-form-helper-label">${this.Translation.getTranslatedText("Base Direction")}</label>
                    <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_vertical" data-field="base_direction_vertical" data-eval="prism_fields.os_left">
                        <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                        <option value="UP" ${this.response.manually.prism_fields.os_left.base_direction_vertical == "UP" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("UP")}
                        </option>
                        <option value="DOWN" ${this.response.manually.prism_fields.os_left.base_direction_vertical == "DOWN" ? "selected" : ""}>
                            ${this.Translation.getTranslatedText("DOWN")}
                        </option>
                    </select>
                </div>
            </div>
        </div>`
    },
    getBoxyPrismLayout: function(selectedVariant) {
        return `<table>
            <thead>
                <tr class="la-prescription-fields-wrapper">
                    <td></td>
                    <td><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('Horizontal')}</h6</td>
                    <td><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('Base Direction')}</h6</td>
                    <td><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('Vertical')}</h6</td>
                    <td><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('Base Direction')}</h6</td>
                </tr>
            </thead>
            <tbody>
                <tr class="la-prescription-fields-wrapper">
                    <td class="la-td-text-left"><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('OD (Right)')}</h6></td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-horizontal" data-field="horizontal" data-eval="prism_fields.od_right" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            ${this.options.fieldValues.prismValues.map(value => `<option
                                value="${value.toFixed(2)}"
                                ${this.response.manually.prism_fields.od_right.horizontal == value.toFixed(2) ? "selected" : ""}
                            >${value.toFixed(2)}</option>`).join(",")}
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_horizontal" data-field="base_direction_horizontal" data-eval="prism_fields.od_right" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            <option value="IN" ${this.response.manually.prism_fields.od_right.base_direction_horizontal == "IN" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("IN")}
                            </option>
                            <option value="OUT" ${this.response.manually.prism_fields.od_right.base_direction_horizontal == "OUT" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("OUT")}
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="a-prism-odright-vertical" data-field="vertical" data-eval="prism_fields.od_right" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            ${this.options.fieldValues.prismValues.map(value => `<option
                                value="${value.toFixed(2)}"
                                ${this.response.manually.prism_fields.od_right.vertical == value.toFixed(2) ? "selected" : ""}
                            >${value.toFixed(2)}</option>`).join(",")}
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_vertical" data-field="base_direction_vertical" data-eval="prism_fields.od_right">
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            <option value="UP" ${this.response.manually.prism_fields.od_right.base_direction_vertical == "UP" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("UP")}
                            </option>
                            <option value="DOWN" ${this.response.manually.prism_fields.od_right.base_direction_vertical == "DOWN" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("DOWN")}
                            </option>
                        </select>
                    </td>
                </tr>
                <tr class="la-prescription-fields-wrapper">
                    <td class="la-td-text-left"><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('OS (Left)')}</h6></td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-horizontal" data-field="horizontal" data-eval="prism_fields.os_left" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            ${this.options.fieldValues.prismValues.map(value => `<option
                                value="${value.toFixed(2)}"
                                ${this.response.manually.prism_fields.os_left.horizontal == value.toFixed(2) ? "selected" : ""}
                            >${value.toFixed(2)}</option>`).join(",")}
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_horizontal" data-field="base_direction_horizontal" data-eval="prism_fields.os_left" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            <option value="IN" ${this.response.manually.prism_fields.os_left.base_direction_horizontal == "IN" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("IN")}
                            </option>
                            <option value="OUT" ${this.response.manually.prism_fields.os_left.base_direction_horizontal == "OUT" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("OUT")}
                            </option>
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="a-prism-odright-vertical" data-field="vertical" data-eval="prism_fields.os_left" required>
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            ${this.options.fieldValues.prismValues.map(value => `<option
                                value="${value.toFixed(2)}"
                                ${this.response.manually.prism_fields.os_left.vertical == value.toFixed(2) ? "selected" : ""}
                            >${value.toFixed(2)}</option>`).join(",")}
                        </select>
                    </td>
                    <td>
                        <select class="la-form-select la-prism-select" name="la-prism-odright-base_direction_vertical" data-field="base_direction_vertical" data-eval="prism_fields.os_left">
                            <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                            <option value="UP" ${this.response.manually.prism_fields.os_left.base_direction_vertical == "UP" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("UP")}
                            </option>
                            <option value="DOWN" ${this.response.manually.prism_fields.os_left.base_direction_vertical == "DOWN" ? "selected" : ""}>
                                ${this.Translation.getTranslatedText("DOWN")}
                            </option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>`
    },
    formatCurrency: function(amount) {
        return this.Currency.formatMoney(parseFloat(amount) * 100, this.Currency.moneyFormats[Shopify.currency.active].money_format)
    },
    convertCurrency: function(productId, variantId, price) {
        const productPresentmentPrices = this.presentmentPrices[productId]
        if (productPresentmentPrices) {

          console.log('productPresentmentPrices', productPresentmentPrices);
          
          if (productPresentmentPrices.variants) {
            const variantPresentmentPrice = productPresentmentPrices.variants.find(variant => variant.id.toString() === variantId.toString())
          
            if (variantPresentmentPrice) {
            const amount = variantPresentmentPrice.presentment_prices[Shopify.currency.active]
                if (amount) {
                    return parseFloat(variantPresentmentPrice.presentment_prices[Shopify.currency.active])
                }
            }
          }

        }
        return this.Currency.convert(parseFloat(price), this.options.default_currency, Shopify.currency.active);
    },
    updateCustomJSandCss: function() {
        if (this.options.settings.custom_javascript && this.options.settings.custom_javascript !== '') {
            let script = document.createElement('script');
            script.append(this.options.settings.custom_javascript)
            document.head.append(script);
        }

        const custom_translationJSON = {...this.options.settings.custom_translationJSON}
        const languages = Object.keys(custom_translationJSON)

        languages.forEach((language) => {
            const userKeys = {...custom_translationJSON[language].user};
            const defaultKeys = {...custom_translationJSON[language].default, ...this.Translation.translationJSON[language.toLowerCase()] || {}};
            this.Translation.translationJSON[language.toLowerCase()] = {...defaultKeys, ...userKeys };
        });

        if (this.Translation.translationJSON.en) {
            this.Translation.translationJSON.default_text = {...this.Translation.translationJSON.default_text, ...this.Translation.translationJSON.en}
        }

        if (this.options.settings.custom_css && this.options.settings.custom_css !== '') {
            let style = document.head.querySelector('#la-custom-rules-injector');
            if (style !== null) {
                return;
            }
            style = `<style type="text/css" id="la-custom-rules-injector">${this.options.settings.custom_css}</style>`
            const selectorElement = document.querySelector("#la-custom-css-injector")
            selectorElement.insertAdjacentHTML("afterend", style)
        }
        this.options.showBranding = this.options.billing_plan.code == "trial"
    },
    initdata: function(data) {
        this.options = data;
        this.settings = data.settings;
    },
    init: function() {
        if (["product", "cart"].includes(this.pageType)) {
            if (this.product && this.product.tags.includes('remove-rx')) {
                return this.handleSettingsException.call(this)
            }
            this.initBuy()
        } else {
            this.initQuickBuy()
        }
    },
    initBuy: function() {
        document.dispatchEvent(new CustomEvent('LensAdvizor:init:start'));
        // Handle this case
        if (!this.productAvailable && this.pageType !== "cart") {
            return this.handleSettingsException.call(this)
        }

        const settingsUrl = this.addQueryParamsToURL(this.API_URL + "/store/settings", {
            store: Shopify.shop,
            product_id: this.productId,
            collection_id: this.collectionId,
            api_version: 2
        })
        fetch(settingsUrl)
        .then(res => res.json())
        .then(response => {
            this.products[this.productId] = response
            this.initdata(response)

            this.enableLunaPdTool = this.options.is_luna_domains_whitelisted && this.options.billing_plan.enable_luna_pd_tool
            if (this.enableLunaPdTool && !this.options.billing_plan.custom_settings.skipLunaInit) {
                this.Luna.importScript()
            }

            if (this.pageType === "cart") {
                return new this.CartHandler(this).performOperation()
            }

            this.selectLensButtons = document.querySelectorAll('[data-lensadvizor-btn]')
            this.productForms = document.querySelectorAll('form[action*="/cart/add"]')
            this.addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] [type=submit]')

            if (this.product.vendor == 'LensAdvizor') {
                this.preventAddingLensesToCart()
            }

            this.updateCustomJSandCss()

            if (this.options.assign_by === null) {
                return this.handleSettingsException.call(this)
            } else if (this.options.assigned_variants || this.options.assign_by) {
                this.updateLensAdvizorVariants()
            }
            // Hide any quick buy btn if it's visible
            document.querySelectorAll("lensadvizor-quick-buy").forEach((btn) => btn.style.display = "none")

            this.injectSelectLensButton();
            this.handleButtonDisplay();
            this.updateFontFamily();
            this.addEventListeners()

            document.dispatchEvent(new CustomEvent('LensAdvizor:init:complete'));
            if (this.enableLunaPdTool && !this.options.billing_plan.custom_settings.skipLunaInit) {
                this.Luna.init(this)
            }
        })
        .catch(this.handleSettingsException.bind(this))
    },
    updateFontFamily: function() {
        this.addStyle('.lensadvisor-widget', 'font-family', this.settings.fontFamily ? this.settings.fontFamily : 'Arial')
        this.addStyle('.lensadvisor-widget *', 'font-family', this.settings.fontFamily ? this.settings.fontFamily : 'Arial')
        this.addStyle('.la-prescription-modal', 'font-family', this.settings.fontFamily ? this.settings.fontFamily : 'Arial')
        this.addStyle('.la-prescription-modal *', 'font-family', this.settings.fontFamily ? this.settings.fontFamily : 'Arial')
    },
    preventAddingLensesToCart: function() {
        if (this.settings.preventAddLensToCart) {
            this.productForms.forEach(form => {
                Array.from(form.getElementsByTagName("button")).forEach(btn => btn.style.display = "none")
            })
            this.addToCartButtons.forEach(button => {
                button.innerHTML =  this.Translation.getTranslatedText('This product is not available for purchase individually')
                button.removeAttribute("name")
                button.setAttribute("disabled", "disabled")
            })
        }
    },
    handleSettingsException: function(e) {
        this.selectLensButtons = document.querySelectorAll('[data-lensadvizor-btn]')
        this.addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] [type=submit]')
        this.selectLensButtons.forEach(btn => btn.remove())
        this.addToCartButtons.forEach(button => button.style.display = '')
        console.warn("Exception", e)
        var defaultCSSInjector = document.querySelector("#la-default-css-injector")
        if (defaultCSSInjector) {
            defaultCSSInjector.remove()
        }
        document.dispatchEvent(new CustomEvent('LensAdvizor:init:error'));
        document.dispatchEvent(new CustomEvent('LensAdvizor:init:complete'));
        return false;
    },
    formVariantUpdate: function(e) {
        setTimeout(function(){
            const variantInputField = this.querySelector('[name="id"]')
            let updatedVariantId = LensAdvizor.getUrlParameter("variant")
            if (variantInputField && variantInputField.value) {
                updatedVariantId = parseInt(variantInputField.value)
            }

            var selectedVariant = LensAdvizor.selectedOrDefaultVariant

            if (LensAdvizor.pageType == "product") {
                LensAdvizor.selectLensButtons.forEach((button) => {
                    selectedVariant = button.getAttribute('data-la-variant-id')
                })
            }

            if (selectedVariant == updatedVariantId) {
                return false
            }

            LensAdvizor.selectedOrDefaultVariant = updatedVariantId
            LensAdvizor.selectLensButtons.forEach((button) => {
                button.setAttribute("data-la-variant-id", updatedVariantId)
            })

            LensAdvizor.prescriptionTypes = []
            LensAdvizor.handleButtonDisplay()
            if (LensAdvizor.variants[updatedVariantId]) {
                LensAdvizor.customiseSelectLensButton(LensAdvizor.variants[updatedVariantId].settings)
            }
            document.dispatchEvent(new CustomEvent('LensAdvizor:variant:change'));
        }.bind(this), 150)
    },
    handleButtonDisplay: function() {
        let selectedVariant = this.variants[this.selectedOrDefaultVariant]

        if (!this.addToCartButtons.length) {
            this.addStyle('form[action*="/cart/add"] [type=submit]', 'display', 'initial !important')
        }

        if (selectedVariant) {
            if (selectedVariant.settings.showAddToCartButton) {
                this.addToCartButtons.forEach(button => {
                    button.style.display = 'unset'
                    button.classList.remove("la-visiblity-hidden")
                })
            } else {
                this.addToCartButtons.forEach(button => {
                    button.style.display = 'none'
                    button.classList.add("la-visiblity-hidden")
                })
            }
            this.selectLensButtons.forEach(button => button.style.display = 'block')
            this.collectionId = selectedVariant.collection_id
            this.prices.frame = selectedVariant.price
        } else {
            this.selectLensButtons.forEach(button => button.style.display = 'none')
            this.addToCartButtons.forEach(button => {
                button.style.display = 'unset'
                button.classList.remove("la-visiblity-hidden")
            })
            this.collectionId = null
        }
    },
    handleToolTipOpen: function(e) {
        const tooltipModal = document.querySelector("#la-tooltip-modal")
        const titleContainer = document.querySelector('.la-tooltip-modal-header h2')
        const modalContainer = document.querySelector('.la-tooltip-modal-body')

        const toolTip = this.tooltips.find(tooltip => tooltip.id == e.detail.toolTipElement.dataset.laTooltip)
        if (toolTip) {
            titleContainer.innerHTML = toolTip.title
            modalContainer.innerHTML = toolTip.content
            tooltipModal.style.display = "flex";
        }
    },
    handleToolTipClose: function(e) {
        const tooltipModal = document.querySelector("#la-tooltip-modal")
        const titleContainer = document.querySelector('.la-tooltip-modal-header h2')
        const modalContainer = document.querySelector('.la-tooltip-modal-body')
        titleContainer.innerHTML = ""
        modalContainer.innerHTML = ""
        tooltipModal.style.display = "none";
    },
    clearLocalStorage: () => localStorage.clear("lensAdvizor"),
    setLocalStorage: function(key, value) {
        const local_storage = this.getLocalStorage()
        local_storage[key] = value
        this.localStorage = local_storage
        localStorage.setItem("lensAdvizor", JSON.stringify(local_storage))
    },
    getLocalStorage: () => localStorage.getItem("lensAdvizor") ? JSON.parse(localStorage.getItem("lensAdvizor")) : {},
    handleModalOpen: function() {
        const body = document.querySelector("body")
        const html = document.querySelector("html")
        if (document.querySelector("#lensadvizor-prescription-modal")) {
            return false;
        }

        if (this.enableLunaPdTool && this.options.billing_plan.custom_settings.skipLunaInit) {
            this.Luna.importScript()
            this.Luna.init(this)
        }

        const selectedVariant = this.variants[this.selectedOrDefaultVariant]
        this.headerContainer = undefined
        this.reSizeEventAttached = false
        this.contactLensFormData = []
        this.singleContactLens = false
        this.localStorage = this.getLocalStorage()

        this.options.variantConfig = selectedVariant.settings
        this.options.settings.layout = selectedVariant.settings.layoutClass;
        this.options.settings.contentSize = ((selectedVariant.settings.layout.type === 'vertical' || selectedVariant.settings.layout.type === 'horizontal-boxy') ? 'h-': 'w-') + selectedVariant.settings.contentSize
        this.isPictureMatrixEnabled = LensAdvizor.options.billing_plan.is_picture_matrix_enabled
        this.progresBar = document.querySelector(".la-progress-bar");

        body.insertAdjacentHTML("afterbegin", this.modalContent)
        body.insertAdjacentHTML("afterbegin", this.toolTipModalContent)

        if (selectedVariant.settings.layout.type === 'horizontal-boxy') {
            body.insertAdjacentHTML("afterbegin", this.boxyModalContent)
        }

        body.classList.add("la-modal-open")
        html.classList.add("la-modal-open")

        const lensAdvizorPrescriptionModal = document.querySelector("#lensadvizor-prescription-modal")
        const tooltipModal = document.querySelector("#la-tooltip-modal")
        const tooltipInformationModal = document.querySelector('#la-boxy-footer-modal')
        const lensAdvizorPrescriptionModalWrapper = document.querySelector("#la-prescription-modal-wrapper")
        lensAdvizorPrescriptionModalWrapper.classList.add("la-" + this.options.settings.layout, "la-" + this.options.settings.contentSize)
        lensAdvizorPrescriptionModal.classList.add("la-show")

        if (this.options.settings.layout.includes("subtotal")) {
            let selectorClass = ".la-prescription-modal-content"
            if (this.options.settings.layout.includes("left")) {
                selectorClass = ".la-prescription-modal-image"
            }
            const selectorElement = document.querySelector(selectorClass)

            if (selectedVariant.settings.layout.type === 'horizontal-boxy') {
                selectorElement.insertAdjacentHTML("beforeend", this.boxyFooterContent)
                document.querySelectorAll(".la-footer-frame-title").forEach((element) => {
                   element.innerHTML = this.productTitle 
                })
            } else {
                selectorElement.insertAdjacentHTML("beforeend", this.footerContent)
            }
        } else {
            const selectorElement = document.querySelector(".la-prescription-modal-content")
            selectorElement.insertAdjacentHTML("beforeend", this.footerBtn)
        }

        if (window.innerWidth > 1024 && this.options.settings.layout.includes("left")) {
            selectorClass = ".la-prescription-modal-image"
        }

        if (this.options.settings.layout.includes("drawer") || window.innerWidth < 1024) {
            setTimeout(() => {
                lensAdvizorPrescriptionModalWrapper.classList.add("la-slide")
                setTimeout(function() {
                    lensAdvizorPrescriptionModalWrapper.style.transition = 'unset';
                    lensAdvizorPrescriptionModalWrapper.classList.add("la-slide-r")
                }, 500)
            })
        }

        document.querySelector(".la-modal-open").addEventListener("click", function (event) {
            if (event.target == lensAdvizorPrescriptionModal) {
                document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'))
            } else if (event.target == tooltipModal) {
                document.dispatchEvent(new CustomEvent('LensAdvizor:toolTip:close'))
            } else if (event.target == tooltipInformationModal) {
                document.dispatchEvent(new CustomEvent('LensAdvizor:footerInformation:toggle'))
            }
        })

        document.querySelector("#la-tooltip-modal .close").addEventListener("click", function(e) {
            document.dispatchEvent(new CustomEvent('LensAdvizor:toolTip:close'))
        })

        this.resetUserResponse()

        const productFeaturedImageSelector = selectedVariant.settings.layout.type === 'horizontal-boxy' ? '.la-footer-image-container ' : "#la-prescription-modal-wrapper "
        this.productFeaturedImage = document.querySelector(productFeaturedImageSelector + '#la-product-featured-image')

        if (this.productFeaturedImage) {
            this.productFeaturedImage.src = selectedVariant.image
        }

        this.errorBoxContainer = document.querySelector("#la-error-box")
        this.errorBoxContainer.innerHTML = "<div class='la-error'></div>"
        this.contentBox = document.querySelector(".la-prescription-modal-content-body")
        this.loader = document.querySelector("#la-loader")
        this.variantTitleContainer = document.querySelector("#la-prescription-modal-title")
        this.errorBox = this.errorBoxContainer.firstElementChild

        this.variantTitleContainer.innerHTML = selectedVariant.json.name

        document.addEventListener("LensAdvizor:action:exception", function(event) {
            this.loader.style.display = "none"
            this.errorBox.innerHTML = this.Translation.getTranslatedText(event.detail.message)
            this.errorBoxContainer.classList.add("la-active")
            setTimeout(function() {
                this.errorBoxContainer.classList.remove("la-active")
            }.bind(this), 6000)
        }.bind(this))

        this.footerElement = document.querySelector(".la-prescription-modal-footer")
        this.formBtn = document.querySelector(".la-subtotal-footer-button")
        this.footerDynamicPriceBox = document.querySelector('.la-footer-dynamic-prices')
        this.subTotalPriceBoxes = document.querySelectorAll('.la-subtotal-price')
        this.subTotalPriceBox = document.querySelector('.la-subtotal-price')
        this.framePriceBox = document.querySelector('.la-frame-price')

        this.boxyFooterFramePrescriptionTitle = document.querySelector('.la-footer-frame-title')
        this.boxyFooterFramePrescriptionType = document.querySelector('.la-footer-frame-prescription')
        this.boxyFooterFramePrescriptionLensTitle = document.querySelector('.la-footer-lens-prescription')
        this.boxyFooterFrameLensPrice = document.querySelector('.la-footer-lens-price')
        this.boxyFooterFrameAddonsWrapper = document.querySelector('.la-footer-addon-wrapper');

        if (!this.reSizeEventAttached) {
            this.reSizeEventAttached = true
            window.addEventListener('resize', this.handleWindowResize.bind(this), true);
        }

        this.handleWindowResize()
        this.renderPrescriptionTypes()

        if (selectedVariant.settings.layout.type === 'horizontal-boxy') {
            this.progresBar.innerHTML = `<div class="la-step-bar"></div>`
            this.progresBar.classList.add("la-transparent-bg");
        }

        if (this.subTotalModalOpener) {
            document.querySelector(".la-boxy-footer-modal-header .close").addEventListener("click", function() {
                document.dispatchEvent(new CustomEvent('LensAdvizor:footerInformation:toggle'))
            })
        }

        this.Translation.apply()
        history.pushState("LensAdvizor", document.title, location.href)
    },
    handleFooterReviewToggle: function() {
        const svg = this.subTotalModalOpener.querySelector("svg")
        const layoutModal = document.querySelector(".la-boxy-layout-modal")
        const tooltipInformationModal = document.querySelector('#la-boxy-footer-modal')

        if (this.subTotalModalOpener.getAttribute("area-open")) {
            svg.style.transform = ""
            this.subTotalModalOpener.removeAttribute("area-open")     
            layoutModal.classList.remove("active")
            tooltipInformationModal.style.display = "none";
        } else {
            this.subTotalModalOpener.setAttribute("area-open", true)
            svg.style.transform = "rotate(180deg)"
            layoutModal.classList.add("active")
            tooltipInformationModal.style.display = "flex";
        }
    },
    updateHeaderPosition: function() {
        const { layout } = this.options.settings;

        selector = '.la-prescription-modal-image'
        if (window.innerWidth > 1024) {
            selector = "#la-error-box"
        }

        if (layout.includes("vertical") || layout.includes("drawer") || layout.includes("modal")) {
            selector = '.la-prescription-modal-image'
        }

        if (this.headerContainer) {
            headerContainer = this.headerContainer.cloneNode(true)
            this.headerContent = headerContainer.outerHTML

            if (document.querySelector("#la-prescription-modal-header")) {
                document.querySelector("#la-prescription-modal-header").remove()
            }
        }

        /* vDEV */
        const selectorElement = document.querySelector(selector);

        if (selectorElement) {
            selectorElement.insertAdjacentHTML("beforeBegin", this.headerContent)
        }
        /* /vDEV */

        // document.querySelector(selector).insertAdjacentHTML("beforeBegin", this.headerContent)

        this.closeBtns = document.querySelectorAll(".la-prescription-modal-close")
        this.headerContainer = document.querySelector("#la-prescription-modal-header")
        this.backBtns = document.querySelectorAll(".la-steeper-back")
        this.progresBar = document.querySelector(".la-progress-bar")

        if (this.options.variantConfig.showProgressBar) {
            this.progresBar.style.display = ""
        }

        this.backBtns.forEach(btn => btn.addEventListener("click", this.handleBackBtnPress.bind(this)))

        this.closeBtns.forEach(closeBtn => closeBtn.addEventListener("click", function (e) {
            document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'))
        }))
    },
    handleBackBtnPress: function() {
        this.formBtn.firstElementChild.removeAttribute("disabled");
        this.stepIndex -= 1
        this.navigationSteps.splice(this.stepIndex, 1);

        if (this.navigationSteps.length > 0 && this.navigationSteps[this.stepIndex - 1] === "bound renderAddOns") {
            this.response.addOnsStep -= 1
            if (this.response.addOnsStep >= 0) {
                currentStep = this.getCurrentAddOnStep()
                this.navigationSteps.splice(this.stepIndex, 1);

                while (currentStep.isSkipable && this.response.addOnsStep > 0) {
                    this.response.addOnsStep -= 1
                    currentStep = this.getCurrentAddOnStep()
                }
            }
        } else if (this.navigationSteps.length > 0 && this.navigationSteps[this.stepIndex - 1] === "bound renderOptions" && this.options.prescriptionConfig.lensOptionDisplayType) {
            this.response.optionLevel -= 1
        }
        return this.navigation[this.stepIndex]()
    },
    handleWindowResize: function(event) {
        this.updateHeaderPosition()

        if (!this.options.settings.layout.includes("subtotal")) {
            return false
        }

        footerElement = this.footerElement.cloneNode(true)
        this.footerContent = footerElement.outerHTML
        document.querySelectorAll(".la-prescription-modal-footer").forEach(element => element.remove())

        let selectorClass = ".la-prescription-modal-content"
        if (window.innerWidth > 1024 && this.options.settings.layout.includes("left")) {
            selectorClass = ".la-prescription-modal-image"
        }

        const selectorElement = document.querySelector(selectorClass)
        selectorElement.insertAdjacentHTML("beforeend", this.footerContent)
        this.footerElement = document.querySelector(".la-prescription-modal-footer")
        this.formBtn = document.querySelector(".la-subtotal-footer-button")
        this.footerDynamicPriceBox = document.querySelector('.la-footer-dynamic-prices')
        this.subTotalPriceBoxes = document.querySelectorAll('.la-subtotal-price')
        this.subTotalPriceBox = document.querySelector('.la-subtotal-price')
        this.framePriceBox = document.querySelector('.la-frame-price')

        this.subTotalModalOpener = document.querySelector('.la-subtotal-modal-trigger')
        if (this.subTotalModalOpener) {
            this.subTotalModalOpener.addEventListener('click', function () {
                document.dispatchEvent(new CustomEvent('LensAdvizor:footerInformation:toggle'))
            })
        }
    },
    handleModalClose: function() {
        const lensAdvizorPrescriptionModal = document.querySelector("#lensadvizor-prescription-modal")
        const toolTipModal = document.querySelector("#la-tooltip-modal")
        const tooltipInformationModal = document.querySelector('#la-boxy-footer-modal')

        const body = document.querySelector("body")
        const html = document.querySelector("html")
        body.classList.remove("la-modal-open")
        html.classList.remove("la-modal-open")

        if (lensAdvizorPrescriptionModal) {
            lensAdvizorPrescriptionModal.classList.remove("la-show")

            setTimeout(function () {
                lensAdvizorPrescriptionModal.remove()
                toolTipModal.remove()

                if (tooltipInformationModal) {
                    tooltipInformationModal.remove()
                }
            }, 500)
        }
    },
    updateProgressBar: function() {
        const linearBars = document.querySelectorAll(".la-progress-bar .la-inner-bar");
        const stepBars = document.querySelectorAll(".la-progress-bar .la-step-bar");
        const navigationStepLastStep = this.navigationSteps[this.navigationSteps.length - 1]

        let maxStep = this.stepIndex + 1
        if (navigationStepLastStep.includes("renderReview")) {
            maxStep = this.navigationSteps.length
        } else if (maxStep < 5) {
            maxStep = 5
        }

        let stepWidth = (100 / maxStep) * this.stepIndex

        linearBars.forEach(progresBar => {
            let currentWidth = parseFloat(progresBar.style.width)
            let intervalId = stepWidth < currentWidth ? setInterval(decreaseWidth, 10) : setInterval(increaseWidth, 10)

            function increaseWidth() {
                if (currentWidth > stepWidth) {
                    return clearInterval(intervalId)
                }
                currentWidth++
                progresBar.style.width = currentWidth + "%"
            }

            function decreaseWidth() {
                if (currentWidth < stepWidth) {
                    return clearInterval(intervalId)
                }
                currentWidth--
                progresBar.style.width = currentWidth + "%"
            }
        })

        stepBars.forEach(stepBar => {
            let i = 0;
            let allStepItems;
            let stepItem = `<li class="la-step-item">
                <div class="la-step-item-bar">
                    <div class="la-step-bar-inner"></div>
                </div>
            </li>`;

            while (i < maxStep) {
                if (i == 0) {
                    allStepItems = stepItem;
                } else {
                    allStepItems += stepItem;
                }
                i++;
            }

            stepBar.innerHTML = `<ul class="la-steps-list">
                ${allStepItems}
            </ul>`
        })

        let stepItems = document.querySelectorAll(".la-step-item");

        stepItems.forEach((step, index) => {
            if (index == this.stepIndex - 1) {
                step.classList.add("is-active");
            }
        })

        let completedStepItems = Array.from(stepItems);
        completedStepItems = completedStepItems.slice(0, completedStepItems.findIndex(el => el.classList.contains("is-active")))
        completedStepItems.forEach(item => item.classList.add("is-completed"))

        if (this.stepIndex > 1) {
            this.backBtns.forEach(btn => btn.style.visibility = "" )
        } else {
            this.backBtns.forEach(btn => btn.style.visibility = "hidden" )
        }
        this.loader.style.display = "none"
    },
    updateState: function(navigation, displayFormBtn, forceUpdate) {
        document.querySelector("#la-prescription-modal-wrapper").style.flexDirection = "unset"
        document.querySelector("#la-prescription-modal-wrapper").style.flexDirection = ""
        document.querySelector(".la-prescription-modal-wrapper").scrollTop = 0
        this.updatePictureMatrix(navigation.name.replace("bound ", ""))
        this.formBtn.style.display = 'none'

        if (!this.navigationSteps) {
            this.navigationSteps = []
            this.navigation = {}
        }

        const boxyFooterContainer = this.formBtn.closest(".la-prescription-boxy-footer")

        if (!this.navigationSteps.includes(navigation.name) || forceUpdate) {
            this.navigationSteps.push(navigation.name)
            this.stepIndex = this.navigationSteps.length;
            this.navigation[this.stepIndex] = navigation
        }
        this.updateProgressBar();
        if (displayFormBtn) {
            this.formBtn.style.display = ''
            this.formBtn.parentElement.style.display = ''
            this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Save and Continue")

            if (boxyFooterContainer) {
                boxyFooterContainer.classList.add("la-btn-active")
            }
        } else {
            this.formBtn.style.display = 'none'
            if (!this.options.settings.layout.includes("subtotal")) {
                this.formBtn.parentElement.style.display = 'none'
            }
            if (boxyFooterContainer) {
                boxyFooterContainer.classList.remove("la-btn-active")
            }
        }
        if (this.options.showBranding && !this.poweredByAdded) {
            this.poweredByAdded = true
            this.contentBox.insertAdjacentHTML("afterend", this.poweredBy)
        }
    },
    updatePictureMatrix: function(stepName) {
        if (!this.isPictureMatrixEnabled) {
            return false
        }
        const selectedVariant = this.variants[this.selectedOrDefaultVariant]
        let featuredImageSrc = selectedVariant.image;
        let defaultSteps = [];
        
        if (this.options.prescriptionConfig?.prescriptionEntryFormLocation !== "before-review") {
            defaultSteps = [
                "renderUploadForm",
                "renderReadingForm",
                "renderManualEntryForm",
                "renderProviderForm"
            ]
        }

        if (this.options.prescriptionConfig?.prescriptionEntryFormLocation !== "before-review") {
            defaultSteps.push("renderSubmissionMethods")
        }

        if (this.response.lensVariant && !defaultSteps.includes(stepName) && this.response.lens.metafield.picture_matrix) {
            const lensProductPictureMatrix = this.response.lens.metafield.picture_matrix[this.productId]
            if (lensProductPictureMatrix) {
                const lensPictureMatrix = lensProductPictureMatrix[this.response.lensVariant.variant_id]
                if (lensPictureMatrix && lensPictureMatrix[this.selectedOrDefaultVariant]) {
                    featuredImageSrc = lensPictureMatrix[this.selectedOrDefaultVariant]
                }
            }
        }

        if (this.productFeaturedImage.src != featuredImageSrc) {
            this.productFeaturedImage.src = featuredImageSrc
        }
    },
    getDynamicPriceRow: function(title, price, id) {
        price = price > 0 ? this.formatCurrency(price) : this.Translation.getTranslatedText("FREE")
        return `<div class="la-footer-row" ${id ? `id=${id}` : ''}>
            <div class="la-footer-text">${title}</div>
            <div class="la-frame-price">${price}</div>
        </div>`
    },
    updateFooterPrices: function() {
        this.prices.addons = null;
        this.prices.lens = this.response.lensVariant ? this.convertCurrency(this.response.lens.shopify_id, this.response.lensVariant.variant_id, this.response.lensVariant.price) : null

        Object.keys(this.response.addOns).forEach(step => {
            const stepInfo = this.response.addOns[step]
            if (stepInfo.variantId && stepInfo.product) {
                if (this.prices.addons == null) {
                    this.prices.addons = 0
                }
                const variant = stepInfo.product.variants.find(variant => variant.id.toString() == stepInfo.variantId.toString())
                this.prices.addons += parseFloat(this.convertCurrency(stepInfo.product.id, variant.id, variant.price))
            }
        })

        this.prices.subtotal = (this.options.variantConfig.addBaseProduct ? this.prices.frame : 0) + (this.prices.addons || 0) + (this.prices.lens || 0) + (this.prices.customAddOnPrice || 0)

        if (this.footerDynamicPriceBox) {
            this.footerDynamicPriceBox.innerHTML = ""
            if (this.prices.lens != null) {
                this.footerDynamicPriceBox.innerHTML += this.getDynamicPriceRow(this.Translation.getTranslatedText("Lens"), this.prices.lens.toFixed(2))
            }
            if (this.prices.addons != null) {
                this.footerDynamicPriceBox.innerHTML += this.getDynamicPriceRow(this.Translation.getTranslatedText("Add Ons"), this.prices.addons.toFixed(2))
            }

            if (this.prices.customAddOnPrice > 0) {
                this.footerDynamicPriceBox.innerHTML += this.getDynamicPriceRow(this.Translation.getTranslatedText("Custom Add Ons"), this.prices.customAddOnPrice.toFixed(2), 'la-customaddon-price-box')
            }

            this.subTotalPriceBox.innerHTML = this.formatCurrency(this.prices.subtotal.toFixed(2))
            if (this.options.variantConfig.addBaseProduct) {
                this.framePriceBox.innerHTML = this.formatCurrency(this.prices.frame.toFixed(2))
            } else {
                this.framePriceBox.parentNode.style.display = "none"
            }
        }

        document.querySelectorAll(".la-footer-frame-variant-title").forEach((element) => {
            const selectedVariant = this.variants[this.selectedOrDefaultVariant]
            if (selectedVariant) {
                element.innerHTML = this.productTitle + (selectedVariant.json.title.includes('Default') ?  '' : (' (' +  selectedVariant.json.title + ')'))
            }
        })

        this.subTotalPriceBoxes.forEach((box) => {
            if(this.isContactLensFlow){
                if(document.querySelector('input[name="la-odright-quantity"]')){
                    this.odRightQuantity = parseInt(document.querySelector('input[name="la-odright-quantity"]').value)
                    this.osLeftQuantity = this.singleContactLens ? 0 : parseInt(document.querySelector('input[name="la-osleft-quantity"]').value)
                }
                this.updateSubTotal(this.odRightQuantity + this.osLeftQuantity);
            }
            else
                this.updateSubTotal(1);       
        })

        if (this.boxyFooterFramePrescriptionType) {
            let rowWrapper = this.boxyFooterFramePrescriptionType.closest('.la-footer-row-wrapper')
            if (this.response.selectedPrescriptionType) {
                this.boxyFooterFramePrescriptionType.innerHTML = this.getPrescriptionTitle()
                rowWrapper.classList.remove("la-d-none")
            } else {
                rowWrapper.classList.add("la-d-none")
            }
        }

        if (this.boxyFooterFramePrescriptionLensTitle) {
            let rowWrapper = this.boxyFooterFramePrescriptionLensTitle.closest('.la-footer-row-wrapper')
            if (this.response.lens) {
                this.boxyFooterFramePrescriptionLensTitle.innerHTML = this.response.lens.name + (this.response.lensVariant.name.includes("Default") ? (" - " + this.response.lensVariant.name) : '')
                this.boxyFooterFrameLensPrice.innerHTML = this.prices.lens.toFixed(2)
                rowWrapper.classList.remove("la-d-none")
            } else {
                rowWrapper.classList.add("la-d-none")
            }
        }

        if (this.boxyFooterFrameAddonsWrapper) {
            this.updateFooterAddons()
        }

        this.footerContent = this.footerElement.outerHTML

        document.querySelector("#la-prescription-modal-wrapper").style.flexDirection = "unset"
        document.querySelector("#la-prescription-modal-wrapper").style.flexDirection = ""
    },
    updateFooterAddons: function() {
        const addons = [];
        Object.keys(this.response.addOns).forEach(step => {
            const stepInfo = this.response.addOns[step];
            if (stepInfo.variantId && stepInfo.product) {
                const variant = stepInfo.product.variants.find(variant => variant.id.toString() === stepInfo.variantId.toString());
                if (variant) {
                    addons.push({
                        title: stepInfo.product.title + (variant.title == "Default Title" ? '' : ` - ${variant.title}`),
                        price: this.formatCurrency(this.convertCurrency(stepInfo.product.id,variant.id,variant.price).toFixed(2))
                    });
                }
            }
        });
        const wrapper = this.boxyFooterFrameAddonsWrapper.closest('.la-footer-row-wrapper')
        this.boxyFooterFrameAddonsWrapper.innerHTML = addons.map((addon) => `<div class="la-footer-row">
            <div class="la-footer-text la-translate la-footer-addon-variant-title">${addon.title}</div>
            <div class="la-footer-addon-price">${addon.price}</div>
        </div>`).join('')

        if (this.boxyFooterFrameAddonsWrapper.innerHTML) {
            wrapper.classList.remove("la-d-none")
        } else {
            wrapper.classList.add("la-d-none")
        }
    },    
    getButtonLayout: function(config) {
        config.className = (config.className || '') + (this.options.variantConfig.layout.type == "horizontal-boxy" ? ' la-horizontal-boxy-label-wrapper ' : '')
        if (config.showRecommendationBadge == true) {
            config.className += (this.options.variantConfig.layout.type == "horizontal-boxy" ? ' boxy-' : ' ') + 'recommendation-label-container'
        }

        return `<div class="${`la-label-btn-wrapper ${config.className}`}">
            ${config.showRecommendationBadge == true ? `<div class="lens-recommendation-badge-wrapper">
                <div class="lens-recommendation-badge">
                    ${this.Translation.getTranslatedText("Recommended for you")}
                </div>
            </div>` : ''}
            <input type="radio" id="${config.name}" name="${config.name}" value="${config.value || config.name}" ${config.productId ? `data-product-id="${config.productId}"` : ""} class="la-tap-select">
            <label for="${config.name}" class="la-label-btn la-${config.name}">
                ${config.tooltip ? this.getToolTipLayout(config.tooltip) : ''}
                ${config.image && this.options.variantConfig.layout.type == "horizontal-boxy" ? '<div class="la-label-image-wapper">' : ''}
                ${config.image ? `<div class="la-label-image">
                    <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                        alt="${config.title}"
                        loading="lazy"
                        srcset='${config.image} 60w,${config.image} 90w,${config.image} 45w'
                        sizes="(max-width: 710px) 90px,(max-width: 475px) 45px,60px"
                    />
                </div>` : ""}
                ${config.image && this.options.variantConfig.layout.type == "horizontal-boxy" ? '</div>' : ''}
                ${config.icon ? `<div class="la-label-image">
                    ${config.icon}
                </div>` : ""}
                <div class="la-label-content-box" style="max-width: ${config.image && config.price && this.options.variantConfig.layout.type != "horizontal-boxy" ? '60%' : 'initial'}">
                    <div class="la-label-title">${this.Translation.getTranslatedText(config.title)}</div>
                    <div class="la-label-description">${this.Translation.getTranslatedText(config.description)}</div>
                </div>
                ${config.price != null ? `<div class="la-label-price">
                    ${config.price > 0 ? this.formatCurrency(config.price) : this.Translation.getTranslatedText("FREE")}
                    ${this.options.default_currency == Shopify.currency.active ? `
                        ${config.compareAtPrice && parseFloat(config.compareAtPrice) > 0 ? `<span class="la-compare-at-price"><del>${this.formatCurrency(config.compareAtPrice)}</del></span>` : ''}
                    `: ''}
                </div>`: ""}
            </label>
        </div>`
    },
    getToolTipLayout: function(toolTip, imgSrc) {
        if (toolTip.isDefault) {
            return `<span class="la-tooltip-wrapper">${this.Translation.getTranslatedText(toolTip.title)}</span>`
        }

        const toolTipId = "tooltip-" + LensAdvizor.Utils.uuidv4()
        this.tooltips.push({
            title: toolTip.title || "",
            content: toolTip.content || "",
            id: toolTipId
        })
        if (imgSrc || !this.svg.tooltip) {
            return `<img
                src="${imgSrc || 'https://cdn.shopify.com/s/files/1/0601/9045/8085/files/FE-i-img.png?v=1647529190'}"
                class="tooltip-img"
                data-la-tooltip="${toolTipId}"
            />`
        }

        return `<span class="tooltip-span" data-la-tooltip="${toolTipId}">${this.svg.tooltip}</span>`
    },
    _component__WillMount: function(eventType, props) {
        document.dispatchEvent(new CustomEvent("LensAdvizor:component:WillMount", {detail: {
            eventType: eventType,
            ...props,
        }}));
    },
    _component__DidMount: function(eventType, props) {
        document.dispatchEvent(new CustomEvent(eventType, {detail: {...props}}));
        document.dispatchEvent(new CustomEvent("LensAdvizor:component:DidMount", {detail: {
            eventType: eventType,
            ...props,
        }}));
    },
    renderPrescriptionTypes: function() {
        this._component__WillMount('LensAdvizor:prescriptionTypes:rendered', {method: "renderPrescriptionTypes"})
        this.loader.style.display = ""
        this.resetUserResponse()

        function handlePrescriptionResponse () {
            const html = this.prescriptionTypes.map(prescriptionType => this.getButtonLayout({
                title: prescriptionType.title,
                image: prescriptionType.image,
                name: `${prescriptionType.name}-${prescriptionType.id}`,
                value: prescriptionType.id,
                description: prescriptionType.description,
                tooltip: prescriptionType.metafield && prescriptionType.metafield.toolTip ? prescriptionType.metafield.toolTip : undefined
            })).join("")
            this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper">
                <div class="la-wrapper-heading">
                    <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Choose Your Prescription Type")}</h3>
                </div>
                <div class="la-label-wrapper">
                    ${html}
                </div>
            </div>`
            document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.handlePrescriptionTypeChange.bind(this)))

            this.updateState(this.renderPrescriptionTypes.bind(this))

            this.formBtn.style.display = 'none'
            if (!this.options.settings.layout.includes("subtotal")) {
                this.formBtn.parentElement.style.display = 'none'
            }
            if (this.options.showBranding && !this.poweredByAdded) {
                this.poweredByAdded = true
                this.contentBox.insertAdjacentHTML("afterend", this.poweredBy)
            }
            this._component__DidMount('LensAdvizor:prescriptionTypes:rendered', {method: "renderPrescriptionTypes"})
        }

        if (this.prescriptionTypes && this.prescriptionTypes.length > 0 && !this.options.variantConfig.skipIfOnePrescriptionType) {
            this.isContactLensFlow = this.prescriptionTypes.find(obj => obj.prescription_type === 'contact_lenses');
            if (this.isContactLensFlow) {
                return this.getProductDetails()
            }
            return handlePrescriptionResponse.call(this)
        }

        if (this.prescriptionTypes && this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
            return this.handlePrescriptionTypeChange()
        }

        fetch(`${this.API_URL}/collection/${this.collectionId}/prescription-types/?api_version=2`)
        .then(res => res.json())
        .then(function(response) {
            this.prescriptionTypes = response.prescriptionTypes.filter(obj => obj.checked);
            this.options.flowMetafields = response.metafields

            this.isContactLensFlow = this.prescriptionTypes.find(obj => obj.prescription_type === 'contact_lenses');
            if (this.isContactLensFlow) {
                return this.getProductDetails()
            }

            if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                return this.handlePrescriptionTypeChange()
            }

            handlePrescriptionResponse.call(this)
        }.bind(this))
    },
    handlePrescriptionTypeChange: function(e) {
        this.resetUserResponse()
        var selectedPrescription = null;

        if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
            selectedPrescription = this.prescriptionTypes[0]
        } else {
            selectedPrescription = this.prescriptionTypes.find(obj => obj.id === e.target.value)
        }
        this.response.selectedPrescriptionType = selectedPrescription
        this.response.prescriptionType = selectedPrescription.name

        this.previousStep = this.currentStep
        this.options.prescriptionConfig = selectedPrescription.settings

        const { pdRequired, pdOnUpload } = this.options.prescriptionConfig
        this.options.showLunaPDTool = this.enableLunaPdTool && this.Utils.formPrescriptionTypes.includes(selectedPrescription.name) && (pdRequired !== "hidden" || pdOnUpload !== "hidden")

        this.updateState(this.renderPrescriptionTypes.bind(this))

        this.options.fieldValues = {
            singlePD: [], dualPD: [], sph: [],
            cyl: [], add: [], axis: Array.from({length: 181}, (_, i) => i),
            segmentHeight: [],
            prismValues: [], diopters: []
        }

        this.updateFieldValues("singlePD", selectedPrescription.settings.fieldOptions.pd, parseFloat(selectedPrescription.settings.fieldOptions.pd.steps > 0 ? selectedPrescription.settings.fieldOptions.pd.steps : 0.5))
        this.updateFieldValues("dualPD", selectedPrescription.settings.fieldOptions.dualPd, 0.5)
        this.updateFieldValues("sph", selectedPrescription.settings.fieldOptions.sph, 0.25)
        this.updateFieldValues("cyl", selectedPrescription.settings.fieldOptions.cyl, 0.25)
        this.updateFieldValues("add", selectedPrescription.settings.fieldOptions.add, 0.25)
        this.updateFieldValues("segmentHeight", selectedPrescription.settings.fieldOptions.segmentHeight || {min:12, max:45}, 1)
        this.updateFieldValues("diopters", selectedPrescription.settings.diopters, parseFloat(selectedPrescription.settings.diopters.steps > 0 ? selectedPrescription.settings.diopters.steps : 0.25))
        this.updateFieldValues("prismValues", {min: 0, max: 5}, 0.25)

        this.lensDisplayMethod = "renderLensGroup"

        if (selectedPrescription.settings.lensGroupDisplayType === "hidden") {
            this.lensDisplayMethod = "renderLenses"
        } else if (selectedPrescription.settings.lensGroupDisplayType === "header") {
            this.lensDisplayMethod = "renderHeaderLenses"
        } else if (selectedPrescription.settings.lensGroupDisplayType === "accordion") {
            this.lensDisplayMethod = "renderAccordionLenses"
        }

        if (["single_vision", "progressive"].includes(this.response.prescriptionType)) {
            if (selectedPrescription.settings.prescriptionEntryFormLocation == "before-review") {
                this.currentStep = this.lensDisplayMethod
                if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                    this.updateState(this[this.lensDisplayMethod].bind(this))
                }
                return this.getItemGroups(this[this.currentStep].bind(this))
            } else {
                this.currentStep = "renderSubmissionMethods";
                if ((this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) && (this.options.prescriptionConfig.submissionMethods.length == 1 && this.options.prescriptionConfig.skipPrescriptionMethod)) {
                    this.updateState(this[this.lensDisplayMethod].bind(this))
                } else if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                    this.updateState(this.renderSubmissionMethods.bind(this))
                } else if (this.options.prescriptionConfig.submissionMethods.length == 1 && this.options.prescriptionConfig.skipPrescriptionMethod && !this.options.variantConfig.skipIfOnePrescriptionType) {
                    if (this.options.prescriptionConfig.submissionMethods.find(submissionMethod => "entered_manually" == submissionMethod.value)) {
                        this.updateState(this.renderManualEntryForm.bind(this))
                    } else if (this.options.prescriptionConfig.submissionMethods.find(submissionMethod => "uploaded" == submissionMethod.value)) {
                        this.updateState(this.renderUploadForm.bind(this))
                    } else {
                        this.updateState(this[this.lensDisplayMethod].bind(this))
                    }
                }
            }
        } else if (this.response.prescriptionType == 'reading') {
            if (selectedPrescription.settings.prescriptionEntryFormLocation == "before-review") {
                this.currentStep = this.lensDisplayMethod
                if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                    this.updateState(this[this.lensDisplayMethod].bind(this))
                }
                return this.getItemGroups(this[this.currentStep].bind(this))
            } else {
                this.currentStep = "renderReadingForm";
                if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                    this.navigationSteps = ["bound renderReadingForm"]
                    this.navigation = { 1: this.renderReadingForm.bind(this) }
                }
            }
        } else if (this.response.prescriptionType == 'non_prescription') {
            if (this.options.prescriptionConfig.lensGroupDisplayType === "button") {
                this.currentStep = this.lensDisplayMethod
            } else {
                this.currentStep = this.lensDisplayMethod
            }
            if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType) {
                this.navigationSteps = [`bound ${this.lensDisplayMethod}`]
                this.navigation = { 1: this[this.lensDisplayMethod].bind(this) }
            }
            return this.getItemGroups(this[this.currentStep].bind(this))
        } else if (this.response.prescriptionType == "frame_only"){
            return this.handleFrameOnly()
        }
        this.getItemGroups()
        if (this.prescriptionTypes.length == 1 && this.options.variantConfig.skipIfOnePrescriptionType && !this.options.prescriptionConfig.skipPrescriptionMethod) {
            this.stepIndex = this.navigationSteps.length;
        }
        return this[this.currentStep]()
    },
    updateFieldValues: function(fieldName, data, step) {
        min = parseFloat(data.min)
        max = parseFloat(data.max)
        while (min <= max) {
            if (!this.options.fieldValues[fieldName].includes(min)) {
                this.options.fieldValues[fieldName].push(min)
            }
            min += step
        }
        this.options.fieldValues[fieldName].sort(function(a, b){return a - b});
    },
    handleFrameOnly: function() {
        this.loader.style.display = ''
        if (this.response.selectedPrescriptionType?.metafield?.addon_flow) {
            return this.getAddOnsForFrameOnly()
        }
        return new this.AddToCartHandler(this).performOperation()
    },
    getAddOnsForFrameOnly: function() {
        const addOnFlowId = this.response.selectedPrescriptionType?.metafield?.addon_flow;
        const addOnUrl = `${this.API_URL}/add-on-flow/${addOnFlowId}/?store=${Shopify.shop}`
        
        fetch(addOnUrl)
        .then(res => res.json())
        .then(response => {
            this.response.selectedPrescriptionType.add_ons_products = response.steps
            this.response.addOns = {}
            this.response.addOnsStep = 0
        
            response.steps.forEach((step, index) => {
                this.response.addOns[index] = {
                    product: null,
                    variantId: null,
                    canSkip: false
                }
            })
            
            this.loader.style.display = 'none';
            return this.renderAddOns();
        })
        
    },
    async getProductDetails() {
        this.loader.style.display = "none"
        const productURL = `${this.API_URL}/collection/product/${this.productId}/?variant=${this.selectedOrDefaultVariant}&api_version=2`
        let response = await fetch(productURL)
        this.product = await response.json()
        this.contactLensFormData = []
        this.renderContactLensForm()
    },
    getContactLensRxFields: function() {
        const { meta_data } = this.product;
        const fieldsOrder = ["sph", "cyl", "axis", "add", "base_curve", "diameter", "d/n"]

        function generateFieldString (evalName, quantity) {
            return fieldsOrder.map(function(fieldName) {
                let fieldValues = meta_data[fieldName]
                if (fieldValues) {
                    fieldValues = fieldValues.split(',')
                    let inputFieldName = `la-${evalName.replace("_", "")}-${fieldName}`
                    const selectedValue = this.contactLensFormData.find(obj => obj.name === inputFieldName) || {}
                    if (fieldValues.length > 1) {
                        let isRequired = this.singleContactLens || (quantity != undefined ? (quantity != "0" ? true : "") : true)
                        return `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Contacts_" + fieldName)}</label>
                            <select
                                class="la-form-select"
                                name="${inputFieldName}"
                                data-field="${fieldName}"
                                data-eval="${evalName}"
                                ${isRequired ? "required" : ""}
                            >
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${fieldValues.map(function(value) {
                                    return `<option value="${value}" ${selectedValue.value == value ? "selected" : ""}>${value}</option>`
                                }.bind(this)).join(",")}
                            </select>
                        </div>`
                    } else {
                        return `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Contacts_" + fieldName)}</label>
                            <input class="la-form-input" type="text" value="${fieldValues[0]}" readonly disabled name="${inputFieldName}">
                        </div>`
                    }
                }
            }.bind(this)).join("");
        }

        const odQuantity = this.contactLensFormData.find(obj => obj.name === "la-odright-quantity") || {}
        const osQuantity = this.contactLensFormData.find(obj => obj.name === "la-osleft-quantity") || {}

        return {
            osLeft: generateFieldString.call(this, "os_left", osQuantity.value),
            odRight: generateFieldString.call(this, "od_right", odQuantity.value),
            odQuantity: odQuantity.value, osQuantity: osQuantity.value
        }
    },
    renderContactLensForm: function() {
        this._component__WillMount('LensAdvizor:rendering:contactLens', {method: "renderContactLensForm"})
        const fields = this.getContactLensRxFields()

        this.contentBox.innerHTML = `<div class="la-contact-lenswrapper">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Enter Your Prescription Details")}</h3>
            </div>
            <h4>
                <label class="la-h5 la-form-field-label la-checkox-wrapper-label" for="la-graduation-field">
                    <input type="checkbox" name="la-graduation-rx-field" ${this.singleContactLens ? 'checked' : ''} id="la-graduation-field">
                    ${this.Translation.getTranslatedText("I have the same graduation in both eyes (Only one graduation)")}
                </label>
            </h4>
            <form class="la-prescription-wrapper" id="la-prescription-form" data-form="contact_lenses">
                <div class="la-prescription-fields-wrapper">
                    ${this.singleContactLens ? '' : `<h6 class="la-h6">
                        ${this.Translation.getTranslatedText("OD (Right Eye)")}
                    </h6>`}
                    <div class="la-form-flex la-column-gap-1-5">
                        ${fields.odRight}
                        <div class="la-form-item">
                            <label class="la-form-helper-label">
                                ${this.Translation.getTranslatedText("Quantity")}
                            </label>
                            <input
                                type="number"
                                value="${fields.odQuantity != undefined ? fields.odQuantity : 1}"
                                min="${this.singleContactLens ? '1' : '0'}"
                                max="25"
                                name="la-odright-quantity"
                                class="la-form-input-number la-quantity-field"
                                data-name-type="od"
                                data-eval-field="od_right"
                            />
                        </div>
                    </div>
                </div>
                ${!this.singleContactLens ? `<div class="la-divider"></div>
                <div class="la-prescription-fields-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("OS (Left Eye)")}</h6>
                    <div class="la-form-flex la-column-gap-1-5">
                        ${fields.osLeft}
                        <div class="la-form-item">
                            <label class="la-form-helper-label">
                                ${this.Translation.getTranslatedText("Quantity")}
                            </label>
                            <input
                                type="number"
                                value="${fields.osQuantity != undefined ? fields.osQuantity : 1}"
                                min="0"
                                max="25"
                                name="la-osleft-quantity"
                                class="la-form-input-number la-quantity-field"
                                data-name-type="os"
                                data-eval-field="os_left"
                            />
                        </div>
                    </div>
                </div>` : ''}
                <div class="la-divider"></div>
                <div class="la-upload-wrapper" style="margin-bottom: 1.5rem">
                    <input type="file" id="la-prescription-file" name="la-prescription-file" class="la-hidden" accept="image/png, image/jpeg, application/pdf">
                    <p class="la-information la-text-left">
                    ${this.Translation.getTranslatedText("Upload your prescription for us to confirm that you have entered it correctly (Optional)")}.
                    </p>
                    <label for="la-prescription-file" class="la-label-btn la-prescription-file-label">
                        ${this.svg.attachment}
                        <span style="margin: auto">
                            ${this.response.prescription ? this.Translation.getTranslatedText("Change") : this.Translation.getTranslatedText("Choose File")}
                        </span>
                    </label>
                    <p class="la-information" id="la-prescription-upload-message">
                        ${this.response.prescription ? `${this.svg.check} ${this.response.prescription.originalName}` : ''}
                    </p>
                </div>
            </form>
        </div>`

        document.querySelector("#la-prescription-file").addEventListener("change", this.handlePrescriptionUpload.bind(this))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))

        document.querySelector("#la-graduation-field").addEventListener("change", function(event) {
            this.singleContactLens = event.target.checked
            this.renderContactLensForm()
        }.bind(this))

        
        document.querySelectorAll(".la-form-input-number").forEach(input => {
           input.addEventListener("change", this.handleContactLensQtyChange.bind(this))
        })
    

        this.setDefaultManualResponse()
        this.response.selectedPrescriptionType = this.isContactLensFlow
        this.updateState(this.renderContactLensForm.bind(this), true)
        this._component__DidMount('LensAdvizor:render:contactLens', {method: "renderContactLensForm"})
    },
    handleContactLensQtyChange: function(event) {
        const qtyField = event.target
        const quantityRelatedFields = event.target.closest("form").querySelectorAll(`[data-eval="${qtyField.dataset.evalField}"]`)

        var siblingQtySelector;

        if (qtyField.name == "la-odright-quantity") {
            siblingQtySelector = 'input[name="la-osleft-quantity"]'
        } else {
            siblingQtySelector = 'input[name="la-odright-quantity"]'
        }

        document.querySelectorAll('.la-quantity-field').forEach(field => field.setAttribute("min", '0'))

        if (qtyField.value == "0") {
            quantityRelatedFields.forEach(field => field.removeAttribute("required"))
            document.querySelector(siblingQtySelector)?.setAttribute("min", "1")
        } else {
            quantityRelatedFields.forEach(field => field.setAttribute("required", "required"))
            document.querySelector(siblingQtySelector)?.setAttribute("min", "0")
        }


        this.odRightQuantity=parseInt(document.querySelector('input[name="la-odright-quantity"]').value)
        this.osLeftQuantity=this.singleContactLens ? 0 : parseInt(document.querySelector('input[name="la-osleft-quantity"]')?.value)

        this.updateSubTotal(this.odRightQuantity + this.osLeftQuantity);

    },
    updateSubTotal: function(quantity){
        this.subTotalPriceBoxes.forEach((box) => {
            box.innerHTML = this.formatCurrency((this.prices.subtotal + (this.prices.frame * (quantity - 1))).toFixed(2))
            if (this.options.variantConfig.addBaseProduct) {
                this.framePriceBox.innerHTML = this.formatCurrency(this.prices.frame.toFixed(2) * quantity)
            } else {
                this.framePriceBox.parentNode.style.display = "none"
            }             
        })
    },
    renderSubmissionMethods: function() {
        this._component__WillMount('LensAdvizor:render:submissionMethods', {method: "renderSubmissionMethods"})
        this.setDefaultManualResponse()
        if (this.options.prescriptionConfig.submissionMethods.length == 1 && this.options.prescriptionConfig.skipPrescriptionMethod ) {
            return this.selectSubmissionMethod()
        } else {
            this.updateState(this.renderSubmissionMethods.bind(this))
        }

        this.contentBox.innerHTML = `<div class="la-prescription-wrapper">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Add Your Prescription")}</h3>
            </div>
            <div class="la-label-wrapper">
                ${this.options.prescriptionConfig.submissionMethods.map(function(submissionMethod) { 
                    return this.getButtonLayout({...submissionMethod, icon: eval(submissionMethod.icon)})
                }.bind(this)).join("")}
            </div>
        </div>`
        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.selectSubmissionMethod.bind(this)))
        this._component__DidMount('LensAdvizor:render:submissionMethods', {method: "renderSubmissionMethods"})
    },
    selectSubmissionMethod: function(e) {
        this.previousStep = this.currentStep
        if (this.options.prescriptionConfig.submissionMethods.length == 1 && this.options.prescriptionConfig.skipPrescriptionMethod) {
            this.response.method = this.options.prescriptionConfig.submissionMethods[0].value;
        } else {
            this.response.method = e.target.value;
        }
        this.lenses = []

        if (this.response.method == "uploaded") {
            this.currentStep = 'renderUploadForm'
        } else if (this.response.method == "entered_manually") {
            this.currentStep = 'renderManualEntryForm'
        } else if (this.response.method == "provider_information") {
            this.currentStep = 'renderProviderForm'
        } else {
            this.currentStep = this.lensDisplayMethod
            if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review") {
                this.currentStep = 'renderReview'
            }
        }

        this.previousStep = 'selectSubmissionMethod'
        return this[this.currentStep]()
    },
    Luna: {
        initCompleted: false,
        currentTarget: null,
        serverUrl: "https://api.glasseson.com/prod/",
        init: function (lensAdvizor) {
            if (this.initCompleted) {
                return true
            }

            this.lensAdvizor = lensAdvizor
            this.themeColor = this.lensAdvizor.settings.lunaThemeColor || this.lensAdvizor.variants[this.lensAdvizor.selectedOrDefaultVariant].settings.modalButtonBackgroundColor
            this.fontFamily = this.lensAdvizor.settings.lunaFont || 'Arial' // Need to import font family before using it

            if (!glasseson || typeof glasseson.init == "undefined") {
                return setTimeout(function() {
                    this.init(lensAdvizor)
                }.bind(this), 1000)
            }

            const options = {
                profileName: this.lensAdvizor.options.luna_profile_name,
                flow: "pd", fullPage: true,
                width: 835, themeColor: this.themeColor ? this.themeColor : "#5FB8E3",
                fontFamily: this.fontFamily
            };

            glasseson.init(this.lensAdvizor.options.luna_client_id, this.serverUrl, options)
            .then(response => {
                this.initCompleted = true
            }, error => {
                this.handleInitError(error);
            })
        },
        handleInitError: function(error) {
            // Handle luna init error
            console.warn(error)
        },
        handleGlassesOnOpen: function(e) {
            if (glasseson.initCompleted) {
                this.Luna.currentTarget = e.target
                glasseson.open("pd")
                glasseson.setResultCallback(this.Luna.handleResultCallback.bind(this))
            }
        },
        handleResultCallback: function(result) {
            this.response.manually.pd.type = 'Single PD'
            this.response.manually.pd.value = result.data.pd
            document.querySelector('input[name="la-pd-field"][value="Single PD"]').checked = true
            document.querySelector('select[name="la-pd-value"]').value = parseFloat(result.data.pd)
            this.response.manually.pd.lunaPdCount = 1
            this.setLocalStorage("lunaPdInformation", result.data.pd)
        },
        importScript: async function() {
            let script = document.createElement("script");
            script.src = "https://web.cdn.glasseson.com/glasseson-2.31.0.js"
            script.async = true
            const selectorElement = document.querySelector("head")
            selectorElement.appendChild(script)
            let glassesonBox = document.createElement("div")
            glassesonBox.id = "glasseson"
            document.querySelector("body").appendChild(glassesonBox)
        }
    },
    renderUploadForm: function() {
        this._component__WillMount('LensAdvizor:render:uploadForm', {method: "renderUploadForm"})
        this.updateState(this.renderUploadForm.bind(this), true)

        const { prescriptionConfig } = this.options;

        const showPDOnUpload = prescriptionConfig.pdOnUpload !== "hidden"
        const showSegmentHeight = prescriptionConfig.segmentHeightOnUpload !== "hidden"
        const showSelfie = prescriptionConfig.selfieOnUpload !== undefined && prescriptionConfig.selfieOnUpload !== "hidden"
        const pdType = this.response.manually.pd.type
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];

        this.contentBox.innerHTML = `<form
            class="la-prescription-wrapper"
            id="la-prescription-form"
            data-form="uploaded"
            novalidate="true"
        >
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">
                    ${this.Translation.getTranslatedText("Upload Prescription")}
                </h3>
            </div>
            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-fields-wrapper" style="border: none; padding: 30px 0;">` : ''}
            <div class="la-upload-wrapper">
                <input type="file" id="la-prescription-file" name="la-prescription-file" class="la-hidden" required accept="image/png, image/jpeg, application/pdf">
                <p class="la-information">
                    ${this.Translation.getTranslatedText("Please upload your prescription as a PNG, JPG or PDF file")}.
                </p>
                <label for="la-prescription-file" class="la-label-btn la-prescription-file-label">
                    ${this.svg.attachment}
                    <span style="margin: auto">
                        ${this.response.prescription ? this.Translation.getTranslatedText("Change") : this.Translation.getTranslatedText("Choose File")}
                    </span>
                </label>
                <p class="la-information" id="la-prescription-upload-message">
                    ${this.response.prescription ? `${this.svg.check} ${this.response.prescription.originalName}` : ''}
                </p>
            </div>
            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}

            ${showSelfie ? `${selectedVariant.settings.layout.type != "horizontal-boxy" ? '<div class="la-divider"></div>' : ''}
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-fields-wrapper" style="padding: 0;">` : ''}
                    <lensadvizor-selfie
                        required="${prescriptionConfig.selfieOnUpload == true ? 'required' : ''}"
                    ></lensadvizor-selfie>
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}
            ` : ''}

            ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `${showPDOnUpload ? '<div class="la-divider"></div>' : ''}`: ''}
            ${showPDOnUpload ? `${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-fields-wrapper">` : ''}
            <div class="la-prescription-fields-wrapper">
                ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `<h6 class="la-h6">
                    ${this.Translation.getTranslatedText("Pupillary Distance (PD)")}
                </h6>
                <div class="la-flex la-column-gap-1-5">
                    <div class="la-flex la-column-gap-5">
                        <input type="radio" name="la-pd-field" value="Single PD" class="la-pd-field" id="la-pd-field-single" ${pdType == "Single PD" ? "checked" : ""}>
                        <label class="la-form-field-label" for="la-pd-field-single">${this.Translation.getTranslatedText("Single PD")}</label>
                    </div>
                    <div class="la-flex la-column-gap-5">
                        <input type="radio" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                        <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Dual PD")}</label>
                    </div>
                </div>` : ''}
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-flex la-column-gap-1-5 la-pd-form">
                    <div class="la-form-item">
                        <h6 class="la-h6">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
                    </div>` : ''}
                    <div
                        class="la-form-flex la-column-gap-1-5 ${selectedVariant.settings.layout.type == "horizontal-boxy" ? 'la-fields-header' : ''}"
                        id="la-pd-fields-container"
                    >
                        ${pdType == "Single PD" ? `<div class="la-form-item ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? 'la-mt-1' : ''}">
                            <select
                                class="la-form-select"
                                name="la-pd-value" ${this.options.prescriptionConfig.pdOnUpload == true ? "required" : ""}
                                data-field="value"
                                data-eval="pd"
                            >
                                <option class="la-option-select" value="">
                                    ${this.Translation.getTranslatedText("Choose")}
                                </option>
                                ${this.options.fieldValues.singlePD.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.pd.value == value ? "selected" : ""}
                                >
                                    ${value}
                                </option>`)}
                            </select>
                        </div>
                        ${this.options.showLunaPDTool ? `<div class="la-form-item ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? 'la-mt-1' : ''}">
                            <a class="la-luna-pd-btn" id="la-luna-pd-btn">Find your PD</a>
                        </div>` : ''}` : `<div class="la-form-item">
                            <label class="la-form-helper-label">
                                ${this.Translation.getTranslatedText("Right")}
                            </label>
                            <select
                                class="la-form-select"
                                name="la-pd-right" ${this.options.prescriptionConfig.pdOnUpload == true ? "required" : ""}
                                data-field="right"
                                data-eval="pd"
                            >
                                <option class="la-option-select" value="">
                                    ${this.Translation.getTranslatedText("Choose")}
                                </option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${this.response.manually.pd.right == value.toFixed(2) ? "selected" : ""}
                                >
                                    ${value}
                                </option>`)}
                            </select>
                        </div>
                        <div class="la-form-item">
                            <label class="la-form-helper-label">
                                ${this.Translation.getTranslatedText("Left")}
                            </label>
                            <select
                                class="la-form-select"
                                name="la-pd-left" ${this.options.prescriptionConfig.pdOnUpload == true ? "required" : ""}
                                data-field="left"
                                data-eval="pd"
                            >
                                <option
                                    class="la-option-select"
                                    value=""
                                >
                                    ${this.Translation.getTranslatedText("Choose")}
                                </option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${this.response.manually.pd.left == value.toFixed(2) ? "selected" : ""}
                                >
                                    ${value}
                                </option>`)}
                            </select>
                        </div>`}
                    </div>
                    ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-item la-pd-switcher">
                        <div class="la-flex la-column-gap-1-5">
                            <div class="la-flex la-column-gap-5">
                                <input type="checkbox" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                                <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Have two PDs")}</label>
                            </div>
                        </div>
                    </div>
                </div>` : ''}
            </div>
            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}` : ''}

            ${showSegmentHeight && this.response.prescriptionType === "progressive" ? `${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `<div class="la-divider"></div>` : ''}
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-fields-wrapper">` : ''}
                <div class="la-prescription-fields-wrapper la-segment-height-wrapper">
                    ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `<h6 class="la-h6">${this.Translation.getTranslatedText("Segment Height")}</h6>` : ""}
                    <div class="la-form-flex la-column-gap-1-5">
                        ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-item">
                            <h6 class="la-h6">${this.Translation.getTranslatedText("Segment Height")}</h6>
                        </div>` : ''}
                        <div class="la-form-item">
                            <select class="la-form-select" name="la-segment-height" data-field="segment_height" ${this.options.prescriptionConfig.segmentHeightOnUpload == true ? "required" :""}>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.segmentHeight.map(value => `<option value="${value}">${value}</option>`)}
                            </select>
                        </div>
                    </div>
                </div>
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}
            ` : ""}
        </form>`
        document.querySelectorAll('input[name="la-pd-field"]').forEach(input => input.addEventListener("change", this.handlePDTypeChange.bind(this)))
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelector("#la-prescription-file").addEventListener("change", this.handlePrescriptionUpload.bind(this))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))

        if (this.options.showLunaPDTool && pdType == "Single PD") {
            document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
        }

        this._component__DidMount('LensAdvizor:render:uploadForm', {method: "renderUploadForm"})
    },
    handlePDTypeChange: function(e) {
        this.response.manually.pd.type = e.target.checked ? e.target.value : 'Single PD'
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];
        const pdFieldContainer = document.querySelector("#la-pd-fields-container")
        const prescriptionConfig = this.options.prescriptionConfig

        if (this.response.method == 'entered_manually' && prescriptionConfig.prescriptionEntryFormLocation == 'before-review') {
            this.updatePDValues();
        }

        const pdRequired = this.response.method == "entered_manually" ? prescriptionConfig.pdRequired == true : prescriptionConfig.pdOnUpload == true

        if (this.response.manually.pd.type == "Single PD") {
            pdFieldContainer.innerHTML = `<div class="la-form-item la-mt-1">
                <select class="la-form-select" name="la-pd-value" ${pdRequired ? "required" : ""} data-field="value" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.singlePD.map(value => `<option value="${value}">${value}</option>`)}
                </select>
            </div>
            ${this.options.showLunaPDTool ? `<div class="la-form-item ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? 'la-mt-1' : ''}">
                <a class="la-luna-pd-btn" id="la-luna-pd-btn">
                    ${this.Translation.getTranslatedText('Find your PD')}
                </a>
            </div>` : ''}`
            this.response.manually.pd.left = null
            this.response.manually.pd.right = null
            if (this.options.showLunaPDTool) {
                document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
            }
        } else {
            this.response.manually.pd.value = null
            pdFieldContainer.innerHTML = `${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-flex">` : ''}
            <div class="la-form-item">
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<h6 class="la-h6">${this.Translation.getTranslatedText("Right")}</h6>` :
                `<label class="la-form-helper-label">${this.Translation.getTranslatedText("Right")}</label>`}
                <select class="la-form-select" name="la-pd-right" ${pdRequired ? "required" : ""} data-field="right" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.dualPD.map(value => `<option value="${value.toFixed(2)}">${value.toFixed(2)}</option>`)}
                </select>
            </div>
            <div class="la-form-item">
                ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<h6 class="la-h6">${this.Translation.getTranslatedText("Left")}</h6>` :
                `<label class="la-form-helper-label">${this.Translation.getTranslatedText("Left")}</label>`}
                <select class="la-form-select" name="la-pd-left" ${pdRequired ? "required" : ""} data-field="left" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.dualPD.map(value => `<option value="${value.toFixed(2)}">${value.toFixed(2)}</option>`)}
                </select>
            </div>
            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}`
        }
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
    },
    handleFormSelectChange: e => {
        eval("LensAdvizor.response.manually" + (e.target.dataset.eval ? `.${e.target.dataset.eval}` : ""))[e.target.dataset.field] = e.target.value
        const prescriptionConfig = LensAdvizor.options.prescriptionConfig

        if (["od_right", "os_left"].includes(e.target.dataset.eval) && ["sph", "cyl", "add"].includes(e.target.dataset.field)) {
            function updateRequiredFields(nodeList){
                nodeList.forEach(select => {
                    if (e.target.value) {
                        select.removeAttribute("required")
                    } else {
                        select.setAttribute("required", "required")
                    }
                })
            }

            updateRequiredFields(document.querySelectorAll("[data-field=sph]"))
            updateRequiredFields(document.querySelectorAll("[data-field=cyl]"))

            if (prescriptionConfig.showAdd == "required" && e.target.getAttribute("data-field") == "add") {
                updateRequiredFields(document.querySelectorAll("[data-field=add]"))
            }

            if (e.target.dataset.field === "cyl") {
                const cylField = document.querySelector(`[data-field=axis][data-eval=${e.target.dataset.eval}]`)
                if (!["", "0.00"].includes(e.target.value)) {
                    cylField.removeAttribute("disabled")
                } else {
                    cylField.setAttribute("disabled", "disabled")
                    cylField.value = ""
                    LensAdvizor.response.manually[e.target.dataset.eval].axis = ""
                }
            }
        }
    },
    handlePrescriptionUpload: function(e) {
        return new this.UploadPrescription(this).upload()
    },
    renderReadingForm: function() {
        this._component__WillMount('LensAdvizor:render:readingForm', {method: "renderReadingForm"})
        this.updateState(this.renderReadingForm.bind(this), true)
        const prescriptionConfig = this.options.prescriptionConfig
        const pdType = this.response.manually.pd.type
        const showPD = prescriptionConfig.pdRequired !== "hidden"
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];

        this.options.prescriptionConfig.dioptersDisplayType == "button"
        this.options.fieldValues.diopters.map
        this.response.method = 'entered_manually'

        this.contentBox.innerHTML = `<form class="la-prescription-wrapper la-reading-form" id="la-prescription-form" data-form="reading" novalidate="true">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Select Your Reading Strength Level")}</h3>
            </div>

            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-fields-wrapper">` : ''}
                <div class="la-prescription-fields-wrapper">
                    ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `<h6 class="la-h6">${this.Translation.getTranslatedText("Diopters")}</h6>` : ''}
                    ${(selectedVariant.settings.layout.type == "horizontal-boxy" && this.options.prescriptionConfig.dioptersDisplayType == "button") ? `
                        <h6 class="la-h6">${this.Translation.getTranslatedText("Diopters")}</h6>
                    ` : ''}
                    <div class="la-form-flex la-column-gap-1-5">
                        ${(selectedVariant.settings.layout.type == "horizontal-boxy" && this.options.prescriptionConfig.dioptersDisplayType !== "button") ? `<div class="la-form-item la-mt-1">
                            <h6 class="la-h6">${this.Translation.getTranslatedText("Diopters")}</h6>
                        </div>` : ''}
                        ${this.options.prescriptionConfig.dioptersDisplayType !== "button" ? `<div class="la-form-flex la-column-gap-1-5 ${selectedVariant.settings.layout.type == "horizontal-boxy" ? 'la-fields-header' : ''}">
                        ${!this.options.prescriptionConfig.dioptersValues ? 
                            `<div class="la-form-item la-mt-1">
                                <select class="la-form-select" name="la-diopters" required data-field="sph">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.diopters.map(value => `<option
                                        value="${value>0?'+':''}${value.toFixed(2)}"
                                        ${this.response.manually.sph == value.toFixed(2) ? "selected" : ""}
                                    >${value>0?'+':''}${value.toFixed(2)}</option>`).join(",")}
                                </select>
                            </div>` 
                            : `<div class="la-form-item">
                                <label class="la-form-helper-label">${this.Translation.getTranslatedText("OD (Right Eye)")}</label>
                                <select class="la-form-select" name="la-diopters" required required data-field="od_right" data-eval="diopters">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.diopters.map(value => `<option
                                        value="${value>0?'+':''}${value.toFixed(2)}"
                                        ${this.response.manually.sph == value.toFixed(2) ? "selected" : ""}
                                    >${value>0?'+':''}${value.toFixed(2)}</option>`).join(",")}
                                </select>
                            </div>
                            <div class="la-form-item">
                                <label class="la-form-helper-label">${this.Translation.getTranslatedText("OS (Left Eye)")}</label>
                                 <select class="la-form-select" name="la-diopters" required data-field="os_left" data-eval="diopters">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.diopters.map(value => `<option
                                        value="${value>0?'+':''}${value.toFixed(2)}"
                                        ${this.response.manually.sph == value.toFixed(2) ? "selected" : ""}
                                    >${value>0?'+':''}${value.toFixed(2)}</option>`).join(",")}
                                </select>
                            </div>`}
                        </div>` 
                        : 
                        `${!this.options.prescriptionConfig.dioptersValues ? `${this.options.fieldValues.diopters.map(value => `<div class="la-form-item la-mt-1 la-radio-button-container">
                                <input type="radio" class="la-hidden" name="la-diopters" required data-field="sph"
                                    id="la-diopters-${value.toFixed(2)}"
                                    value="${value>0?'+':''}${value.toFixed(2)}"
                                    ${this.response.manually.sph == value.toFixed(2) ? "checked" : ""}
                                >
                                <label for="la-diopters-${value.toFixed(2)}" class="la-radio-button">${value>0?'+':''}${value.toFixed(2)}</label>
                            </div>`).join("")}`
                            :
                            `<label class="la-form-helper-label w100">${this.Translation.getTranslatedText("OD (Right Eye)")}</label>
                            ${this.options.fieldValues.diopters.map(value => `<div class="la-form-item la-mt-1 la-radio-button-container">
                                <input type="radio" class="la-hidden" name="la-diopters-od_right" required required data-field="od_right" data-eval="diopters"
                                    id="la-diopters-od_right-${value.toFixed(2)}"
                                    value="${value>0?'+':''}${value.toFixed(2)}"
                                    ${this.response.manually.diopters.od_right == value.toFixed(2) ? "checked" : ""}
                                >
                                <label for="la-diopters-od_right-${value.toFixed(2)}" class="la-radio-button">${value>0?'+':''}${value.toFixed(2)}</label>
                            </div>`).join("")}
                            <label class="la-form-helper-label w100">${this.Translation.getTranslatedText("OS (Left Eye)")}</label>
                            ${this.options.fieldValues.diopters.map(value => `<div class="la-form-item la-mt-1 la-radio-button-container">
                                <input type="radio" class="la-hidden" name="la-diopters-os_left" required data-field="os_left" data-eval="diopters"
                                    id="la-diopters-os_left-${value.toFixed(2)}"
                                    value="${value>0?'+':''}${value.toFixed(2)}"
                                    ${this.response.manually.diopters.os_left == value.toFixed(2) ? "checked" : ""}
                                >
                                <label for="la-diopters-os_left-${value.toFixed(2)}" class="la-radio-button">${value>0?'+':''}${value.toFixed(2)}</label>
                            </div>`).join("")}`
                        }`
                    }
                    </div>
                </div>
                ${showPD ? `${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `<div class="la-divider"></div>` : ''}
                <div class="la-prescription-fields-wrapper">
                    ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? `
                    <h6 class="la-h6">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
                    <div class="la-flex la-column-gap-1-5">
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-pd-field" value="Single PD" class="la-pd-field" id="la-pd-field-single" ${pdType == "Single PD" ? "checked" : ""}>
                            <label class="la-form-field-label" for="la-pd-field-single">${this.Translation.getTranslatedText("Single PD")}</label>
                        </div>
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                            <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Dual PD")}</label>
                        </div>
                    </div>` : ``}
                    ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-flex la-column-gap-1-5 la-pd-form">
                        <div class="la-form-item">
                            <h6 class="la-h6">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
                        </div>` : ''}
                    <div class="la-form-flex la-column-gap-1-5 ${selectedVariant.settings.layout.type == "horizontal-boxy" ? 'la-fields-header' : ''}" id="la-pd-fields-container">
                        ${pdType == "Single PD" ? `<div class="la-form-item  ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? 'la-mt-1' : ''}">
                            <select class="la-form-select" name="la-pd-value" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="value" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.singlePD.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.pd.value == value ? "selected" : ""}
                                >${value}</option>`).join(",")}
                            </select>
                        </div>
                        ${this.options.showLunaPDTool ? `<div class="la-form-item ${selectedVariant.settings.layout.type !== "horizontal-boxy" ? 'la-mt-1' : ''}">
                            <a class="la-luna-pd-btn" id="la-luna-pd-btn">${this.Translation.getTranslatedText('Find your PD')}</a>
                        </div>` : ''}` : `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Right")}</label>
                            <select class="la-form-select" name="la-pd-right" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="right" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    ${this.response.manually.pd.right == value.toFixed(2) ? "selected" : ""}
                                    value="${value.toFixed(2)}"
                                >${value.toFixed(2)}</option>`).join(",")}
                            </select>
                        </div>
                        <div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Left")}</label>
                            <select class="la-form-select" name="la-pd-left" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="left" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${this.response.manually.pd.left == value.toFixed(2) ? "selected" : ""}
                                >${value.toFixed(2)}</option>`).join(",")}
                            </select>
                        </div>`}
                    </div>
                    ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `<div class="la-form-item la-pd-switcher">
                        <div class="la-flex la-column-gap-1-5">
                            <div class="la-flex la-column-gap-5">
                                <input type="checkbox" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                                <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Have two PDs")}</label>
                            </div>
                        </div>
                    </div></div>` : ''}
                </div>`: ''}
            ${selectedVariant.settings.layout.type == "horizontal-boxy" ? `</div>` : ''}
        </form>`
        document.querySelectorAll('input[name="la-pd-field"]').forEach(input => input.addEventListener("change", this.handlePDTypeChange.bind(this)))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelectorAll('input[name="la-diopters"]').forEach(input => input.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelectorAll('input[name="la-diopters-od_right"]').forEach(input => input.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelectorAll('input[name="la-diopters-os_left"]').forEach(input => input.addEventListener("change", this.handleFormSelectChange.bind(this)))

        if (this.options.showLunaPDTool && pdType == "Single PD") {
            document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
        }

        this._component__DidMount('LensAdvizor:render:readingForm', {method: "renderReadingForm"})
    },
    setManualResponseFromLocalStorage: function(prescriptionConfig) {
        if (this.localStorage.manualResponse && this.localStorage.manualResponse[this.response.prescriptionType]) {
            const prescriptionTypeManualResponse = this.localStorage.manualResponse[this.response.prescriptionType]
            if (prescriptionTypeManualResponse?.prism_fields?.od_right?.sph) {
                this.localStorage = {}
                return this.setManualResponseFromLocalStorage(prescriptionConfig)
            }
            this.response.manually = prescriptionTypeManualResponse
        }

        if (this.localStorage.lunaPdInformation && this.response.pd == "Single PD") {
            this.response.manually.pd.value = this.localStorage.lunaPdInformation
        }

        if(this.options.prescriptionConfig.showAdd == "hide" && ["progressive", "single_vision"].includes(this.response.prescriptionType)){
            this.response.manually.od_right.add = null
            this.response.manually.os_left.add = null
        }

        if (prescriptionConfig.pdRequired === "hidden") {
            this.response.manually.pd.type = 'Single PD'
            this.response.manually.pd.left = this.response.manually.pd.right = this.response.manually.pd.value = null
        }

        if (!prescriptionConfig.prismRequired) {
            this.response.manually.prism_fields = {
                od_right: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null},
                os_left: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null}
            }
        }

        if (prescriptionConfig.segmentHeight === "hidden") {
            this.response.manually.segment_heights = null
        }
    },
    updateSphCylFieldValues: function() {
        const lensOptionsSphValuesInRange = [];
        const lensOptionsCylValuesInRange = [];
        const lensSphValuesInRange = [];
        const lensCylValuesInRange = [];

        if (this.response.lens.options_settings.length) {
            this.response.lensOptions.map(optionKey => {
                const option = this.response.lens.options[optionKey]
                const optionSettings = this.response.lens.options_settings.find(obj => obj.name === option.name)
                const selectedOptionSettings = optionSettings.values.find(optionVal => optionVal.name == this.response.lensOptionsSelected[optionKey])
                const selectedOptionSphRxLimits = selectedOptionSettings?.sph
                const selectedOptionCylRxLimits = selectedOptionSettings?.cyl
                
                if (selectedOptionSphRxLimits && (selectedOptionSphRxLimits.range1.from || selectedOptionSphRxLimits.range2.from)) {
                    // Get sph values that lies in rx limit range for lens options
                    this.getPermissibleValues(this.options.fieldValues.sph, selectedOptionSphRxLimits, lensOptionsSphValuesInRange);
                }
                if (selectedOptionCylRxLimits && (selectedOptionCylRxLimits.range1.from || selectedOptionCylRxLimits.range2.from)) {
                    // Get cyl values that lies in rx limit range for lens options
                    this.getPermissibleValues(this.options.fieldValues.cyl, selectedOptionCylRxLimits, lensOptionsCylValuesInRange);
                }
            })

            if (this.response.lens.rx_limit.sph.range1.from || this.response.lens.rx_limit.sph.range2.from) {
                // Filter lens options sph values that lies in range to get lens permissible values
                this.getPermissibleValues(lensOptionsSphValuesInRange.length ? lensOptionsSphValuesInRange : this.options.fieldValues.sph, this.response.lens.rx_limit.sph, lensSphValuesInRange);
            }
            if (this.response.lens.rx_limit.cyl.range1.from || this.response.lens.rx_limit.cyl.range2.from) {
                // Filter lens options cyl values that lies in range to get lens permissible values
                this.getPermissibleValues(lensOptionsCylValuesInRange.length ? lensOptionsCylValuesInRange : this.options.fieldValues.cyl, this.response.lens.rx_limit.cyl, lensCylValuesInRange);
            }
        } else {
            if (this.response.lens.rx_limit.sph.range1.from || this.response.lens.rx_limit.sph.range2.from) {
                // Get sph values that lies in rx limit range for lens
                this.getPermissibleValues(this.options.fieldValues.sph, this.response.lens.rx_limit.sph, lensSphValuesInRange);
            }
            if (this.response.lens.rx_limit.cyl.range1.from || this.response.lens.rx_limit.cyl.range2.from) {
                // Get cyl values that lies in rx limit range for lens
                this.getPermissibleValues(this.options.fieldValues.cyl, this.response.lens.rx_limit.cyl, lensCylValuesInRange);
            }
        }

        // If lens values are present (if rx_limit range is not empty), assign filtered lens values, else assign filtered lens options values
        if (lensSphValuesInRange.length || lensOptionsSphValuesInRange.length) {
            this.options.fieldValues.sph = lensSphValuesInRange.length > 0 ? lensSphValuesInRange : lensOptionsSphValuesInRange;
            this.options.fieldValues.sph.sort(function(a, b){return a - b});
        }

        if (lensOptionsCylValuesInRange.length || lensCylValuesInRange.length) {
            this.options.fieldValues.cyl = lensCylValuesInRange.length > 0 ? lensCylValuesInRange : lensOptionsCylValuesInRange;
            this.options.fieldValues.cyl.sort(function(a, b){return a - b});
        }
    },
    updatePDValues: function() {
        const lensSinglePDValuesInRange = [];
        const lensDualPDValuesInRange = [];

        const lensSinglePDValues = {
            range1: {
                from: this.response.lens.min_single_pd,
                to: this.response.lens.max_single_pd
            }
        }
        const lensDualPDValues = {
            range1: {
                from: this.response.lens.min_dual_pd,
                to: this.response.lens.max_dual_pd
            }
        }

        if(this.response.lens.min_single_pd && this.response.lens.max_single_pd) {
            // Filter lens single PD values that lies in range to get lens permissible values
            this.getPermissibleValues(this.options.fieldValues.singlePD, lensSinglePDValues, lensSinglePDValuesInRange)
        }
        if(this.response.lens.min_dual_pd && this.response.lens.max_dual_pd) {
            // Filter lens dual PD values that lies in range to get lens permissible values
            this.getPermissibleValues(this.options.fieldValues.dualPD, lensDualPDValues, lensDualPDValuesInRange)
        }

        if (lensSinglePDValuesInRange.length) {
            this.options.fieldValues.singlePD = lensSinglePDValuesInRange
        }

        if (lensDualPDValuesInRange.length) {
            this.options.fieldValues.dualPD = lensDualPDValuesInRange
        }
    },
    getPermissibleValues: function(rangeToFilter, rxLimit, rangeToPush) {
        rangeToFilter.forEach(val => {
            Object.keys(rxLimit).forEach(range => {
                if (rxLimit[range].from && rxLimit[range].to) {
                    if (val >= parseFloat(rxLimit[range].from) && val <= parseFloat(rxLimit[range].to)) {
                        if (!rangeToPush.includes(val)) {
                            rangeToPush.push(val)
                        }
                    }
                }
            })
        })
    },
    renderManualEntryForm: function() {
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];

        if (selectedVariant.settings.layout.type == "horizontal-boxy") {
            return this.renderBoxyLayoutManualEntryForm()
        }

        this._component__WillMount('LensAdvizor:render:manualEntryForm', {method: "renderManualEntryForm"})
        this.updateState(this.renderManualEntryForm.bind(this), true)

        const prescriptionConfig = this.options.prescriptionConfig
        this.setManualResponseFromLocalStorage(prescriptionConfig)

        if (prescriptionConfig.prescriptionEntryFormLocation == 'before-review') {
            if (this.response.lens.options_settings.length || Object.keys(this.response.lens.rx_limit).length) {
                this.updateSphCylFieldValues()
            }
            this.updatePDValues()
        }

        if ((prescriptionConfig.showAdd === undefined || prescriptionConfig.showAdd === "hide") && this.response.prescriptionType == "progressive") {
            prescriptionConfig.showAdd = "required";
        }

        const pdType = this.response.manually.pd.type
        const showPD = prescriptionConfig.pdRequired !== "hidden"
        const showSegmentHeight = prescriptionConfig.segmentHeight !== "hidden"
        const showUpload = prescriptionConfig.uploadRequiredOnManualEntry !== "hidden"
        const showSelfie = prescriptionConfig.selfiedOnEntry !== undefined && prescriptionConfig.selfiedOnEntry !== "hidden"

        this.contentBox.innerHTML = `<form class="la-prescription-wrapper" id="la-prescription-form" data-form="manually" novalidate="true">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Enter Your Prescription Manually")}</h3>
            </div>
            <div class="la-fields-wrapper">
                <div class="la-prescription-fields-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("OD (Right Eye)")}</h6>
                    <div class="la-form-flex la-column-gap-1-5">
                        ${prescriptionConfig.formFields.showSph ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("SPH")}</label>
                            <select class="la-form-select" id="la-odright-sph" name="la-odright-sph" data-field="sph" data-eval="od_right" required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.sph.map(value => `<option
                                    value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.od_right.sph) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showCyl ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("CYL")}</label>
                            <select class="la-form-select" id="la-odright-cyl" name="la-odright-cyl" data-field="cyl" data-eval="od_right" required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.cyl.map(value => `<option
                                    value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.od_right.cyl) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showAxis ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("AXIS")}</label>
                            <select class="la-form-select" id="la-odright-axis" name="la-odright-axis" data-field="axis" data-eval="od_right" ${this.response.manually.od_right.axis ? '' : ' disabled'} required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.axis.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.od_right.axis != "" && Number(this.response.manually.od_right.axis) === value ? "selected" : ""}
                                >${value}</option>`).join("")}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showAdd ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("ADD")}</label>
                            <select
                                class="la-form-select"
                                id="la-odright-add"
                                name="la-odright-add"
                                data-field="add"
                                data-eval="od_right"
                                ${prescriptionConfig.showAdd}
                            >
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.add.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.od_right.add) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                    </div>
                </div>
                <div class="la-prescription-fields-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("OS (Left Eye)")}</h6>
                    <div class="la-form-flex la-column-gap-1-5">
                        ${prescriptionConfig.formFields.showSph ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("SPH")}</label>
                            <select class="la-form-select" id="la-odleft-sph" name="la-odleft-sph" data-field="sph" data-eval="os_left" required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.sph.map(value => `<option
                                    value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.os_left.sph) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showCyl ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("CYL")}</label>
                            <select class="la-form-select" id="la-odleft-cyl" name="la-odleft-cyl" data-field="cyl" data-eval="os_left" required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.cyl.map(value => `<option
                                    value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.os_left.cyl) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showAxis ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("AXIS")}</label>
                            <select class="la-form-select" id="la-odleft-axis" name="la-odleft-axis" data-field="axis" data-eval="os_left" ${this.response.manually.os_left.axis ? '' : ' disabled'} required>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.axis.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.os_left.axis != "" && Number(this.response.manually.os_left.axis) === value ? "selected" : ""}
                                >${value}</option>`)}
                            </select>
                        </div>` : ''}
                        ${prescriptionConfig.formFields.showAdd ? `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("ADD")}</label>
                            <select
                                class="la-form-select"
                                id="la-odleft-add"
                                name="la-odleft-add"
                                data-field="add"
                                data-eval="os_left"
                                ${prescriptionConfig.showAdd}
                            >
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.add.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${parseFloat(this.response.manually.os_left.add) == value ? "selected" : ""}
                                >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>` : ''}
                    </div>
                </div>
                ${showPD ? `<div class="la-divider"></div>
                <div class="la-prescription-fields-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
                    <div class="la-flex la-column-gap-1-5">
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-pd-field" value="Single PD" class="la-pd-field" id="la-pd-field-single" ${pdType == "Single PD" ? "checked" : ""}>
                            <label class="la-form-field-label" for="la-pd-field-single">${this.Translation.getTranslatedText("Single PD")}</label>
                        </div>
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                            <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Dual PD")}</label>
                        </div>
                    </div>
                    <div class="la-form-flex la-column-gap-1-5 la-pd-form" id="la-pd-fields-container">
                        ${pdType == "Single PD" ? `<div class="la-form-item la-mt-1">
                            <select class="la-form-select" name="la-pd-value" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="value" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.singlePD.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.pd.value == value ? "selected" : ""}
                                >${value}</option>`).join("")}
                            </select>
                        </div>
                        ${this.options.showLunaPDTool ? `<div class="la-form-item la-mt-1">
                            <a class="la-luna-pd-btn" id="la-luna-pd-btn">${this.Translation.getTranslatedText('Find your PD')}</a>
                        </div>` : ''}` : `<div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Right")}</label>
                            <select class="la-form-select" name="la-pd-right" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="right" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${this.response.manually.pd.right == value.toFixed(2) ? "selected" : ""}
                                >${value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>
                        <div class="la-form-item">
                            <label class="la-form-helper-label">${this.Translation.getTranslatedText("Left")}</label>
                            <select class="la-form-select" name="la-pd-left" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="left" data-eval="pd">
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.dualPD.map(value => `<option
                                    value="${value.toFixed(2)}"
                                    ${this.response.manually.pd.left == value.toFixed(2) ? "selected" : ""}
                                >${value.toFixed(2)}</option>`).join("")}
                            </select>
                        </div>`}
                    </div>
                </div>`: ''}
                ${showSegmentHeight && LensAdvizor.response.prescriptionType === "progressive" ? `<div class="la-divider"></div>
                <div class="la-prescription-fields-wrapper la-segment-height-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("Segment Height")}</h6>
                    <div class="la-form-flex la-column-gap-1-5">
                        <div class="la-form-item">
                            <select class="la-form-select" name="la-segment-height" data-field="segment_height" ${prescriptionConfig.segmentHeight == true ? "required" :""}>
                                <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                ${this.options.fieldValues.segmentHeight.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.segment_height == value ? "selected" : ""}
                                >${value}</option>`).join(",")}
                            </select>
                        </div>
                    </div>
                </div>` : ""}
                ${prescriptionConfig.prismRequired ? `<div class="la-divider"></div>
                <div class="la-prescription-fields-wrapper">
                    <h6 class="la-h6">${this.Translation.getTranslatedText("Prism Values")}</h6>
                    <div class="la-flex la-column-gap-1-5">
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-prism-field" value="none" class="la-prism-field" id="la-prism-field-single" ${this.response.manually.prismRequired ? '' : 'checked'}>
                            <label class="la-form-field-label" for="la-prism-field-single">${this.Translation.getTranslatedText("No")}</label>
                        </div>
                        <div class="la-flex la-column-gap-5">
                            <input type="radio" name="la-prism-field" value="" class="la-prism-field" id="la-prism-field-dual" ${this.response.manually.prismRequired ? 'checked' : ''}>
                            <label class="la-form-field-label" for="la-prism-field-dual">${this.Translation.getTranslatedText("Yes")}</label>
                        </div>
                    </div>
                </div>
                <div id="la-prescription-prism-wrapper">${this.response.manually.prismRequired ? this.getPrismFields() : ''}</div>` : ""}
                ${showSelfie ? `<div class="la-divider"></div>
                    <lensadvizor-selfie
                        required="${prescriptionConfig.selfiedOnEntry == true ? 'required' : ''}"
                    ></lensadvizor-selfie>
                ` : ''}
                ${showUpload ? `<div class="la-divider"></div>
                <div class="la-upload-wrapper" style="margin-bottom: 1.5rem">
                    <input type="file" id="la-prescription-file" name="la-prescription-file" class="la-hidden" accept="image/png, image/jpeg, application/pdf" ${prescriptionConfig.uploadRequiredOnManualEntry ? 'required' : ''}>
                    <p class="la-information la-text-left">
                        ${this.Translation.getTranslatedText("Upload your prescription for us to confirm that you have entered it correctly")} ${prescriptionConfig.uploadRequiredOnManualEntry ? "." : `(${this.Translation.getTranslatedText("Optional")}).`}
                    </p>
                    <label for="la-prescription-file" class="la-label-btn la-prescription-file-label">
                        ${this.svg.attachment}
                        <span style="margin: auto">
                            ${this.response.prescription ? this.Translation.getTranslatedText("Change") : this.Translation.getTranslatedText("Choose File")}
                        </span>
                    </label>
                    <p class="la-information" id="la-prescription-upload-message">
                        ${this.response.prescription ? `${this.svg.check} ${this.response.prescription.originalName}` : ''}
                    </p>
                </div>` : ''}
            </div>
        </form>`

        document.querySelectorAll('input[name="la-pd-field"]').forEach(input => input.addEventListener("change", this.handlePDTypeChange.bind(this)))
        document.querySelectorAll('input[name="la-prism-field"]').forEach(input => input.addEventListener("change", this.handlePrismOptionChange.bind(this)))
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))

        if (showPD && this.options.showLunaPDTool && pdType == "Single PD") {
            document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
        }

        const prescriptionFileInput = document.querySelector("#la-prescription-file")
        if (prescriptionFileInput) {
            prescriptionFileInput.addEventListener("change", this.handlePrescriptionUpload.bind(this))
        }

        if (this.response.prescription) {
            fetch(this.response.prescription.blob) 
            .then(r => r.blob())
            .then(function(blob) {
                const fileField = document.querySelector("#la-prescription-file")
                const dataTransfer = new DataTransfer()
                const existingPrescriptionFile = new File([this.response.prescription.blob], this.response.prescription.originalName, {
                    type: this.response.prescription.type
                })
                dataTransfer.items.add(existingPrescriptionFile)
                fileField.files = dataTransfer.files
            }.bind(this));
        }
        this._component__DidMount('LensAdvizor:render:manualEntryForm', {method: "renderManualEntryForm"})
    },
    renderBoxyLayoutManualEntryForm: function() {
        this._component__WillMount('LensAdvizor:render:manualEntryForm', {method: "renderManualEntryForm"})
        this.updateState(this.renderManualEntryForm.bind(this), true)

        const prescriptionConfig = this.options.prescriptionConfig
        this.setManualResponseFromLocalStorage(prescriptionConfig)

        const pdType = this.response.manually.pd.type
        const showPD = prescriptionConfig.pdRequired !== "hidden"
        const showSegmentHeight = prescriptionConfig.segmentHeight !== "hidden"
        const showUpload = prescriptionConfig.uploadRequiredOnManualEntry !== "hidden"
        const showSelfie = prescriptionConfig.selfiedOnEntry !== undefined && prescriptionConfig.selfiedOnEntry !== "hidden";

        this.contentBox.innerHTML =  `<form class="la-prescription-wrapper" id="la-prescription-form" data-form="manually" novalidate="true">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Enter Your Prescription Manually")}</h3>
            </div>
            <div class="la-fields-wrapper">
                <table>
                    <thead>
                        <tr class="la-prescription-fields-wrapper">
                            <td></td>
                            ${prescriptionConfig.formFields.showSph ? `<td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("SPH")}</h6>
                            </td>` : ''}
                            ${prescriptionConfig.formFields.showCyl ? `<td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("CYL")}</h6>
                            </td>` : ''}
                            ${prescriptionConfig.formFields.showAxis ? `<td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("AXIS")}</h6>
                            </td>` : ''}
                            ${prescriptionConfig.formFields.showAdd ? `<td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("ADD")}</h6>
                            </td>` : ''}
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="la-prescription-fields-wrapper">
                            <td class="la-td-text-left"><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('OD (Right)')}</h6></td>
                            ${prescriptionConfig.formFields.showSph ? `<td>
                                <select class="la-form-select" id="la-odright-sph" name="la-odright-sph" data-field="sph" data-eval="od_right" required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.sph.map(value => `<option
                                        value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.od_right.sph) == value ? "selected" : ""}
                                    >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showCyl ? `<td>
                                <select class="la-form-select" id="la-odright-cyl" name="la-odright-cyl" data-field="cyl" data-eval="od_right" required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.cyl.map(value => `<option
                                        value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.od_right.cyl) == value ? "selected" : ""}
                                    >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showAxis ? `<td>
                                <select class="la-form-select" id="la-odright-axis" name="la-odright-axis" data-field="axis" data-eval="od_right" ${this.response.manually.od_right.axis ? '' : ' disabled'} required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.axis.map(value => `<option
                                        value="${value}"
                                        ${this.response.manually.od_right.axis != "" && Number(this.response.manually.od_right.axis) === value ? "selected" : ""}
                                    >${value}</option>`).join("")}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showAdd ? `<td>
                                <select
                                    class="la-form-select"
                                    id="la-odright-add"
                                    name="la-odright-add"
                                    data-field="add"
                                    data-eval="od_right"
                                    ${prescriptionConfig.showAdd}
                                >
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.add.map(value => `<option
                                        value="${value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.od_right.add) == value ? "selected" : ""}
                                    >${value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                        </tr>
                        <tr class="la-prescription-fields-wrapper">
                            <td class="la-td-text-left"><h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText('OS (Left)')}</h6></td>
                            ${prescriptionConfig.formFields.showSph ? `<td>
                                <select class="la-form-select" id="la-odleft-sph" name="la-odleft-sph" data-field="sph" data-eval="os_left" required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.sph.map(value => `<option
                                        value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.os_left.sph) == value ? "selected" : ""}
                                    >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showCyl ? `<td>
                                <select class="la-form-select" id="la-odleft-cyl" name="la-odleft-cyl" data-field="cyl" data-eval="os_left" required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.cyl.map(value => `<option
                                        value="${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.os_left.cyl) == value ? "selected" : ""}
                                    >${value > 0 ? `+${value.toFixed(2)}` : value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showAxis ? `<td>
                                <select class="la-form-select" id="la-odleft-axis" name="la-odleft-axis" data-field="axis" data-eval="os_left" ${this.response.manually.os_left.axis ? '' : ' disabled'} required>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.axis.map(value => `<option
                                        value="${value}"
                                        ${this.response.manually.os_left.axis != "" && Number(this.response.manually.os_left.axis) === value ? "selected" : ""}
                                    >${value}</option>`)}
                                </select>
                            </td>`: ''}
                            ${prescriptionConfig.formFields.showAdd ? `<td>
                                <select class="la-form-select" id="la-odleft-add" name="la-odleft-add" data-field="add" data-eval="os_left" ${prescriptionConfig.showAdd}>
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.add.map(value => `<option
                                        value="${value.toFixed(2)}"
                                        ${parseFloat(this.response.manually.os_left.add) == value ? "selected" : ""}
                                    >${value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`: ''}
                        </tr>
                        ${showPD ? `<tr class="la-prescription-fields-wrapper" id="la-pd-fields-container">
                            <td class="la-td-text-left">
                                <h6 class="la-h6 la-td-text-left">
                                    ${this.Translation.getTranslatedText("Pupillary Distance (PD)")}
                                </h6>
                            </td>
                            ${pdType == "Single PD" ? `<td colspan="2">
                                <select class="la-form-select" name="la-pd-value" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="value" data-eval="pd">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.singlePD.map(value => `<option
                                    value="${value}"
                                        ${this.response.manually.pd.value == value ? "selected" : ""}
                                    >${value}</option>`).join("")}
                                </select>
                                ${this.options.showLunaPDTool ? `<a class="la-luna-pd-btn" id="la-luna-pd-btn">${this.Translation.getTranslatedText('Find your PD')}</a>` : ''}
                            </td>`: `<td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("Right")}</h6>
                                <select class="la-form-select" name="la-pd-right" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="right" data-eval="pd">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.dualPD.map(value => `<option
                                        value="${value.toFixed(2)}"
                                        ${this.response.manually.pd.right == value.toFixed(2) ? "selected" : ""}
                                    >${value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>
                            <td>
                                <h6 class="la-h6">${this.Translation.getTranslatedText("Left")}</h6>
                                <select class="la-form-select" name="la-pd-left" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="left" data-eval="pd">
                                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                                    ${this.options.fieldValues.dualPD.map(value => `<option
                                        value="${value.toFixed(2)}"
                                        ${this.response.manually.pd.left == value.toFixed(2) ? "selected" : ""}
                                    >${value.toFixed(2)}</option>`).join("")}
                                </select>
                            </td>`}
                            <td colspan="2">
                                <div class="la-flex la-column-gap-1-5">
                                    <input type="checkbox" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                                    <label class="la-form-field-label" for="la-pd-field-dual">${this.Translation.getTranslatedText("Have two PDs")}</label>
                                </div>
                            </td>
                        </tr>` : ''}
                    </tbody>
                </table>
            </div>
            ${showSegmentHeight && LensAdvizor.response.prescriptionType === "progressive" ? `<div class="la-fields-wrapper">
                <table>
                    <tr class="la-prescription-fields-wrapper la-segment-height-wrapper">
                        <td>
                            <h6 class="la-td-text-left la-h6">
                                ${this.Translation.getTranslatedText("Segment Height")}
                            </h6>
                        </td>
                        <td colspan="1">
                            <select class="la-form-select" name="la-segment-height" data-field="segment_height" ${prescriptionConfig.segmentHeight == true ? "required" :""}>
                                <option class="la-option-select" value="">
                                    ${this.Translation.getTranslatedText("Choose")}
                                </option>
                                ${this.options.fieldValues.segmentHeight.map(value => `<option
                                    value="${value}"
                                    ${this.response.manually.segment_height == value ? "selected" : ""}
                                >${value}</option>`).join(",")}
                            </select>
                        </td>
                        <td colspan="3"></td>
                    </tr>
                </table>
            </div>` : ""}

            ${prescriptionConfig.prismRequired ? `<div class="la-fields-wrapper" style="border: none; padding-bottom: 0; margin-top: 0;">
                <div class="la-prescription-fields-wrapper">
                    <div class="la-form-flex la-column-gap-1-5">
                        <div class="la-form-item la-ignore">
                            <div class="la-flex la-column-gap-1-5">
                                <div class="la-flex la-column-gap-5">
                                    <input type="checkbox" name="la-prism-field" value="" class="la-prism-field" id="la-prism-field-dual" ${this.response.manually.prismRequired ? 'checked' : ''}>
                                    <label class="la-form-field-label" for="la-prism-field-dual">${this.Translation.getTranslatedText("Add Prism")}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="la-fields-wrapper la-prism-wrapper" style="display: none;">
                <div id="la-prescription-prism-wrapper">${this.response.manually.prismRequired ? this.getPrismFields() : ''}</div>
            </div>` : ""}
            ${showSelfie ? `<div class="la-fields-wrapper" style="padding: 0;">
                <div class="la-upload-wrapper" style="${showUpload ? '' : `margin-bottom: 1.5rem`}">
                    <lensadvizor-selfie
                        required="${prescriptionConfig.selfiedOnEntry == true ? 'required' : ''}"
                    ></lensadvizor-selfie>
                </div>
            </div>` : ''}
            ${showUpload ? `<div class="la-fields-wrapper" style="border: none; margin: auto;">
                <div class="la-upload-wrapper" style="margin-bottom: 1.5rem">
                    <input type="file" id="la-prescription-file" name="la-prescription-file" class="la-hidden" accept="image/png, image/jpeg, application/pdf" ${prescriptionConfig.uploadRequiredOnManualEntry ? 'required' : ''}>
                    <p class="la-information la-text-left">
                        ${this.Translation.getTranslatedText("Upload your prescription for us to confirm that you have entered it correctly")} ${prescriptionConfig.uploadRequiredOnManualEntry ? "." : `(${this.Translation.getTranslatedText("Optional")}).`}
                    </p>
                    <label for="la-prescription-file" class="la-label-btn la-prescription-file-label">
                        ${this.svg.attachment}
                        <span style="margin: auto">
                            ${this.response.prescription ? this.Translation.getTranslatedText("Change") : this.Translation.getTranslatedText("Choose File")}
                        </span>
                    </label>
                    <p class="la-information" id="la-prescription-upload-message">
                        ${this.response.prescription ? `${this.svg.check} ${this.response.prescription.originalName}` : ''}
                    </p>
                </div>
            </div>` : ''}
        </form>`

        document.querySelectorAll('input[name="la-pd-field"]').forEach(input => input.addEventListener("change", this.handleBoxyPDTypeChange.bind(this)))
        document.querySelectorAll('input[name="la-prism-field"]').forEach(input => input.addEventListener("change", this.handlePrismOptionChange.bind(this)))
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))

        if (this.options.showLunaPDTool && pdType == "Single PD") {
            document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
        }

        const prescriptionFileInput = document.querySelector("#la-prescription-file")
        if (prescriptionFileInput) {
            prescriptionFileInput.addEventListener("change", this.handlePrescriptionUpload.bind(this))
        }

        if (this.response.prescription) {
            fetch(this.response.prescription.blob) 
            .then(r => r.blob())
            .then(function(blob) {
                const fileField = document.querySelector("#la-prescription-file")
                const dataTransfer = new DataTransfer()
                const existingPrescriptionFile = new File([this.response.prescription.blob], this.response.prescription.originalName, {
                    type: this.response.prescription.type
                })
                dataTransfer.items.add(existingPrescriptionFile)
                fileField.files = dataTransfer.files
            }.bind(this));
        }

        this._component__DidMount('LensAdvizor:render:manualEntryForm', {method: "renderManualEntryForm"})
    },
    handleBoxyPDTypeChange: function(e) {
        this.response.manually.pd.type = e.target.checked ? e.target.value : 'Single PD'
        const selectedVariant = this.variants[this.selectedOrDefaultVariant];
        const pdFieldContainer = document.querySelector("#la-pd-fields-container")
        const prescriptionConfig = this.options.prescriptionConfig
        const pdType = this.response.manually.pd.type

        if (pdType == "Single PD") {
            pdFieldContainer.innerHTML = `<td>
                <h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
            </td>
            <td colspan="2">
                <select class="la-form-select" name="la-pd-value" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="value" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.singlePD.map(value => `<option
                    value="${value}"
                        ${this.response.manually.pd.value == value ? "selected" : ""}
                    >${value}</option>`).join("")}
                </select>
                ${this.options.showLunaPDTool ? `<a class="la-luna-pd-btn" id="la-luna-pd-btn">${this.Translation.getTranslatedText('Find your PD')}</a>` : ''}
            </td>
            <td colspan="2">
                <div class="la-flex la-column-gap-1-5">
                    <input type="checkbox" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                    <label class="la-form-field-label" for="la-pd-field-dual">
                        ${this.Translation.getTranslatedText("Have two PDs")}
                    </label>
                </div>
            </td>`
            this.response.manually.pd.left = null
            this.response.manually.pd.right = null
            if (this.options.showLunaPDTool) {
                document.querySelector("#la-luna-pd-btn").addEventListener("click", this.Luna.handleGlassesOnOpen.bind(this))
            }
        } else {
            this.response.manually.pd.value = null
            pdFieldContainer.innerHTML = `<td>
                <h6 class="la-h6 la-td-text-left">${this.Translation.getTranslatedText("Pupillary Distance (PD)")}</h6>
            </td>
            <td>
                <h6 class="la-h6">${this.Translation.getTranslatedText("Right")}</h6>
                <select class="la-form-select" name="la-pd-right" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="right" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.dualPD.map(value => `<option
                        value="${value.toFixed(2)}"
                        ${this.response.manually.pd.right == value.toFixed(2) ? "selected" : ""}
                    >${value.toFixed(2)}</option>`).join("")}
                </select>
            </td>
            <td>
                <h6 class="la-h6">${this.Translation.getTranslatedText("Left")}</h6>
                <select class="la-form-select" name="la-pd-left" ${prescriptionConfig.pdRequired == true ? "required" : ""} data-field="left" data-eval="pd">
                    <option class="la-option-select" value="">${this.Translation.getTranslatedText("Choose")}</option>
                    ${this.options.fieldValues.dualPD.map(value => `<option
                        value="${value.toFixed(2)}"
                        ${this.response.manually.pd.left == value.toFixed(2) ? "selected" : ""}
                    >${value.toFixed(2)}</option>`).join("")}
                </select>
            </td>
            <td colspan="2">
                <div class="la-flex la-column-gap-1-5">
                    <input type="checkbox" name="la-pd-field" value="Dual PD" class="la-pd-field" id="la-pd-field-dual" ${pdType == "Dual PD" ? "checked" : ""}>
                    <label class="la-form-field-label" for="la-pd-field-dual">
                        ${this.Translation.getTranslatedText("Have two PDs")}
                    </label>
                </div>
            </td>`
        }
        document.querySelectorAll('input[name="la-pd-field"]').forEach(input => input.addEventListener("change", this.handleBoxyPDTypeChange.bind(this)))
        document.querySelectorAll('.la-form-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
    },
    renderProviderForm: function() {
        this._component__WillMount('LensAdvizor:render:providerForm', {method: "renderProviderForm"})
        this.updateState(this.renderProviderForm.bind(this), true)

        const { provider } = this.response.manually;

        this.contentBox.innerHTML = `<form class="la-prescription-wrapper" id="la-prescription-form" data-form="provider" novalidate="true">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Have us contact your doctor")}</h3>
            </div>
            <div class="la-prescription-fields-wrapper">
                <h6 class="la-h6">${this.Translation.getTranslatedText("Your info")}</h6>
                <div class="la-form-fields">
                    <div class="la-form-item">
                        <label class="la-form-helper-label la-text-transform-initial">
                            ${this.Translation.getTranslatedText("First and last name")}
                        </label>
                        <input
                            class="la-form-input"
                            type="text" value="${provider.customerName}"
                            name="la-customerName"
                            data-eval="provider"
                            data-field="customerName"
                            required
                        >
                    </div>
                    <div class="la-form-item">
                        <label class="la-form-helper-label la-text-transform-initial">
                            ${this.Translation.getTranslatedText("Date of birth")}
                        </label>
                        <input
                            class="la-form-input"
                            type="text" value="${provider.dateOfBirth}"
                            name="la-dateOfBirth"
                            data-eval="provider"
                            data-field="dateOfBirth"
                            required
                        >
                    </div>
                </div>
            </div>
            <div class="la-divider"></div>
            <div class="la-prescription-fields-wrapper">
                <h6 class="la-h6">${this.Translation.getTranslatedText("Your doctor's info")}</h6>
                <div class="la-form-fields">
                    <div class="la-form-item">
                        <label class="la-form-helper-label la-text-transform-initial">
                            ${this.Translation.getTranslatedText("Doctor's name")}
                        </label>
                        <input
                            class="la-form-input"
                            type="text" value="${provider.doctorName}"
                            name="la-doctorName"
                            data-eval="provider"
                            data-field="doctorName"
                            required
                        >
                    </div>
                    <div class="la-form-item">
                        <label class="la-form-helper-label la-text-transform-initial">
                            ${this.Translation.getTranslatedText("Address")}
                        </label>
                        <input
                            class="la-form-input"
                            type="text" value="${provider.doctorAddress}"
                            name="la-doctorAddress"
                            data-eval="provider"
                            data-field="doctorAddress"
                            required
                        >
                    </div>
                    <div class="la-form-item">
                        <label class="la-form-helper-label la-text-transform-initial">
                            ${this.Translation.getTranslatedText("Doctor's phone number")}
                        </label>
                        <input
                            class="la-form-input"
                            type="text" value="${provider.doctorPhoneNo}"
                            name="la-doctorPhoneNo"
                            data-eval="provider"
                            data-field="doctorPhoneNo"
                            required
                        >
                    </div>
                </div>
            </div>
        </form>`

        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))
        document.querySelectorAll('.la-form-input').forEach(input => input.addEventListener("change", this.handleFormSelectChange.bind(this)))

        this._component__DidMount('LensAdvizor:render:providerForm', {method: "renderProviderForm"})
    },
    handlePrismOptionChange: function(e) {
        const prismWrapper = document.querySelector("#la-prescription-prism-wrapper")
        if (event.target.type == "radio") {
            this.response.manually.prismRequired = e.target.value === ""
        } else {
            this.response.manually.prismRequired = e.target.checked
        }

        if (this.response.manually.prismRequired && prismWrapper) {
            const selectedVariant = this.variants[this.selectedOrDefaultVariant];
            if (document.querySelector('.la-fields-wrapper.la-prism-wrapper')) {
                document.querySelector('.la-fields-wrapper.la-prism-wrapper').style.display = selectedVariant.settings.layout.type == "horizontal-boxy" ? 'table' : 'block';
            }
            prismWrapper.innerHTML = this.getPrismFields()

            document.querySelectorAll('.la-prism-select').forEach(select => select.addEventListener("change", this.handleFormSelectChange.bind(this)))
            prismWrapper.scrollIntoViewIfNeeded()
        } else {
            if (document.querySelector('.la-fields-wrapper.la-prism-wrapper')) {
                document.querySelector('.la-fields-wrapper.la-prism-wrapper').style.display = 'none';
            }
            if (prismWrapper) {
                prismWrapper.innerHTML = ''
            }
            this.response.manually.prism_fields = {
                od_right: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null},
                os_left: {horizontal: null, base_direction_horizontal: null, vertical: null, base_direction_vertical: null}
            }
        }
    },
    async getPrescriptionLenses() {
        this.loader.style.display = ""
        let queryParams = {
            prescription_type: this.response.prescriptionType,
            prescription_id: this.response.selectedPrescriptionType.id,
            api_version: 2
        }

        if (this.response.method === 'entered_manually') {
            queryParams.method = this.response.method
            queryParams.settings = JSON.stringify(this.getPrescriptionRequestData())
        } else if (this.response.method === 'uploaded' && this.options.prescriptionConfig.pdOnUpload !== "hidden") {
            queryParams.method = this.response.method
            queryParams.settings = JSON.stringify(this.getPrescriptionRequestData())
        } else if (this.lenses.length > 0) {
            this.prices.addons = null
            return this.lenses
        }

        const lensURL = this.addQueryParamsToURL(LensAdvizor.API_URL + "/collection/" + this.collectionId + '/items/', queryParams)
        let response = await fetch(lensURL)
        this.lenses = await response.json()
        this.lensesByGroups = {}
        this.lensGroups.forEach(lensGroup => {
            let groupLenses = this.lenses.filter(lens => lens.group_type === lensGroup.group_type)
            this.lensesByGroups[lensGroup.group_type] = groupLenses
        })

        // Preloading all the lens and lens options images
        const images = [];
        this.lenses.forEach(lens => {
            lens.images.forEach(img => images.push(img.src))

            let pictureMatrix = lens.metafield?.picture_matrix || {}
            pictureMatrix = JSON.stringify(pictureMatrix[this.productId] || {});
            const lensOptions = JSON.stringify(lens.raw_options);

            const pictureMatrixImages = pictureMatrix.match(/https:\/\/[^"]*/g);
            const lensOptionsImages = lensOptions.match(/https:\/\/[^"]*/g);

            if (pictureMatrixImages) {
                images.push(...pictureMatrixImages);
            }

            if (lensOptionsImages) {
                images.push(...lensOptionsImages);
            }
        })

        images.forEach((img, index) => {
            images[index] = this.preloadImage(img)
        })

        this.presentmentPrices = await this.getPresentmentPrices(this.lenses)
        return this.lenses
    },
    async getItemGroups(callback) {
        this.loader.style.display = ""
        const queryParams = {
            fields: 'group_type,title,description,image,order,item_count,metafield,metafields',
            prescription_type: this.response.prescriptionType,
            prescription_id: this.response.selectedPrescriptionType.id,
            api_version: 2
        }
        const lensGroupURL = this.addQueryParamsToURL(LensAdvizor.API_URL + "/collection/" + this.collectionId + '/items/groups/', queryParams)
        fetch(lensGroupURL)
        .then(r => r.json())
        .then(function(lensGroups) {
            this.lensGroups = lensGroups.filter(group => group.item_count > 0)
            if (callback) {
                callback()
            }
        }.bind(this))
    },
    async getPresentmentPrices(items) {
        productIds = new Set([LensAdvizor.productId, ...LensAdvizor.customProductIds])

        if (items) {
            items.forEach(item => {
                productIds.add(item.shopify_id)
                item.add_ons_products.forEach(addOn => addOn.product_ids.forEach(productId => {
                    productIds.add(productId)
                }))
            })
        }

        const queryParams = {
            shop: Shopify.shop,
            products: Array.from(productIds).join(","),
            currencies: this.options.default_currency === Shopify.currency.active ? Shopify.currency.active : `${this.options.default_currency},${Shopify.currency.active}`,
            api_version: 2
        }
        let response = await fetch(this.addQueryParamsToURL(LensAdvizor.API_URL + '/collection/variants/', queryParams))
        response = await response.json()
        return response
    },
    async renderHeaderLenses() {
        let self = this;
        const lenses = await this.getPrescriptionLenses()
        this._component__WillMount('LensAdvizor:lens:rendered', {method: "renderHeaderLenses"})
        this.loader.style.display = "none"

        let contentHTML = "";

        if (lenses.length == 0) {
            contentHTML = `<p class="la-text-center">${this.Translation.getTranslatedText("No lenses found")}</p>
                <button class="la-prescription-form-btn" id="la-back-btn">
                    ${this.Translation.getTranslatedText("Go Back")}
                </button>
            `
        } else if (lenses.length == 1 && this.options.prescriptionConfig.skipPrescriptionLenses) {
            return this.handleLensChange()
        } else {
            contentHTML = this.lensGroups.map((group, index) => {
                const groupedLenses = this.lensesByGroups[group.group_type]

                if (groupedLenses.length) {
                    return `<div class="la-lensgroup-wrapper">
                        <div class="la-lensgroup-header">
                            ${group.metafield && group.metafield.toolTip ? this.getToolTipLayout(group.metafield.toolTip) : ''}
                            ${group.image ? `<div class="la-lensgroup-header-image">
                                <img src='${group.image}' srcset='${group.image} 60w ${group.image} 90w ${group.image} 45w'>
                            </div>` : ''}
                            <div class>
                                <h3 class="la-lensgroup-title">
                                    ${this.Translation.getTranslatedText(group.title)}
                                </h3>
                                ${group.description ? `<p>${this.Translation.getTranslatedText(group.description)}</p>` : ''}
                            </div>
                        </div>
                        ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `<div class="la-horizontal-boxy-layout-wrapper la-horizontal-boxy-lenses-wrapper">`: ''}

                        ${groupedLenses.map(lens => {
                            const recommendationBadgeMetafield = lens.metafields.find(item => ["_showRecommendationBadge", "showRecommendationBadge"].includes(item.key))
                            return self.getButtonLayout({
                                title: lens.name,
                                image: lens.images.length > 0 ? lens.images[0].src : "",
                                name: lens.name.generateId(lens.id),
                                description: lens.description || "",
                                price: this.getLensPrice(lens),
                                compareAtPrice: lens.variants[0].compare_at_price,
                                value: lens.id,
                                showRecommendationBadge: recommendationBadgeMetafield && recommendationBadgeMetafield.value.toLowerCase() === "true",
                                tooltip: lens.metafield && lens.metafield.toolTip ? lens.metafield.toolTip : undefined
                            })
                        }).join("")}
                        ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `</div>`: ''}
                    </div>

                    ${index + 1 < this.lensGroups.length ? '<div class="la-divider"></div>' : ''}`
                }
            }).join("")
        }

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-lenses">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Choose Your Lenses")}</h3>
            </div>
            ${contentHTML}
        </div>`
        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.handleLensChange.bind(this)))
        if (document.querySelector("#la-back-btn")) {
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.stepIndex -= 1
                this.navigationSteps.splice(this.stepIndex, 1);
                return this.navigation[this.stepIndex]()
            }.bind(this))
        }

        if (lenses.length != 1 || !this.options.prescriptionConfig.skipPrescriptionLenses) {
            this.updateState(this.renderHeaderLenses.bind(this))
        }
        this._component__DidMount('LensAdvizor:lens:rendered', {method: "renderHeaderLenses"})
    },
    getLensPrice(lens) {
        if (!lens.is_depricated_item && lens.show_exact_pricing) {
            if (Object.keys(lens.options).length > 1) {
                return this.Currency.convert(parseFloat(lens.lens_base_price), this.options.default_currency, Shopify.currency.active)
            }
        } else {
            return this.convertCurrency(lens.shopify_id, lens.variants[0].variant_id, lens.price)
        }
    },
    async renderAccordionLenses() {
        let self = this;
        const lenses = await this.getPrescriptionLenses()
        this._component__WillMount('LensAdvizor:lens:rendered', {method: "renderAccordionLenses"})
        this.loader.style.display = "none"
        let contentHTML = "";

        if (lenses.length == 0) {
            contentHTML = `<p class="la-text-center">${this.Translation.getTranslatedText("No lenses found")}</p>
                <button class="la-prescription-form-btn" id="la-back-btn">
                    ${this.Translation.getTranslatedText("Go Back")}
                </button>
            `
        } else if (lenses.length == 1 && this.options.prescriptionConfig.skipPrescriptionLenses) {
            return this.handleLensChange()
        } else {
            contentHTML = this.lensGroups.map(group => {
                const groupedLenses = this.lensesByGroups[group.group_type]

                if (groupedLenses.length) {
                    return `<div class="la-accordion-wrapper">
                        <div class="la-accordion-head la-label-btn">
                            ${group.metafield && group.metafield.toolTip ? this.getToolTipLayout(group.metafield.toolTip) : ''}
                            ${group.image ? `<div class="la-lensgroup-header-image">
                                <img src='${group.image}' srcset='${group.image} 60w ${group.image} 90w ${group.image} 45w'>
                            </div>` : ''}
                            <div class>
                                <h3 class="la-lensgroup-title">
                                    ${this.Translation.getTranslatedText(group.title)}
                                </h3>
                                ${group.description ? `<p class="la-label-description">${this.Translation.getTranslatedText(group.description)}</p>` : ''}
                            </div>
                        </div>
                        <div class="la-accordion-body">
                            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `<div class="la-horizontal-boxy-layout-wrapper la-horizontal-boxy-lenses-wrapper">`: ''}
                            ${groupedLenses.map(lens => {
                                const recommendationBadgeMetafield = lens.metafields.find(item => ["_showRecommendationBadge", "showRecommendationBadge"].includes(item.key))
                                return self.getButtonLayout({
                                    title: lens.name,
                                    image: lens.images.length > 0 ? lens.images[0].src : "",
                                    name: lens.name.generateId(lens.id),
                                    description: lens.description || "",
                                    price: this.getLensPrice(lens),
                                    compareAtPrice: lens.variants[0].compare_at_price,
                                    value: lens.id,
                                    showRecommendationBadge: recommendationBadgeMetafield && recommendationBadgeMetafield.value.toLowerCase() === "true",
                                    tooltip: lens.metafield && lens.metafield.toolTip ? lens.metafield.toolTip : undefined
                                })
                            }).join("")}
                            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `</div>`: ''}
                        </div>
                    </div>`
                }
            }).join("")
        }

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-lenses">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Choose Your Lenses")}</h3>
            </div>
            ${contentHTML}
        </div>`

        const accordionHeads = document.getElementsByClassName("la-accordion-head");
        Array.from(accordionHeads).forEach((accordionHead, index) => accordionHead.addEventListener("click", function(event) {
            let element = event.target;
            if (!element.classList.contains("la-label-btn")) {
                element = element.closest(".la-label-btn")
            }

            element.classList.toggle("active");
            var accordionBody = element.nextElementSibling;
            if (accordionBody.style.maxHeight) {
                accordionBody.style.maxHeight = null;
            } else {
                accordionBody.style.maxHeight = accordionBody.scrollHeight + 150 + "px";
            } 
        }.bind(this)))
        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.handleLensChange.bind(this)))
        if (document.querySelector("#la-back-btn")) {
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.stepIndex -= 1
                this.navigationSteps.splice(this.stepIndex, 1);
                return this.navigation[this.stepIndex]()
            }.bind(this))
        }

        if (lenses.length != 1 || !this.options.prescriptionConfig.skipPrescriptionLenses) {
            this.updateState(this.renderAccordionLenses.bind(this))
        }
        this._component__DidMount('LensAdvizor:lens:rendered', {method: "renderAccordionLenses"})
    },
    async renderLenses() {
        let self = this;
        if (this.response.lensGroupSelected && this.options.prescriptionConfig.lensGroupDisplayType) {
            lenses = this.lensesByGroups[this.response.lensGroupSelected]
        } else {
            const all_lenses = await this.getPrescriptionLenses()
            lenses = []
            this.lensGroups.map(group => this.lensesByGroups[group.group_type].map(lens => lenses.push(lens)))
        }

        this.loader.style.display = "none"
        let contentHTML = "";

        if (lenses.length == 0) {
            contentHTML = `<p class="la-text-center">${this.Translation.getTranslatedText("No lenses found")}</p>
                <button class="la-prescription-form-btn" id="la-back-btn">
                    ${this.Translation.getTranslatedText("Go Back")}
                </button>
            `
        } else if (lenses.length == 1 && this.options.prescriptionConfig.skipPrescriptionLenses) {
            return this.handleLensChange()
        } else {
            contentHTML = lenses.map(lens => {
                const recommendationBadgeMetafield = lens.metafields.find(item => ["_showRecommendationBadge", "showRecommendationBadge"].includes(item.key))
                return this.getButtonLayout({
                    title: lens.name,
                    image: lens.images.length > 0 ? lens.images[0].src : "",
                    name: lens.name.generateId(lens.id),
                    description: lens.description || "",
                    price: this.getLensPrice(lens),
                    compareAtPrice: lens.variants[0].compare_at_price,
                    value: lens.id,
                    showRecommendationBadge: recommendationBadgeMetafield && recommendationBadgeMetafield.value.toLowerCase() === "true",
                    tooltip: lens.metafield && lens.metafield.toolTip ? lens.metafield.toolTip : undefined
                })
            }).join("")
        }

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-lenses">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Choose Your Lenses")}</h3>
            </div>
            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `<div class="la-horizontal-boxy-layout-wrapper la-horizontal-boxy-lenses-wrapper">`: ''}
                ${contentHTML}
            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `</div>`: ''}
        </div>`

        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.handleLensChange.bind(this)))
        this._component__DidMount('LensAdvizor:lens:rendered', {method: "renderLenses"})
        if (document.querySelector("#la-back-btn")) {
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.stepIndex -= 1
                this.navigationSteps.splice(this.stepIndex, 1);
                return this.navigation[this.stepIndex]()
            }.bind(this))
        }

        if (lenses.length != 1 || !this.options.prescriptionConfig.skipPrescriptionLenses) {
            this.updateState(this.renderLenses.bind(this))
        }
    },
    async renderLensGroup() {
        this.response.lensGroupSelected = undefined;
        let self = this;
        const lenses = await this.getPrescriptionLenses()
        this._component__WillMount('LensAdvizor:lens:rendered', {method: "renderLensGroup"})
        let contentHTML = "";

        if (lenses.length == 0) {
            contentHTML = `<p class="la-text-center">${this.Translation.getTranslatedText("No lenses found")}</p>
                <button class="la-prescription-form-btn" id="la-back-btn">
                    ${this.Translation.getTranslatedText("Go Back")}
                </button>
            `
        } else {
            contentHTML += this.options.variantConfig.layout.type == "horizontal-boxy" ? '<div class="la-horizontal-boxy-layout-wrapper">': ''
            contentHTML += this.lensGroups.map(group => this.getButtonLayout({
                title: group.title,
                image: group.image || "",
                name: group.title.generateId(),
                description: group.description || "",
                value: group.group_type,
                tooltip: group.metafield && group.metafield.toolTip ? group.metafield.toolTip : undefined
            })).join("")
            contentHTML += this.options.variantConfig.layout.type == "horizontal-boxy" ? '</div>': ''
        }

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-lenses x-pro">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Choose Lens Group")}</h3>
            </div>
            ${contentHTML}
        </div>`

        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", function(ev) {
            this.response.lensGroupSelected = ev.target.value
            return this.renderLenses()
        }.bind(this)))
        if (document.querySelector("#la-back-btn")) {
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.stepIndex -= 1
                this.navigationSteps.splice(this.stepIndex, 1);
                return this.navigation[this.stepIndex]()
            }.bind(this))
        }
        this.updateState(this.renderLensGroup.bind(this))
        this._component__DidMount('LensAdvizor:lens:rendered', {method: "renderLensGroup"})
    },
    preloadImage: function(url) {
        var img = new Image();
        img.src = url;
        return img.src;
    },
    handleFormSubmit: function(e) {
        e.preventDefault()
        e.stopImmediatePropagation()
        const target = e.target
        if (target.dataset.form === "addToCart") {
            return new this.AddToCartHandler(this).performOperation()
        } else if (target.dataset.form === "options") {
            if (this.response.lens.add_ons) {
                return this.renderAddOns()
            }
            if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review") {
                if (["single_vision", "progressive"].includes(this.response.prescriptionType)) {
                    return this.renderSubmissionMethods()
                } else if (this.response.prescriptionType == 'reading') {
                    return this.renderReadingForm()
                }
            }
            /// Handle Prescription Form
            return this.renderReview()
        } else if (target.dataset.form === "contact_lenses") {
            this.contactLensFormData = []
            Array.from(target.elements).forEach(function(elem){
                if (elem.name && (elem.classList.contains("la-form-input") || elem.classList.contains("la-form-input-number") || elem.classList.contains("la-form-select"))) {
                    this.contactLensFormData.push({name: elem.name, value: elem.value})
                }
            }.bind(this))
            if (this.isContactLensFlow.settings.showReviewOrderPage) {
                return this.renderReview()
            }
            return new this.AddToCartHandler(this).performOperation();
        } else if (target.dataset.form !== "review") {
            if (this.checkFormValidity(target)) {
                // Handle Review in case of before-review
                if (target.dataset.form === "manually") {
                    const manualResponse = this.localStorage.manualResponse || {}
                    this.setLocalStorage("manualResponse", {...manualResponse, [this.response.prescriptionType]: this.response.manually})
                }
                if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review") {
                    return this.renderReview()
                }
                return this[this.lensDisplayMethod]()
            }
        }
        return false
    },
    checkFormValidity: function(target) {
        const isValid = target.reportValidity();
        if (!isValid) {
            Array.from(target.elements).forEach(function(elem) {
                if (!elem.checkValidity()) {
                    elem.style.borderColor = "red"
                }
                setTimeout(function() {
                    elem.style.borderColor = '#C1C1C1';
                }, 5000)
            })
            return false
        }

        if (target.dataset.form === "manually") {
            let fieldValues = []

            const checkForFieldValidation = (elem) => {
                if (elem.value == 0) {
                    fieldValues.push(true)
                    elem.style.borderColor = 'red'
                } else {
                    fieldValues.push(false)
                }
            }

            Array.from(target.elements).forEach(function(elem) {
                if (["od_right", "os_left"].includes(elem.dataset.eval) && ["sph", "cyl", "add"].includes(elem.dataset.field)) {
                    if (elem.dataset.field !== 'add' || this.response.selectedPrescriptionType.settings.showAdd !== "hidden") {
                        checkForFieldValidation(elem);
                    }
                }

                setTimeout(function() {
                    elem.style.borderColor = '#C1C1C1';
                }, 5000)
            }.bind(this))

            if (fieldValues.includes(false)) {
                Array.from(target.elements).forEach(function(elem) {
                    elem.style.borderColor = '#C1C1C1';
                })
                return true;
            } else {
                const messageKey = this.response.selectedPrescriptionType.settings.showAdd == "hidden" ? "SPH_CYL_REQUIRED" : "SPH_CYL_ADD_REQUIRED"

                document.dispatchEvent(new CustomEvent('LensAdvizor:action:exception', {
                    detail: {
                        message: this.Translation.getTranslatedText(messageKey),
                    }
                }));
                return false;
            }
        }

        return true
    },
    handleLensChange: function(ev) {
        const lenses = this.lensDisplayMethod == 'renderLensGroup' ? this.lensesByGroups[this.response.lensGroupSelected] : this.lenses

        const selectedPrescription = this.response.selectedPrescriptionType
        if (lenses.length == 1 && this.options.prescriptionConfig.skipPrescriptionLenses) {
            this.response.lens = lenses[0]
        } else {
            this.response.lens = this.lenses.find(function(lens) {
                return lens.id == parseInt(ev.target.value)
            })
        }
        this.response.lensOptionsSelected = {}
        this.customOptions = {}
        this.response.lensVariant = this.response.lens.variants[0]
        this.response.lensOptions = Object.keys(this.response.lens.options)
        this.updateFieldValues("singlePD", selectedPrescription.settings.fieldOptions.pd, parseFloat(selectedPrescription.settings.fieldOptions.pd.steps > 0 ? selectedPrescription.settings.fieldOptions.pd.steps : 0.5))
        this.updateFieldValues("dualPD", selectedPrescription.settings.fieldOptions.dualPd, 0.5)
        this.postChooseLens()
    },
    getPredictedPrescriptionType: function(override) {
        return this.response.prescriptionType
    },
    postChooseLens: function() {
        const prescriptionType = this.getPredictedPrescriptionType()
        let isOptionsAvailable = (Object.keys(this.response.lens.options).length > 0 && this.response.lens.variants.length > 1) || Object.keys(this.response.lens.raw_options).length > 0

        /// Handle Prescription Form

        let func = 'renderReview'

        if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review") {
            if (["single_vision", "progressive"].includes(this.response.prescriptionType)) {
                func = 'renderSubmissionMethods'
            } else if (this.response.prescriptionType == 'reading') {
                func = "renderReadingForm";
            }
        }

        this.response.addOns = {}
        this.response.addOnsStep = 0
        if (isOptionsAvailable && this.options.billing_plan.is_multiple_options_allowed) {
            func = 'renderOptions'
            this.response.optionLevel = 1
        } else if (this.response.lens.add_ons) {
            this.response.addOnsStep = 0
            this.response.lens.add_ons_products.forEach((step, index) => {
                this.response.addOns[index] = {
                    product: null,
                    variantId: null,
                    canSkip: false
                }
            })
            func = 'renderAddOns'
        }
        this.updateFooterPrices()
        if (!(isOptionsAvailable && this.options.billing_plan.is_multiple_options_allowed)) {
            document.dispatchEvent(new CustomEvent('LensAdvizor:lensVariant:change'))
        }
        this[func]()
    },
    optionCompare: function(os_value, od_value, valueConfig) {
        const min_value = parseFloat(Math.min(valueConfig.range1.from, valueConfig.range2.from));
        const max_value = parseFloat(Math.max(valueConfig.range1.to, valueConfig.range2.to));
        const rx_limit_rule = this.response.lens.rx_limit_rule;
        if (min_value == 0 && max_value == 0) {
            return false
        }

        const range1From = parseFloat(valueConfig.range1.from)
        const range1To = parseFloat(valueConfig.range1.to)

        const range2From = parseFloat(valueConfig.range2.from)
        const range2To = parseFloat(valueConfig.range2.to)

        let range1Output = false
        let range2Output = false

        if (rx_limit_rule == "atleast-one-eye") {
            let isOsRange1Valid = false;
            let isOsRange2Valid = false;
            let isOdRange1Valid = false;
            let isOdRange2Valid = false;

            if (valueConfig.range1.from) {
                isOsRange1Valid = os_value >= range1From && os_value <= range1To
                isOdRange1Valid = od_value >= range1From && od_value <= range1To
            }

            if (valueConfig.range2.from) {
                isOsRange2Valid = os_value >= range2From && os_value <= range2To
                isOdRange2Valid = od_value >= range2From && od_value <= range2To
            }
            let lieInRange = (isOsRange1Valid || isOsRange2Valid) || (isOdRange1Valid || isOdRange2Valid) 
            return !lieInRange
        } else if (rx_limit_rule == "both-eyes") {
            let isOsRange1Valid = false;
            let isOsRange2Valid = false;
            let isOdRange1Valid = false;
            let isOdRange2Valid = false;

            if (valueConfig.range1.from) {
                isOsRange1Valid = os_value >= range1From && os_value <= range1To
                isOdRange1Valid = od_value >= range1From && od_value <= range1To
            }

            if (valueConfig.range2.from) {
                isOsRange2Valid = os_value >= range2From && os_value <= range2To
                isOdRange2Valid = od_value >= range2From && od_value <= range2To
            }
            let lieInRange = (isOsRange1Valid || isOsRange2Valid) && (isOdRange1Valid || isOdRange2Valid) 
            return !lieInRange
        } else {
            if (Math.abs(os_value) > Math.abs(od_value)) {
                strongest_rx_value = os_value
            } else {
                strongest_rx_value = od_value
            }

            if (valueConfig.range1.from) {
                range1Output = strongest_rx_value >= range1From && strongest_rx_value <= range1To
            }
            if (valueConfig.range2.from) {
                range2Output = strongest_rx_value >= range2From && strongest_rx_value <= range2To
            }

            if (range1Output || range2Output) {
              return false
            }
            return true
        }
    },
    renderOptions: function() {
        if (this.options.prescriptionConfig.lensOptionDisplayType !== "single") {
            return this.renderOption()
        }
        this.Utils.skipPrescriptionLenses.call(this, "renderOptions");
        this._component__WillMount('LensAdvizor:lensOptions:rendered', {method: "renderOptions"})

        const { lens, manually, method, lensVariant } = this.response;
        const preSelectedOptions = []

        this.response.lensOptionsSelected = {}
        this.customOptions = {}
        this.response.lensOptions.forEach((obj) => {
            preSelectedOptions.push({
                rawOptionName: this.response.lens.options[obj].name,
                optionValue: lensVariant[obj],
                isPriced: true
            })
            this.response.lensOptionsSelected[obj] = lensVariant[obj]
        })

        let contentHTML = "";
        let optionsRendered = true

        contentHTML = this.response.lens.raw_options.map(function(option, index){
            const optionKey = `option${index+1}`
            const rawOption = option;
            const optionSettings = this.response.lens.options_settings.find(obj => obj.name === option.name)
            if (!option.is_priced) {
                this.customOptions[option.name] = option.values[0].name
                preSelectedOptions.push({
                    rawOptionName: rawOption.name,
                    optionValue: this.customOptions[option.name],
                    isPriced: false
                })
            }

            const optionListClassNames = ["la-option-list"]

            if (rawOption && rawOption.is_inline) {
                optionListClassNames.push("la-option-inline-list")
                if (this.Utils.isSwatchOption(option.name)) {
                    optionListClassNames.push("la-color-swatch")
                }

                if (this.response.lens?.show_exact_pricing) {
                    optionListClassNames.push("la-option-excact-price-list")
                }
            }

            if (this.options.variantConfig.layout.type == "horizontal-boxy") {
                optionListClassNames.push("la-horizontal-boxy-layout-wrapper")
            }

            const optionValues = rawOption.values.map(function (optionValue, index) {
                if (optionSettings && method === 'entered_manually') {
                    let valueConfig = optionSettings.values.find(val => val.name === optionValue.name)
                    if (!this.validateLensOptionConfigation(valueConfig)) {
                        return null
                    }
                }
                return optionValue.name.trim()
            }.bind(this)).filter(o => o)

            if (!optionValues.length) {
                optionsRendered = false
            }

            return `<div class="la-option-container">
                ${rawOption.is_inline ? `<h3 class="la-lensgroup-title la-flex-sb">
                    <span class="la-inline-title-container">
                        ${this.Translation.getTranslatedText(option.name)}${rawOption.is_inline ? `: <span id="la-inline-option-${option.name.generateUnique()}--value"></span><span id="la-inline-option-${option.name.generateUnique()}--tooltip"></span>`: ''}
                    </span>
                    <span id="la-inline-option-${option.name.generateUnique()}--price"></span>
                </h3>`: `<h3 class="la-lensgroup-title">${this.Translation.getTranslatedText(option.name)}</h3>`}
                <div class="${optionListClassNames.join(" ")}">
                    ${optionValues.map(function (optionValue) {
                        const optionIndex = Object.values(LensAdvizor.response.lens.options).findIndex(opt => opt.name == option.name)

                        let selected = false
                        if (!option.is_priced) {
                            selected = this.customOptions[option.name] == optionValue ? "checked" : ""
                        } else {
                            selected = lensVariant[`option${optionIndex + 1}`] === optionValue ? "checked" : ""
                        }

                        const rawValue = rawOption ? rawOption.values.find(value => value.name.trim() == optionValue.trim()) : {}

                        let valueImage = ""
                        if (rawOption.is_inline && optionListClassNames.includes("la-color-swatch")) {
                            valueImage = `<div class="la-label-image la-swatch-input">
                                ${rawValue.image ? `<img src="${rawValue.image}" loading="lazy" />`: `<span
                                    style="background-color: ${optionValue}; display: block">&nbsp;<span>`}
                            </div>`
                        } else if (rawValue.image) {
                            valueImage = `<div class="la-label-image">
                                <img src="${rawValue.image}" loading="lazy" />
                            </div>`
                        } else if (rawOption.is_inline) {
                            valueImage = `<div class="la-label-image la-no-image">
                                <img src="${LensAdvizor.BASE_URL}/assets/default.png" loading="lazy" />
                            </div>`
                        }

                        let toolTipContent = ""
                         if (rawOption.is_inline) {
                            toolTipContent = this.getToolTipLayout({
                                title: optionValue,
                                isDefault: true
                            })
                        } else if (rawOption.showTooltips && rawValue.tooltipContent) {
                            toolTipContent = this.getToolTipLayout({
                                title: rawValue.tooltipTitle,
                                content: rawValue.tooltipContent
                            })
                        }

                        const optionIdentifier = option.is_priced ? `option${optionIndex + 1}` : rawOption.name

                        const classes = "la-label-btn-wrapper la-each-card-carousel" + (this.options.variantConfig.layout.type == "horizontal-boxy" ? " la-horizontal-boxy-label-wrapper" : "")
                        return `<div class="${classes}">
                            <input
                                type="radio"
                                id="${optionKey}${optionValue.generateUnique()}"
                                name="radio-carousel-${optionKey}"
                                value="${optionValue}"
                                required
                                data-non-priced-option="${!option.is_priced}"
                                data-option-type="${optionIdentifier}"
                                data-raw-option-name="${rawOption.name}"
                                class="la-tap-select"
                                ${selected ? "checked" : ""}
                            >
                            <label for="${optionKey}${optionValue.generateUnique()}" class="la-label-btn">
                                ${toolTipContent}
                                ${valueImage}
                                <div class="la-label-content-box" style="max-width: initial">
                                    <div class="la-label-title">${this.Translation.getTranslatedText(optionValue)}</div>
                                    ${!rawOption.is_inline && rawValue.description ? `<div class="la-label-description">
                                        ${this.Translation.getTranslatedText(rawValue.description)}
                                    </div>` : ""}
                                </div>
                                <div class="la-label-price la-option-pricing" id="la-option-price-${optionIdentifier}${optionValue.generateUnique()}"></div>
                            </label>
                        </div>`
                    }.bind(this)).join("")}
                </div>
            </div>
            ${this.response.lensOptions.length > index + 1 ? '<div class="la-divider"></div>' : ''}`
        }.bind(this)).join("")

        if (!optionsRendered) {
            contentHTML = `<div class="la-n-available">
                <p class="la-text-center" style="margin-top: 20px;">${this.Translation.getTranslatedText("No options found")}</p>
                <button class="la-prescription-form-btn la-option-available" id="la-back-btn" type="button">
                    ${this.Translation.getTranslatedText("Go Back")}
                </button>
            </div>`
            this.formBtn.firstElementChild.setAttribute("disabled", true)
            this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Options Unavailable")
        }

        this.response.addOns = {}
        this.response.addOnsStep = 0
        if (this.response.lens.add_ons) {
            this.response.addOnsStep = 0
            this.response.lens.add_ons_products.forEach((step, index) => {
                this.response.addOns[index] = {
                    product: null,
                    variantId: null,
                    canSkip: false
                }
            })
        }

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-options">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Select Options for")} ${lens.name}</h3>
            </div>
            <form class="la-prescription-wrapper la-option-container" data-form="options" id="la-prescription-form">
                ${contentHTML}
            </form>
        </div>`

        if (document.querySelector("#la-back-btn")) { 
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.backBtns.forEach(btn => btn.click())
            }.bind(this))
        }

        // Handle Add-Ons next step in case of next Step available
        document.querySelectorAll(".la-tap-select").forEach(option => option.addEventListener("click", this.handleOptionChange.bind(this)))
        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))

        if (optionsRendered) {
            this.handleOptionChange()
            preSelectedOptions.forEach((preSelectedOption) => this.updateInlineOption(preSelectedOption.rawOptionName, preSelectedOption.optionValue, preSelectedOption.isPriced))
        }
        this._component__DidMount('LensAdvizor:lensOptions:rendered', {method: "renderOptions"})
    },
    validateLensOptionConfigation: function(valueConfig) {
        let odSPH = parseFloat(this.response.manually.od_right.sph);
        let odCYL = parseFloat(this.response.manually.od_right.cyl);

        let osSPH = parseFloat(this.response.manually.os_left.sph);
        let osCYL = parseFloat(this.response.manually.os_left.cyl);

        if (osCYL > 0) {
            osSPH += osCYL;
            osCYL = -osCYL
        }

        if (odCYL > 0) {
            odSPH += odCYL;
            odCYL = -odCYL
        }

        if (valueConfig && (this.optionCompare(osSPH, odSPH, valueConfig.sph) !== false)) {
            return false
        }
        if (valueConfig && (this.optionCompare(osCYL, odCYL, valueConfig.cyl) !== false)) {
            return false
        }
        return true
    },
    renderOption: function() {
        this.Utils.skipPrescriptionLenses.call(this, "renderOption")
        this._component__WillMount(`LensAdvizor:lensOption${this.response.optionLevel}:rendered`, {method: "renderOption", optionLevel: this.response.optionLevel})

        const { options, raw_options, options_settings, name } = this.response.lens;
        const { manually } = this.response; 
        const optionKey = `option${this.response.optionLevel}`
        const option = raw_options[this.response.optionLevel-1]
        const rawOption = raw_options.find(opt => opt.name == option.name)
        const optionSettings = options_settings.find(obj => obj.name == option.name)

        var valuesRendered = false;

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-options">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">
                    ${this.Translation.getTranslatedText("Select")} ${this.Translation.getTranslatedText(option.name)} ${this.Translation.getTranslatedText("for")} ${this.Translation.getTranslatedText(name)}
                </h3>
            </div>
            <div class="la-prescription-wrapper la-option-container ${this.options.variantConfig.layout.type == "horizontal-boxy" ? " la-horizontal-boxy-layout-wrapper" : ""}">
                ${option.values.map(function (optionValue, index) {
                    const optionIndex = Object.values(this.response.lens.options).findIndex(opt => opt.name == option.name)

                    if (optionSettings && this.response.method === 'entered_manually') {
                        let valueConfig = optionSettings.values.find(val => val.name === optionValue.name)
                        if (!this.validateLensOptionConfigation(valueConfig)) {
                            return ''
                        }
                    }

                    optionValue = optionValue.name.trim();

                    valuesRendered = true;

                    let selected = this.response.lensVariant[optionKey] === optionValue || option.values[0].name == optionValue ? "checked" : ""
                    if (!option.is_priced) {
                        selected = this.customOptions[option.name] == optionValue ? "checked" : ""
                    }

                    const rawValue = rawOption ? rawOption.values.find(value => value.name.trim() == optionValue) : {}

                    let toolTipContent = ""
                    if (rawOption.showTooltips && rawValue.tooltipContent) {
                        toolTipContent = this.getToolTipLayout({
                            title: rawValue.tooltipTitle,
                            content: rawValue.tooltipContent
                        })
                    }

                    // Handle Case if Variant Doesn't exists based on Option Selection
                    const optionIdentifier = option.is_priced ? `option${optionIndex + 1}` : rawOption.name

                    const classes = "la-label-btn-wrapper la-each-card-carousel" + (this.options.variantConfig.layout.type == "horizontal-boxy" ? " la-horizontal-boxy-label-wrapper" : "")
                    return `<div class="${classes}">
                        <input
                            type="radio"
                            id="${optionKey}${optionValue.generateUnique()}"
                            name="radio-carousel-${optionKey}"
                            value="${optionValue}"
                            required
                            data-non-priced-option="${!option.is_priced}"
                            data-option-type="${optionIdentifier}"
                            class="la-tap-select"
                            ${selected ? "checked" : ""}>
                        <label for="${optionKey}${optionValue.generateUnique()}" class="la-label-btn">
                            ${toolTipContent}
                            ${rawValue.image ? `<div class="la-label-image">
                                <img src="${rawValue.image}" loading="lazy" />
                            </div>` : ""}
                            <div class="la-label-content-box" style="max-width: initial">
                                <div class="la-label-title">${this.Translation.getTranslatedText(optionValue)}</div>
                                ${rawValue.description ? `<div class="la-label-description">${this.Translation.getTranslatedText(rawValue.description)}</div>` : ""}
                            </div>
                            <div class="la-label-price la-option-pricing" id="la-option-price-${optionIdentifier}${optionValue.generateUnique()}"></div>
                        </label>
                    </div>`
                }.bind(this)).join("")}
                ${!valuesRendered ? `<div class="la-n-available">
                    <p class="la-text-center" style="margin-top: 20px;">${this.Translation.getTranslatedText("No options found")}</p>
                    <button class="la-prescription-form-btn la-option-available" id="la-back-btn" type="button">
                        ${this.Translation.getTranslatedText("Go Back")}
                    </button>
                </div>` : ''} 
            </div>
        </div>`

        if (document.querySelector("#la-back-btn")) { 
            document.querySelector("#la-back-btn").addEventListener("click", function() {
                this.backBtns.forEach(btn => btn.click())
            }.bind(this))
        }

        document.querySelectorAll(".la-tap-select").forEach(option => option.addEventListener("click", this.handleSingleOptionChange.bind(this)))

        if (valuesRendered) {
            this.updateOptionsPrice()
        }

        document.dispatchEvent(new CustomEvent('LensAdvizor:lensOptions:rendered'))
        this._component__DidMount(`LensAdvizor:lensOption${this.response.optionLevel}:rendered`, {method: "renderOption", optionLevel: this.response.optionLevel})
    },
    handleSingleOptionChange: function(evt) {
        if (evt.target.dataset.nonPricedOption == 'true') {
            this.customOptions[evt.target.dataset.optionType] = evt.target.value;
        } else {
            this.response.lensOptionsSelected[evt.target.dataset.optionType] = evt.target.value;
        }
        var newVariant = this.findLensVariant()
        if (newVariant) {
            this.response.lensVariant = newVariant
        }

        this.response.optionLevel += 1
        if (this.response.optionLevel > this.response.lens.raw_options.length) {
            if (this.response.lens.add_ons) {
                return this.renderAddOns()
            }
            if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review" && ["single_vision", "progressive"].includes(this.response.prescriptionType)) {
                return this.renderSubmissionMethods()
            }
            return this.renderReview()
        }

        this.navigationSteps.push("bound renderOptions")
        this.stepIndex = this.navigationSteps.length;
        this.navigation[this.stepIndex] = this.renderOptions.bind(this)

        this.updateOptionsPrice()

        this.renderOptions()
        this.updateFooterPrices()
    },
    handleOptionChange: function(evt) {
        if (evt && evt.type === "click") {
            const { optionType, nonPricedOption, rawOptionName } = evt.target.dataset
            const optionValue = evt.target.value
            if (nonPricedOption == 'true') {
                this.customOptions[optionType] = optionValue
            } else {
                this.response.lensOptionsSelected[optionType] = optionValue
            }
            this.updateInlineOption(rawOptionName, optionValue, nonPricedOption != "true")
        }

        var newVariant = this.findLensVariant()
        if (newVariant) {
            this.response.lensVariant = newVariant
            this.formBtn.firstElementChild.removeAttribute("disabled")
            this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Save and Continue")
        } else {
            this.formBtn.firstElementChild.setAttribute("disabled", true)
            this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Options Unavailable")
        }
        this.updateOptionsPrice()
        document.dispatchEvent(new CustomEvent('LensAdvizor:lensVariant:change'))
    },
    findLensVariant: function() {
        var selectedValues = Object.keys(this.response.lensOptionsSelected).map(function(optionKey) {
            return {
                index: optionKey,
                value: this.response.lensOptionsSelected[optionKey]
            }
        }.bind(this))
        return this.response.lens.variants.find(function(variant) {
            return selectedValues.every(function(values) {
                return variant[values.index] === values.value;
            });
        });
    },
    updateInlineOption: function(rawOptionName, optionValue, isPriced) {
        const rawOption = this.response.lens.raw_options.find(rawOption => rawOption.name == rawOptionName)
        if (!rawOption.is_inline) {
            return
        }
        const uniqueIdentifier = rawOptionName.generateUnique()
        const rawValue = rawOption ? rawOption.values.find(rawValue => rawValue.name.trim() == optionValue.trim()) : {}
        document.querySelector(`#la-inline-option-${uniqueIdentifier}--value`).innerHTML = optionValue
        const toolTipContainer = document.querySelector(`#la-inline-option-${uniqueIdentifier}--tooltip`)
        toolTipContainer.innerHTML = rawValue.tooltipContent ? this.getToolTipLayout({
            title: rawValue.tooltipTitle,
            content: rawValue.tooltipContent
        }) : ''

        const toolTipElement = toolTipContainer.querySelector("[data-la-tooltip]")
        if (toolTipElement) {
            this.addTooltipEvent(toolTipElement)
        }

        if (this.response.lens.show_exact_pricing && isPriced) {
            let currencyPrice;
            if (Object.keys(this.response.lens.options).length == 1) {
                let variant = this.response.lens.variants.find((variant) => variant.option1 == rawValue.name)
                currencyPrice = this.convertCurrency(this.response.lens.shopify_id, variant.variant_id, variant.price)
            } else {
                currencyPrice = this.Currency.convert(parseFloat(rawValue.price), this.options.default_currency, Shopify.currency.active)
            }
            document.querySelector(`#la-inline-option-${uniqueIdentifier}--price`).innerHTML = this.formatCurrency(currencyPrice)
        }
    },
    updateOptionsPrice: function() {
        document.querySelectorAll(".la-option-pricing").forEach(element => element.innerHTML = "")

        if (!this.response.lens.is_depricated_item && this.response.lens.show_exact_pricing) {
            for (optionKey in this.response.lens.options) {
                const lensOption = this.response.lens.options[optionKey]
                const rawOption = this.response.lens.raw_options.find(option => option.name == lensOption.name)
                rawOption.values.forEach(function (value, index) {
                    var optionPriceBox = document.getElementById(`la-option-price-${optionKey}${value.name.generateUnique()}`)
                    let currencyPrice;
                    if (Object.keys(this.response.lens.options).length == 1) {
                        let variant = this.response.lens.variants.find((variant) => variant.option1 == value.name)
                        currencyPrice = this.convertCurrency(this.response.lens.shopify_id, variant.variant_id, variant.price)
                    } else {
                        currencyPrice = this.Currency.convert(parseFloat(value.price), this.options.default_currency, Shopify.currency.active)
                    }
                    if (optionPriceBox) {
                        optionPriceBox.innerHTML = this.formatCurrency(currencyPrice)
                    }
                }.bind(this))
            }
        } else {
            for (optionKey in this.response.lens.options) {
                const lensOption = this.response.lens.options[optionKey]
                const rawOption = this.response.lens.raw_options.find(option => option.name == lensOption.name)
                lensOption.values.forEach(function (value, index) {
                    let selectedValues = []
                    this.response.lensOptions.forEach(function (key, index) {
                        if (optionKey !== key) {
                            selectedValues.push({ value: this.response.lensVariant[key], index: key })
                        } else {
                            selectedValues.push({ value: value, index: optionKey })
                        }
                    }.bind(this))
                    var foundVariant = this.response.lens.variants.find(function(variant) {
                        return selectedValues.every(function(values) {
                            return variant[values.index] === values.value;
                        });
                    });
                    var optionPriceBox = document.getElementById(`la-option-price-${optionKey}${value.generateUnique()}`)
                    if (!optionPriceBox) {
                        const optionIndex = this.response.lens.raw_options.findIndex(opt => opt.name == lensOption.name)
                        var optionPriceBox = document.getElementById(`la-option-price-option${optionIndex + 1}${value.generateUnique()}`)
                    }
                    if (foundVariant) {
                        if (foundVariant.variant_id !== this.response.lensVariant.variant_id) {
                            let currencyPrice = this.formatCurrency(
                                this.convertCurrency(
                                    this.response.lens.shopify_id, foundVariant.variant_id, foundVariant.price
                                ) - this.convertCurrency(
                                    this.response.lens.shopify_id, this.response.lensVariant.variant_id, this.response.lensVariant.price
                                )
                            )
                            if (!currencyPrice.includes("-")) {
                                currencyPrice = `+${currencyPrice}`
                            } else {
                                currencyPrice = `${currencyPrice}`
                            }
                            if (optionPriceBox) {
                                optionPriceBox.innerHTML = currencyPrice
                            }
                        } else {
                            if (this.options.prescriptionConfig.lensOptionDisplayType == 'single') {
                                optionPriceBox.innerHTML = this.Translation.getTranslatedText("Selected")
                            }
                        }
                    } else {
                        optionPriceBox.innerHTML = this.Translation.getTranslatedText(" --- ")
                    }
                }.bind(this))
            }
        }
        this.updateFooterPrices()
        this.updatePictureMatrix("renderLenses")
    },
    renderAddOns: function(forceUpdate) {
        this._component__WillMount('LensAdvizor:addOns:rendered', {method: "renderAddOns"})

        this.response.addOns[this.response.addOnsStep] = {
            product: null,
            variantId: null,
            outOfStockSkip: undefined
        }

        const step = this.getCurrentAddOnStep()

        if (step.isSkipable){
            return this.handleAddOnSelection()
        } else {
            this.updateState(this.renderAddOns.bind(this), false, forceUpdate)
        }

        let outOfStockSkip = true

        const contentHTML = step.products.map(function(product) {
            if (product.variants.length > 1) {
                return product.variants.map(variant => {
                    if (variant.inventory_policy === "deny" && variant.inventory_management !== null && variant.inventory_quantity === 0) {
                        return ''
                    } else {
                        outOfStockSkip = false
                    }
                    let image = product.images.find(image => image.variant_ids.includes(variant.id)) || product.image || this.defaultImage

                    const price = parseFloat(variant.price) == 0 ? this.Translation.getTranslatedText("FREE") : this.convertCurrency(product.id, variant.id, variant.price)
                    return this.getButtonLayout({
                        title: `${product.title} - ${variant.title}`,
                        image: image.src,
                        name: product.handle + '-' + variant.id,
                        description: step.show_product_description ? product.body_html : "",
                        price: price,
                        compareAtPrice: variant.compare_at_price,
                        value: variant.id,
                        productId: product.id
                    })
                }).join("")
            } else {
                let variant = product.variants[0]
                if (variant.inventory_policy === "deny" && variant.inventory_management !== null && variant.inventory_quantity === 0) {
                    return ''
                } else {
                    outOfStockSkip = false
                }
                const image = product.image || this.defaultImage
                const price = parseFloat(variant.price) == 0 ? this.Translation.getTranslatedText("FREE") : this.convertCurrency(product.id, variant.id, variant.price)
                return this.getButtonLayout({
                    title: `${product.title}`,
                    image: image.src,
                    name: product.handle + '-' + variant.id,
                    description: step.show_product_description ? product.body_html : "",
                    price: price,
                    compareAtPrice: variant.compare_at_price,
                    value: product.variants[0].id, 
                    productId: product.id
                })
            }
        }.bind(this)).join("")

        this.response.addOns[this.response.addOnsStep].outOfStockSkip = outOfStockSkip

        this.contentBox.innerHTML = `<div class="la-choose-prescription-wrapper la-render-addons">
            <div class="la-wrapper-heading">
                <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText(step.title)}</h3>
            </div>
            <p>${this.Translation.getTranslatedText(step.description)}</p>
            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `<div class="la-divider"></div><div class="la-horizontal-boxy-layout-wrapper">` : ""}
            ${contentHTML}
            ${this.options.variantConfig.layout.type == "horizontal-boxy" ? `</div>` : ""}
            ${step.can_skip ? `<div class="la-skip-add-on-wrapper">
                <a class="la-skip-add-on" href="javascript:void(0)">
                    ${this.Translation.getTranslatedText(step.skip_button_text)}
                </a>
                <div class="la-skip-button-description">
                    ${this.Translation.getTranslatedText(step.skip_button_description)}
                </div>
            </div>` : ""}
        </div>`

        document.querySelectorAll('.la-tap-select').forEach(btn => btn.addEventListener("click", this.handleAddOnSelection.bind(this)))
        if (step.can_skip) {
            document.querySelector('.la-skip-add-on').addEventListener("click", this.handleAddOnSelection.bind(this))
        }

        this._component__DidMount('LensAdvizor:addOns:rendered', {method: "renderAddOns"})

        if (this.response.addOns[this.response.addOnsStep].outOfStockSkip) {
            document.querySelector('.la-skip-add-on').click()
        }
    },
    getCurrentAddOnStep: function() {
        let step = {};
        if (this.response.selectedPrescriptionType?.metafield?.addon_flow) {
            step = this.response.selectedPrescriptionType.add_ons_products[this.response.addOnsStep];
        } else {
            step = this.response.lens.add_ons_products[this.response.addOnsStep];
        }
        
        step.isSkipable = step.products.length == 1 && step.products[0].variants.length == 1 && this.response.selectedPrescriptionType.settings.skipAddOns && !step.can_skip
        if (step.isSkipable) {
            step.skipProduct = step.products[0]
            step.skipVariant = step.skipProduct.variants[0].id
        }
        return step
    },
    handleAddOnSelection: function(event) {
        const step = this.getCurrentAddOnStep()

        if (step.isSkipable || event.target.type === "radio") {
            this.response.addOns[this.response.addOnsStep] = {
                product: step.isSkipable ? step.skipProduct : step.products.find(product => product.id == event.target.dataset.productId),
                variantId: step.isSkipable ? step.skipVariant : event.target.value,
                step: step.title,
                itemId: step.item,
                canSkip: step.can_skip,
                bundleProducts: step.bundle_products,
                outOfStockSkip: this.response.addOns[this.response.addOnsStep]["outOfStockSkip"]
            }
        }

        this.updateFooterPrices()
        this.response.addOnsStep += 1
        const addOnStepLength = this.response.selectedPrescriptionType?.metafield?.addon_flow ? this.response.selectedPrescriptionType.add_ons_products.length : this.response.lens.add_ons_products.length
        if ((this.response.addOnsStep + 1) > addOnStepLength) {
            /// Handle Prescription Form
            if (this.options.prescriptionConfig.prescriptionEntryFormLocation === "before-review") {
                if (["single_vision", "progressive"].includes(this.response.prescriptionType)) {
                    return this.renderSubmissionMethods()
                } else if (this.response.prescriptionType == "reading") {
                    return this.renderReadingForm()
                }
            }
            return this.renderReview()
        }

        return this.renderAddOns(true)
    },
    renderReview: function() {
        if (!this.options.variantConfig.showReviewScreen) {
            return new this.AddToCartHandler(this).performOperation()
        }
        this.updateState(this.renderReview.bind(this), true)
        const reviewType = this.isContactLensFlow ? "contact_lenses" : "default"
        this._component__WillMount('LensAdvizor:review:rendered', {method: "renderReview", reviewType})

        this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Add to Cart")
        let contentReview = reviewType == "default" ? this.renderReviewDetails() : this.renderContactLensReview();

        this.contentBox.innerHTML = `<form class="la-prescription-wrapper" id="la-prescription-form" data-form="addToCart">
            <div class="la-choose-prescription-wrapper la-render-review">
                <div class="la-wrapper-heading">
                    <h3 id="la_prescriptionSelect_title">${this.Translation.getTranslatedText("Please Review Your Order")}</h3>
                </div>
                ${contentReview}
            </div>
        </form>`

        document.querySelector("#la-prescription-form").removeEventListener("submit", this.handleFormSubmit.bind(this), true)
        document.querySelector("#la-prescription-form").addEventListener("submit", this.handleFormSubmit.bind(this))
        document.querySelector("#la-order-notes").addEventListener("keyup", function(evt) {
            this.response.orderNote = evt.target.value
        }.bind(this))

        this._component__DidMount('LensAdvizor:review:rendered', {method: "renderReview", reviewType})
    },
    renderContactLensReview: function() {
        const reviewDetails = this.Utils.getReviewDetails.call(this)

        var fields = Object.keys(reviewDetails.odRight)
        var types = Object.keys(reviewDetails)

        const properties = this.getCustomFieldData()
        this.customBaseProductProperties = {...this.customBaseProductProperties, ...properties}

        var properties_texts = []
        const properties_keys = Object.keys(properties)

        properties_keys.forEach(function (fieldName, index) {
            if (!fieldName.startsWith('_')) {
                properties_texts.push(`${fieldName}: ${properties[fieldName]}`)
            }
        })

        const subtotal = parseFloat(this.variants[this.selectedOrDefaultVariant].price)
        // const subtotal = parseFloat(this.convertCurrency(this.productId, this.selectedOrDefaultVariant, this.variants[this.selectedOrDefaultVariant].price))
        var totalQuantity = 1

        let variant_summary = ''
        this.variants[this.selectedOrDefaultVariant].json.options.forEach(optionName => {
            if (optionName !== "Default Title") {
                variant_summary += `<div class="review-item-variant">${optionName}</div>`
            }
        })

        const contentReview = `<div class="la-review-details-wrapper">
            <div class="la-review-item la-flex-start">
                <div class="la-review-left">
                    <div class="la-label-title">${this.productTitle}</div>
                    <div class="la-label-description">${variant_summary}</div>
                </div>
                <div class="la-review-right">
                    <div class="la-label-title">${this.formatCurrency(parseFloat(this.variants[this.selectedOrDefaultVariant].price))}</div>
                </div>
            </div>
            <div class="la-divider"></div>
            <div class="la-review-item">
                <div class="la-review-left">
                    <div class="la-label-title">${this.isContactLensFlow.title}</div>
                </div>
            </div>
            <div class="la-review-item">
                <div class="la-review-left">
                    <div class="la-label-description">
                        ${properties_texts.join(" <br/>")}
                    </div>
                </div>
            </div>
            <div class="la-review-lens-container">
            ${types.map(fieldType => {
                const obj = reviewDetails[fieldType]
                if (obj.quantity > 0) {
                    totalQuantity += parseInt(obj.quantity)
                    return `<div class="la-review-item">
                        <div class="la-review-left">
                            <div class="la-label-title la-mt-1"><strong>${fieldType === 'osLeft' ? this.Translation.getTranslatedText('OS (Left Eye)') : this.Translation.getTranslatedText('OD (Right Eye)')}</strong></div>
                            ${fields.map((fieldName) => {
                                if (obj[fieldName]) {
                                    let fieldTitle = this.Translation.getTranslatedText('Contacts_' + fieldName)
                                    return `<div class="la-label-description"><strong>${fieldTitle}: </strong> ${obj[fieldName]}</div>`
                                }
                                return ''
                            }).join("")}
                        </div>
                    </div>`
                }
                return ''
            }).join("")}
            </div>
            <div class="la-divider"></div>
            <div class="la-order-notes-wrapper">
                <div class="la-label-title">${this.Translation.getTranslatedText("Order Notes")}</div>
                <textarea class="la-form-textarea la-mt-1" id="la-order-notes"></textarea>
            </div>
        </div>`;
        return contentReview;
    },
    renderReviewDetails: function() {
        let variant_summary = ''
        this.variants[this.selectedOrDefaultVariant].json.options.forEach((optionName, index) => {
            if (optionName !== "Default Title") {
                let productOption = LensAdvizor.product.options[index]
                variant_summary += `<div class="review-item-variant">${typeof productOption == "string" ? productOption : productOption.name}: ${optionName}</div>`
            }
        })

        var options_text = ""
        for (let optionKey in this.response.lens.options) {
            var option = this.response.lens.options[optionKey]
            if (this.response.lensVariant[optionKey] === "Default Title") {
                continue
            }
            options_text += `<div class="la-label-description la-lens-option-text">${this.Translation.getTranslatedText(option.name)}: ${this.Translation.getTranslatedText(this.response.lensVariant[optionKey])}</div>`
        }

        if (Object.keys(this.additionalInformations).length > 0) {
            for (let optionKey in this.additionalInformations) {
                options_text += `<div class="la-label-description la-lens-option-text">${this.Translation.getTranslatedText(optionKey)}: ${this.Translation.getTranslatedText(this.additionalInformations[optionKey])}</div>`
            }
        }

        const properties = new this.AddToCartHandler(this).getProperties("lens")

        var properties_texts = []
        const properties_keys = Object.keys(properties)
        const propertiesDuplicateKeys = [
            "Prescription Type", "Prescription Method", "Product",
            this.Translation.getTranslatedText('Prescription Type'),
            this.Translation.getTranslatedText('Prescription Method'),
            this.Translation.getTranslatedText('Product')]

        properties_keys.forEach(function (fieldName, index) {
            if (!fieldName.startsWith('_') && !propertiesDuplicateKeys.includes(fieldName)) {
                properties_texts.push(`${fieldName}: ${properties[fieldName]}`)
            }
        })
        var addOns = "";

        if (this.response.lens.add_ons || this.response.selectedPrescriptionType?.metafield?.addon_flow) {
            let addOnsContent = Object.keys(this.response.addOns).map(step => {
                const stepInfo = this.response.addOns[step]
                if (!stepInfo.variantId && !stepInfo.product) {
                    return ''
                }
                const variant = stepInfo.product.variants.find(variant => variant.id.toString() == stepInfo.variantId.toString())
                let productTitle = stepInfo.product.title
                if (variant.title !== 'Default Title') {
                    productTitle = `${productTitle} - ${variant.title}`
                }
                return `<div class="la-review-item">
                    <div class="la-review-left">
                        <div class="la-label-description">${productTitle}</div>
                    </div>
                    <div class="la-review-right la-label-title">
                        ${variant.price > 0 ? this.formatCurrency(this.convertCurrency(stepInfo.product.id, variant.id, variant.price)) : this.Translation.getTranslatedText("FREE")}
                        ${this.options.default_currency == Shopify.currency.active ? `
                            ${variant.compare_at_price && variant.compare_at_price > 0 ? `<span class="la-compare-at-price"><del>${this.formatCurrency(variant.compare_at_price)}</del></span>` : ''}
                        `: ''}
                    </div>
                </div>`
            }).join('')

            if (addOnsContent) {
                addOns = `<div class="la-review-item">
                    <div class="la-review-left">
                        <div class="la-label-title">${this.Translation.getTranslatedText('Add Ons')}</div>
                    </div>
                </div>
                ${addOnsContent}
                <div class="la-divider"></div>`
            }
        }

        this.prices.customAddOnPrice = 0

        var customAddOns = this.customAddOns.map(customAddOn => {
            if (!customAddOn.productTitle) {
                return ''
            }
            const price = parseFloat(this.convertCurrency(customAddOn.productId, customAddOn.variantId, customAddOn.price))
            this.prices.customAddOnPrice += price

            const customAddOnProperties = Object.keys(customAddOn.properties)

            return `<div class="la-review-item la-flex-start">
                <div class="la-review-left">
                    <div class="la-label-description">
                        ${customAddOn.productTitle}
                        ${customAddOnProperties.map((customAddOnPropertyName) => {
                            return`<li class="la-label-description-custom-add-on-properties">${customAddOnPropertyName}: ${customAddOn.properties[customAddOnPropertyName]}</li>`
                        }).join('')}
                    </div>
                </div>
                <div class="la-review-right la-label-title">
                    ${price > 0 ? this.formatCurrency(price) : this.Translation.getTranslatedText("FREE")}
                </div>
            </div>`
        }).join('')

        if (customAddOns) {
            customAddOns = `<div class="la-review-item">
                <div class="la-review-left">
                    <div class="la-label-title">${this.Translation.getTranslatedText('Custom Add Ons')}</div>
                </div>
            </div>` + customAddOns + '<div class="la-divider"></div>'
        }

        const selectedVariant = this.variants[this.selectedOrDefaultVariant]

        var prescriptionPreviewContent = selfiePreviewContent = 'null'

        if (this.response.prescription && this.response.prescription.fileUrl) {
            const toolTipId = "tooltip-" + LensAdvizor.Utils.uuidv4()
            prescriptionPreviewContent = `<span class="la-review-prescription" data-la-tooltip="${toolTipId}">
                ${this.svg.preview ? this.svg.preview : `<img src="${this.previewIcon}" class="la-preview-img" alt="LensAdvizor prescription preview">`}
                ${this.Translation.getTranslatedText('Preview')}
            </span>`
            let toolTipContent = `<iframe src=${this.response.prescription.fileUrl} class="la-preview-frame" />`
            if (!this.response.prescription.type.includes("pdf")) {
                toolTipContent = `<img src=${this.response.prescription.fileUrl} class="la-preview-frame" height="500px" width="100%" />`
            }

            this.tooltips.push({
                title: this.Translation.getTranslatedText("Preview Prescription"),
                content: toolTipContent,
                id: toolTipId
            })
        }

        if (this.response.selfie && this.response.selfie.fileUrl) {
            const toolTipId = "tooltip-" + LensAdvizor.Utils.uuidv4()
            selfiePreviewContent = `<span class="la-review-prescription la-selfie-prescription" data-la-tooltip="${toolTipId}">
                ${LensAdvizor.response.selfie.originalName}
            </span>`
            this.tooltips.push({
                title: this.Translation.getTranslatedText("Preview Selfie"),
                content: `<img src=${this.response.selfie.fileUrl} class="la-preview-frame" height="500px" width="100%" />`,
                id: toolTipId
            })
        }

        const contentReview = `<div class="la-review-details-wrapper">
            ${this.options.variantConfig.addBaseProduct ? `<div class="la-review-item la-flex-start">
                <div class="la-review-left">
                    <div class="la-label-title">${selectedVariant.json.name}</div>
                    <div class="la-label-description">${variant_summary}</div>
                </div>
                <div class="la-review-right">
                    <div class="la-label-title">
                        ${selectedVariant.price > 0 ? this.formatCurrency(this.convertCurrency(this.productId, this.selectedOrDefaultVariant, selectedVariant.price)) : this.Translation.getTranslatedText("FREE")}
                        ${this.options.default_currency == Shopify.currency.active ? `
                            ${selectedVariant.compare_at_price && selectedVariant.compare_at_price > 0 ? `<span class="la-compare-at-price"><del>${this.formatCurrency(selectedVariant.compare_at_price)}</del></span>` : ''}
                        `: ''}
                    </div>
                </div>
            </div>
            <div class="la-divider"></div>` : ''}
            ${this.response.lens ? `<div class="la-review-item la-flex-start">
                <div class="la-review-left">
                    <div class="la-label-title">${this.Translation.getTranslatedText(this.response.lens.name)}</div>
                    ${options_text}
                    <div class="la-label-description">
                        <div>${this.Translation.getTranslatedText("Prescription Type")} : ${this.getPrescriptionTitle()}</div>
                        ${this.response.prescriptionType == "single_vision" || this.response.prescriptionType == "progressive" ? `<div class="la-review-method">
                            ${this.Translation.getTranslatedText("Method")}: ${this.getPrescriptionMethodDisplayName(this.response.method)}
                            ${this.response.prescription && this.response.prescription.fileUrl ? prescriptionPreviewContent : ''}
                        </div>` : ""}
                        ${["single_vision", "progressive"].includes(this.response.prescriptionType) && this.response.selfie ? `<div class="la-review-method">
                            ${this.Translation.getTranslatedText("Selfie")}: ${this.response.selfie && this.response.selfie.fileUrl ? selfiePreviewContent : ''}
                        </div>`: ''}
                    </div>
                    <div class="la-label-description">
                        ${properties_texts.join(" <br/>")}
                    </div>
                </div>
                <div class="la-review-right la-label-title">
                    ${this.response.lensVariant.price > 0 ? this.formatCurrency(this.convertCurrency(this.response.lens.shopify_id, this.response.lensVariant.variant_id, this.response.lensVariant.price)) : this.Translation.getTranslatedText("FREE")}
                    ${this.options.default_currency == Shopify.currency.active ? `
                        ${this.response.lensVariant.compare_at_price && this.response.lensVariant.compare_at_price > 0 ? `<span class="la-compare-at-price"><del>${this.formatCurrency(this.response.lensVariant.compare_at_price)}</del></span>` : ''}
                    `: ''}
                </div>
            </div>
            <div class="la-divider"></div>` : ''}
            ${addOns}
            ${customAddOns}
            <div id="la-review-quantity-box" class="la-review-item la-flex-start ${this.options.variantConfig.showQuantityFieldOnReview ? '' : 'la-hidden'}">
                <div class="la-review-left">
                    <div class="la-label-title">${this.Translation.getTranslatedText('Quantity')}</div>
                </div>
                <div class="la-review-right">
                    <input type="number" name="la-quantity" value="1" required min="1" max="25" class="la-form-input-number la-quantity">
                </div>
            </div>
            ${this.options.variantConfig.showQuantityFieldOnReview ? '<div class="la-divider"></div>' : ''}
            <div class="la-order-notes-wrapper">
                <div class="la-label-title">${this.Translation.getTranslatedText('Order Notes')}</div>
                <textarea class="la-form-textarea la-mt-1" id="la-order-notes"></textarea>
            </div>
        </div>`;
        return contentReview;
    },
    parsePrescriptionSettings: function() {
        let prescriptionSettings = {}
        if (this.response.method === 'uploaded') {
            if (this.options.prescriptionConfig.pdOnUpload !== "hidden") {
                prescriptionSettings.pd = this.response.manually.pd
            }
            if (this.options.prescriptionConfig.segmentHeight !== "hidden") {
                prescriptionSettings.segment_height = this.response.manually.segment_height
            }
        }
        if (["entered_manually", "provider_information"].includes(this.response.method)) {
            prescriptionSettings = this.response.manually
        }
        return prescriptionSettings
    },
    getPrescriptionRequestData: function(cartToken) {
        let prescriptionSettings = this.parsePrescriptionSettings()

        if (!cartToken) {
            return prescriptionSettings
        }

        let lensVariant = this.response.lensVariant || ""
        if (lensVariant) {
            lensVariant.base_product_id = this.productId
            lensVariant.base_product_title = this.productTitle
            if (this.response.lens.variants.length > 1) {
                lensVariant.name = `${this.response.lens.name} - ${lensVariant.name}`
            }
            lensVariant.lens_group_title = this.response.lens.group_title
            lensVariant.lens_group_type = this.response.lens.group_type
        }

        const timestamp = new Date().getTime()
        const uniqueIdentifier = `${this.response.prescriptionType}__${this.productId}__${timestamp}`

        const storeSettings = JSON.parse(JSON.stringify({
            ...this.options.settings,
            ...this.options.prescriptionConfig,
            prescriptionType: {...this.response.selectedPrescriptionType},
            variantConfig: this.options.variantConfig,
            sendOrderToLab: this.response.selectedPrescriptionType.settings.sendOrderToLab,
            addBaseProduct: this.options.variantConfig.addBaseProduct,
            flowId: this.collectionId
        }))

        delete storeSettings.custom_translationJSON
        delete storeSettings.formFields
        delete storeSettings.fieldOptions
        delete storeSettings.custom_javascript
        delete storeSettings.custom_css
        delete storeSettings.lens_descriptions
        delete storeSettings.submissionMethods
        delete storeSettings.diopters
        delete storeSettings.variantConfig.layout

        let data = {
            cart_token: cartToken,
            prescription_type: this.response.prescriptionType,
            method: this.response.method,
            prescription_file: this.response.prescription ? this.response.prescription.fileUrl : "",
            selfie_file: this.response.selfie ? this.response.selfie.fileUrl : "",
            prescription_setting: prescriptionSettings,
            product_id: this.productId,
            order_note: this.response.orderNote || "",
            lens: lensVariant,
            unique_identifier: this.response.uniqueIdentifier || uniqueIdentifier,
            store_settings: storeSettings,
            additional_informations: {
                ...this.additionalInformations,
                frameProperties: {...this.customBaseProductProperties},
                lensProperties: {...this.customLensProperties, ...this.customOptions},
                addOnProperties: {...this.customAddOnsProperties}
            },
            addons: this.response.addOns
        }

        if (this.customAddOns.length) {
            let addOnIndex = Object.keys(this.response.addOns).length
            this.customAddOns.forEach(customAddOn => {
                data.addons[addOnIndex] = {
                    variantId: customAddOn.variantId,
                    productId: customAddOn.productId,
                    canSkip: customAddOn.canSkip || false,
                    step: customAddOn.name || "Custom Step (Dynamic)"
                }
                addOnIndex += 1
            })
        }

        // Picking up all fields which has name format as la-properties selector and sending them as additional information
        const customPropertiesFields = document.querySelectorAll('input[name^="la-properties"], select[name^="la-properties"], input[name^="_la-properties"], select[name^="_la-properties"]');
        [].forEach.call(customPropertiesFields, function (customField) {
            if ((customField.value && !customField.dataset.prescription_type) || (customField.dataset.prescription_type === this.response.prescriptionType && customField.value)) {
                fieldName = customField.name.replace('la-properties[', '').replace(']', '')
                if ((customField.type == 'radio' && customField.checked) || customField.type != 'radio' ) {
                    data.additional_informations[fieldName] = customField.value
                }
            }
        }.bind(this))
        return data
    },
    Translation: {
        translationJSON: {"default_text": {}, "en": {}},
        getTranslatedText: function(e) {
            locale_code = typeof(Shopify) == undefined ? "default_text" : Shopify.locale.toLowerCase()
            translationJSON = this.translationJSON[locale_code] == undefined ? this.translationJSON.default_text : this.translationJSON[locale_code]
            return translationJSON[e] || e
        },
        apply: function(elements) {
            if (!elements) {
                elements = document.querySelectorAll(".la-translate")
            }
            Array.from(elements).forEach(element => element.innerHTML = this.getTranslatedText(element.innerHTML))
        }
    },
    AddToCartHandler: function(lensAdvizor) {
        this.lensAdvizor = lensAdvizor
        this.timestamp = new Date().getTime()
    },
    UploadPrescription: function(lensAdvizor) {
        this.lensAdvizor = lensAdvizor
        this.fileField = document.querySelector("#la-prescription-file")
        this.file = this.fileField.files[0]
        this.lensAdvizor.loader.style.display = ""
    },
    getPrescriptionTitle: function() {
        customPrescriptionField = document.querySelector('input[name="_la-properties[la-custom-prescription-type]"')
        if (customPrescriptionField && customPrescriptionField.value) {
            return customPrescriptionField.value
        }
        return this.Translation.getTranslatedText(this.response.selectedPrescriptionType.title)
    },
    getPrescriptionMethodDisplayName: function(submissionMethod) {
        if (!submissionMethod) {
            return undefined
        }
        return this.Translation.getTranslatedText(submissionMethod.title())
    },
    Utils: function() {},
    additionalInformations: {},
    customBaseProductProperties: {},
    customLensProperties: {},
    customOptions: {},
    customAddOnsProperties: {},
    CartHandler: function(lensAdvizor) {
        this.lensAdvizor = lensAdvizor
        this.timestamp = new Date().getTime()
    },
    initQuickBuy: function() {
        document.dispatchEvent(new CustomEvent('LensAdvizor:init-quick-buy:start'));

        this.quickBuyButtons = Array.from(document.querySelectorAll('[data-la-quick-buy]'))
        this.quickBuyProductIds = this.quickBuyButtons.map((button) => button.productId)
        const removeRxTaggedButtons = this.quickBuyButtons.filter((button) => button.productJSON.tags.includes('remove-rx'))

        if (removeRxTaggedButtons) {
            this.quickBuyButtons = this.quickBuyButtons.filter(btn => !removeRxTaggedButtons.includes(btn))
            removeRxTaggedButtons.forEach(btn => {
                btn.style.display = 'none'
            });
        }
        
        if (!this.quickBuyProductIds.length) {
            return false
        }
        const productFlows = this.quickBuyButtons.map((button) => {
            return {
                productId: button.productId,
                flowId: button.flowId
            }
        })

        const settingsUrl = this.addQueryParamsToURL(this.API_URL + "/store/quick-buy-settings", {
            store: Shopify.shop,
            product_flows: JSON.stringify(productFlows),
            api_version: 2
        })

        fetch(settingsUrl)
        .then(res => res.json())
        .then(response => {
            this.products = {...this.products, ...response.products}
            this.options = response
            this.settings = response.settings;

            if (!["product", "cart"].includes(this.pageType)) {
                this.enableLunaPdTool = this.options.is_luna_domains_whitelisted && this.options.billing_plan.enable_luna_pd_tool

                if (this.enableLunaPdTool && !this.options.billing_plan.custom_settings.skipLunaInit) {
                   this.Luna.importScript()
                }
                this.updateCustomJSandCss()
                this.addEventListeners()

                this.quickBuyButtons.forEach((button) => {
                    const product = response.products[button.productId]
                    const selectedVariant = button.productJSON.variants.find((variant) => variant.id == button.variantId)

                    if (product.assign_by == "product" && product && product.assigned_variants) {
                        this.updateQuickBuyButton(button, product.assigned_variants[button.variantId].settings)
                    } else if (product.assign_by == "collection" && selectedVariant.available) {
                        this.updateQuickBuyButton(button, product.collection_settings)
                    } else {
                        button.remove()
                    }
                })

                if (this.enableLunaPdTool && !this.options.billing_plan.custom_settings.skipLunaInit) {
                    this.Luna.init(this)
                }
            }
            document.dispatchEvent(new CustomEvent('LensAdvizor:init-quick-buy:complete'));
        })
        .catch(this.handleSettingsException.bind(this))
    },
    getCustomFieldData: function() {
        const properties = {}
        const customPropertiesFields = document.querySelectorAll('input[name^="la-properties"], select[name^="la-properties"], input[name^="_la-properties"], select[name^="_la-properties"]');
        [].forEach.call(customPropertiesFields, function (customField) {
            if ((customField.value && !customField.dataset.prescriptionType) || (customField.dataset.prescriptionType === this.response.prescriptionType && customField.value)) {
                fieldName = customField.name.replace('la-properties[', '').replace(']', '')
                if ((customField.type == 'radio' && customField.checked) || customField.type != 'radio' ) {
                    properties[fieldName] = customField.value
                }
            }
        }.bind(this))
        return properties
    }
}

LensAdvizor.Utils.swatchOptionNames = ["color", "tint", "colour"]
LensAdvizor.Utils.formPrescriptionTypes = ["single_vision", "progressive", "reading"]

LensAdvizor.Utils.isSwatchOption = function(optionName) {
    return this.swatchOptionNames.includes(optionName.toLowerCase())
}

LensAdvizor.Utils.skipPrescriptionLenses = function (callingFunc) {
    if (this.lenses.length == 1 && this.options.prescriptionConfig.skipPrescriptionLenses) {
        if (this.navigationSteps.length == 0 || (this.navigationSteps.length == 1 && this.navigationSteps[0] == `bound ${this.lensDisplayMethod}`)) {
            // If navigationSteps length is 1 and the first element is the lensDisplayMethod, override navigationSteps value since we are skipping that screen
            if (["renderOptions", "renderOption"].includes(callingFunc)) {
                this.navigationSteps = ["bound renderOptions"]
                this.navigation = { 1: this.renderOptions.bind(this) }
            } else {
                this.navigationSteps = [`bound ${callingFunc}`]
                this.navigation = { 1: this[callingFunc].bind(this) }
            }
            this.stepIndex = this.navigationSteps.length;
            this.updateProgressBar(this.stepIndex);

            if (callingFunc == "renderOptions") {
                this.formBtn.style.display = ''
                this.formBtn.parentElement.style.display = ''
                this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Save and Continue")
            }
        } else if (this.navigationSteps.length == 2 && this.navigationSteps[1] == `bound ${this.lensDisplayMethod}`) {
            // If navigationSteps length is 2 and the second element is the lensDisplayMethod, remove that element and push renderOptions instead
            this.stepIndex -= 1
            this.navigationSteps.splice(this.stepIndex, 1);
            if (["renderOptions", "renderOption"].includes(callingFunc)) {
                this.navigationSteps.push("bound renderOptions");
                this.stepIndex = this.navigationSteps.length;
                this.navigation[this.stepIndex] = this.renderOptions.bind(this)
            } else {
                this.navigationSteps.push(`bound ${callingFunc}`);
                this.stepIndex = this.navigationSteps.length;
                this.navigation[this.stepIndex] = this[callingFunc].bind(this)
            }
            this.updateProgressBar(this.stepIndex);

            if (callingFunc == "renderOptions") {
                this.formBtn.style.display = ''
                this.formBtn.parentElement.style.display = ''
                this.formBtn.firstElementChild.innerHTML = this.Translation.getTranslatedText("Save and Continue")
            }
        } else {
            if (["renderOptions", "renderOption"].includes(callingFunc)) {
                this.updateState(this.renderOptions.bind(this), callingFunc == "renderOptions" ? true : false)
            } else {
                this.updateState(this[callingFunc].bind(this))
            }
        }
    } else {
        if (["renderOptions", "renderOption"].includes(callingFunc)) {
            this.updateState(this.renderOptions.bind(this), callingFunc == "renderOptions" ? true : false)
        } else {
            this.updateState(this[callingFunc].bind(this))
        }
    }
}

LensAdvizor.Utils.getReviewDetails = function () {
    const { manually } = this.response;
    const metaDataFields = Object.keys(this.product.meta_data)

    const reviewDetails = {
        odRight: { ...manually.od_right},
        osLeft: { ...manually.os_left}
    }

    this.contactLensFormData.forEach(function(field){
        if (field.name.includes('la-odright')) {
            if (field.name.includes('quantity')) {
                odRightQuantity = parseInt(field.value)
            }
            reviewDetails.odRight[field.name.replace('la-odright-', '')] = field.value
        } else {
            if (field.name.includes('quantity')) {
                osLeftQuantity = parseInt(field.value)
            }
            reviewDetails.osLeft[field.name.replace('la-osleft-', '')] = field.value
        }
    }.bind(this))

    Object.keys(reviewDetails.odRight).forEach(fieldName => {
        if (!metaDataFields.includes(fieldName) && fieldName != "quantity") {
            delete reviewDetails.odRight[fieldName]
        }
    })

    Object.keys(reviewDetails.osLeft).forEach(fieldName => {
        if (!metaDataFields.includes(fieldName) && fieldName != "quantity") {
            delete reviewDetails.osLeft[fieldName]
        }
    })

    return reviewDetails;
}

LensAdvizor.AddToCartHandler.prototype.filterProperties = function(properties) {
    return properties;
}

LensAdvizor.AddToCartHandler.prototype.getProperties = function(propertyType) {
    const { lensVariant, lens } = this.lensAdvizor.response;

    if (propertyType === "base_product") {
        // combine if any additional properties that have been added by custom code 
        let props = {...{
            "_unique_identifier": this.lensAdvizor.response.uniqueIdentifier,
            "_productType": "frame",
            [this.lensAdvizor.Translation.getTranslatedText("Prescription Type")]: this.lensAdvizor.getPrescriptionTitle(),
            [this.lensAdvizor.Translation.getTranslatedText("Method")]: this.lensAdvizor.getPrescriptionMethodDisplayName(this.lensAdvizor.response.method) || ""
        }, ...this.lensAdvizor.customBaseProductProperties }

        if (lensVariant) {
            props = {...props, 
                [this.lensAdvizor.Translation.getTranslatedText("Lens")]: `${lens.name}${lensVariant.name != 'Default Title' ? ` - ${lensVariant.name}` : ''}`,
                "_lens_variant_id": lensVariant.variant_id
            }
        }

        return this.filterProperties(props)
    }

    if (propertyType === "addOns") {
        // combine if any additional properties that have been added by custom code 
        return  this.filterProperties({...{
            "_productType": "addon",
            "_unique_identifier": this.lensAdvizor.response.uniqueIdentifier,
            [this.lensAdvizor.Translation.getTranslatedText("Paired With")]: this.lensAdvizor.productTitle
        }, ...this.lensAdvizor.customAddOnsProperties })
    }
    properties = {
        "_unique_identifier": this.lensAdvizor.response.uniqueIdentifier,
        "_productType": propertyType,
        "_base_variant_id": this.lensAdvizor.selectedOrDefaultVariant,
        [this.lensAdvizor.Translation.getTranslatedText("Lens Group")]: this.lensAdvizor.Translation.getTranslatedText(this.lensAdvizor.response.lens.group_title),
        [this.lensAdvizor.Translation.getTranslatedText("Prescription Type")]: this.lensAdvizor.getPrescriptionTitle(),
        [this.lensAdvizor.Translation.getTranslatedText("Prescription Method")]: this.lensAdvizor.getPrescriptionMethodDisplayName(this.lensAdvizor.response.method),
        [this.lensAdvizor.Translation.getTranslatedText("Frame")]: this.lensAdvizor.productTitle,
    }

    const prescriptionType = this.lensAdvizor.getPredictedPrescriptionType(true)
    let manualResponse = this.lensAdvizor.response.manually

    if (!this.lensAdvizor.settings.hideManualPrescription) {
        if (this.lensAdvizor.response.method === "entered_manually") {
            properties = this.parseManualEntryInformation(prescriptionType, properties, manualResponse)
        } else if (this.lensAdvizor.response.method === "uploaded" || this.lensAdvizor.response.customMethod === "email_later") {
            properties = this.parseUploadEntryInformation(properties, manualResponse)
        } else if (this.lensAdvizor.response.method === "provider_information") {
            properties = this.parseProviderInformation(properties, manualResponse.provider)
        }

        if (this.lensAdvizor.response.prescription) {
            properties["_Prescription File"] = this.lensAdvizor.response.prescription.authenticateURL
        }
    }
    // combine in any additional properties that have been added by custom code 
    // Picking up all fields which has name format as la-properties selector
    return {...this.filterProperties(properties), ...this.lensAdvizor.customLensProperties, ...this.lensAdvizor.customOptions, ...this.lensAdvizor.getCustomFieldData()}
}

LensAdvizor.AddToCartHandler.prototype.parseUploadEntryInformation = function (properties, manualResponse) {
    let values = []

    if (this.lensAdvizor.options.prescriptionConfig.segmentHeight !== "hidden" && manualResponse.segment_height) {
        properties[this.lensAdvizor.Translation.getTranslatedText("Segment Height")] = manualResponse.segment_height
    }
    if (manualResponse.pd.type === 'Single PD' && manualResponse.pd.value || manualResponse.pd.type === 'Dual PD' && manualResponse.pd.right && manualResponse.pd.left) {
        LensAdvizor.Utils.getFieldKeys(manualResponse.pd).forEach(function(fieldName, index) {
            if (manualResponse.pd[fieldName] && fieldName != "lunaPdCount") {
                values.push(manualResponse.pd[fieldName])
            }
        })
    }
    if (values.length > 0 && typeof values[0] === "string") {
        properties[this.lensAdvizor.Translation.getTranslatedText("PD")] = values.join(" | ")
    }
    return properties
}

LensAdvizor.AddToCartHandler.prototype.parseProviderInformation = function(properties, provider) {
    properties["First and last name"] = provider.customerName
    properties["Date of birth"] = provider.dateOfBirth
    properties["Doctor's name"] = provider.doctorName
    properties["Doctor's address"] = provider.doctorAddress
    properties["Doctor's phone number"] = provider.doctorPhoneNo
    return properties
}

LensAdvizor.AddToCartHandler.prototype.parseManualEntryInformation = function (prescriptionType, properties, manualResponse) {

    let responseKeys = Object.keys(manualResponse)
    responseKeys.forEach(function(key, index) {
        if (typeof manualResponse[key] === "string" && manualResponse[key] != "") {
            if ("segment_height" == key) {
                properties["Segment Height"] = manualResponse[key]
            } else if (key == "sph" && prescriptionType === "reading") {
                properties["Diopters"] = manualResponse[key]
            } else {
                properties[key] = manualResponse[key]
            }
        } else if (typeof manualResponse[key] !== "string" && manualResponse[key]) {
            let values = []
            LensAdvizor.Utils.getFieldKeys(manualResponse[key]).forEach(function(fieldName, secondaryIndex) {
                if (typeof manualResponse[key][fieldName] === "string" && manualResponse[key][fieldName] != "") {
                    if (fieldName === "axis") {
                        values.push("x" + manualResponse[key][fieldName])
                    } else if (fieldName === "add") {
                        values.push("ADD " + manualResponse[key][fieldName])
                    } else if (key === "pd" && ["left", "right"].includes(fieldName) && manualResponse[key][fieldName] && (manualResponse[key].right || manualResponse[key].left)) {
                        values.push(`${fieldName === "left" ? "OS - " : "OD - "}${manualResponse[key][fieldName]}`)
                    } else {
                        if (key === "pd" && manualResponse[key].value && manualResponse[key][fieldName] && fieldName != "lunaPdCount") {
                            values.push(manualResponse[key][fieldName])    
                        } else if (key !== "pd") {
                            values.push(manualResponse[key][fieldName])
                        }
                    }
                } else if (typeof manualResponse[key][fieldName] !== "string" && manualResponse[key][fieldName] && fieldName != "lunaPdCount") {
                    let nested_values = {key: (fieldName == "od_right" ? "Prism OD" : "Prism OS"), values: []}
                    LensAdvizor.Utils.getFieldKeys(manualResponse[key][fieldName]).forEach(function(SecondaryfieldName, nestedIndex) {
                        if (manualResponse[key][fieldName][SecondaryfieldName]) {
                            nested_values.values.push(manualResponse[key][fieldName][SecondaryfieldName])
                        }
                    })
                    values.push(nested_values)
                }
            })
            if (values.length > 0 && typeof values[0] === "string" && prescriptionType !== "reading") {
                if (key === "od_right") {
                    key = "OD Right"
                } else if (key === "os_left") {
                    key = "OS Left"
                } else {
                    key = key.toUpperCase()
                }
                properties[key] = values.join(" | ")
            } else if (values.length > 0 && typeof values[0] === "string" && prescriptionType === "reading" && !["od_right", "os_left"].includes(key)) {
                if(key == "diopters")
                    properties["Diopters"] = values.join(" | ")
                else
                    properties[key.toUpperCase()] = values.join(" | ")
            } else if (values.length > 0 && typeof values[0] !== "string") {
                values.forEach(function (obj, index) {
                    if (obj.values.length > 0) {
                        properties[obj.key] = obj.values.join(" | ")
                    }
                })
            }
        }
    })
    return properties
}

LensAdvizor.AddToCartHandler.prototype.performOperation = function () {

    if (this.lensAdvizor.isContactLensFlow) {
        return this.addContactLensToCart()
    }

    this.lensAdvizor.loader.style.display = ''

    const { lensVariant, lens, addOns, prescriptionType, selectedPrescriptionType } = this.lensAdvizor.response;

    this.lensAdvizor.response.uniqueIdentifier = `${prescriptionType}__${this.lensAdvizor.productId}__${this.timestamp}`
    let items = []

    let quantity = document.querySelector(".la-quantity")
    if (quantity) {
        quantity = quantity.value
    } else {
        quantity = 1
    }

    if (quantity == "0" || quantity == 0) {
        document.dispatchEvent(new CustomEvent('LensAdvizor:action:exception', {
            detail: {
                message: this.lensAdvizor.Translation.getTranslatedText('Quantity Error'),
            }
        }));
        return false
    }

    const customAddOnLine = this.lensAdvizor.customAddOns.map(customAddOn => {
        return {
            id: customAddOn.variantId,
            quantity: customAddOn.quantity || 1,
            properties: {
                ...customAddOn.properties || {},
                _canSkip: customAddOn.canSkip ? customAddOn.canSkip: false,
                message: customAddOn.message || "",
                _productType: "addon",
                _unique_identifier: this.lensAdvizor.response.uniqueIdentifier,
                [this.lensAdvizor.Translation.getTranslatedText("Paired With")]: this.lensAdvizor.productTitle
            }
        }
    })
    let addOnsLength = customAddOnLine.length
    const isAddOnsAvailable = lens.add_ons || customAddOnLine.length > 0 || selectedPrescriptionType?.metafield?.addon_flow
    if (isAddOnsAvailable) {
        Object.keys(addOns).forEach(function(step){
            const stepInfo = addOns[step]
            if (stepInfo.variantId && stepInfo.product) {
                if (stepInfo.bundleProducts) {
                    addOnsLength += 1
                }
                let properties = this.getProperties("addOns")
                properties._canSkip = !stepInfo.bundleProducts
                items.push({
                    quantity: quantity,
                    id: stepInfo.variantId,
                    properties: properties
                })
            }
        }.bind(this))
    }

    if (customAddOnLine.length) {
        items = [...items, ...customAddOnLine]
    }

    let productData = {
        quantity: quantity || 1,
        id: this.lensAdvizor.selectedOrDefaultVariant,
        properties: this.getProperties("base_product")
    }

    if (lensVariant) {
        items.push({
            quantity: quantity,
            id: lensVariant.variant_id,
            properties: this.getProperties("lens")
        })
        let lensPrice = parseFloat(lensVariant.price) == 0 ? this.lensAdvizor.Translation.getTranslatedText('FREE') : this.lensAdvizor.formatCurrency(parseFloat(lensVariant.price))
    }

    if (this.lensAdvizor.options.variantConfig.addBaseProduct) {
        items.push(productData)
    }

    items = this.bundleProducts(this.timestamp, items, isAddOnsAvailable, addOnsLength)

    if (this.lensAdvizor.formBtn.style.display != "none") {
        this.lensAdvizor.formBtn.firstElementChild.setAttribute("disabled", "disabled")
        this.lensAdvizor.formBtn.firstElementChild.innerHTML = `${this.lensAdvizor.Translation.getTranslatedText("Adding to cart")}...`
    }

    const addToCartSuccessCallback = function (response) {
        return LensAdvizor.Utils.getCart()
        .then(function({token}) {
            this.sendPrescriptionRequest(this.lensAdvizor.getPrescriptionRequestData(token))
        }.bind(this))
    }

    const addToCartErrorCallback = function(response) {
        this.lensAdvizor.formBtn.firstElementChild.innerHTML = this.lensAdvizor.Translation.getTranslatedText("Add to cart")
        this.lensAdvizor.formBtn.firstElementChild.removeAttribute("disabled")
        document.dispatchEvent(new CustomEvent('LensAdvizor:action:exception', {
            detail: {
                message: response.description || this.lensAdvizor.Translation.getTranslatedText("Something went wrong while adding product!"),
                response: response
            }
        }));

        if (this.lensAdvizor.response.prescriptionType === "frame_only") {
            this.lensAdvizor.resetUserResponse()
        }
    }

    return LensAdvizor.Utils.getCart()
    .then(({ note }) => {
        this.addToCart(
            { items: items},
            addToCartSuccessCallback.bind(this),
            addToCartErrorCallback.bind(this)
        )
    })
}

LensAdvizor.AddToCartHandler.prototype.makePrescriptionRequest = function (payload) {
    return fetch(this.lensAdvizor.API_URL + '/prescriptions/?shop=' + Shopify.shop + '&api_version=2', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
}

LensAdvizor.AddToCartHandler.prototype.sendPrescriptionRequest = function (payload) {
    this.makePrescriptionRequest(payload)
    .then(response => {
        if (response.ok) {
            return response.json()
        }
        return Promise.reject(response);
    })
    .then(function(responseJson){
        document.dispatchEvent(new CustomEvent('LensAdvizor:prescription:updated', { detail: payload }));
        let redirectToCart = true
        if (this.lensAdvizor.options.settings.post_add_to_cart && this.lensAdvizor.postAddToCart) {
            this.lensAdvizor.postAddToCart()
            redirectToCart = false
        }
        if (typeof LensAdvizorEmbed != 'undefined' && LensAdvizorEmbed.postAddToCart) {
            LensAdvizorEmbed.postAddToCart()
            redirectToCart = false
        }

        if (redirectToCart) {
            window.location.href = `${Shopify.routes.root}cart`
        } else {
            document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'))
        }
    }.bind(this))
    .catch(function(response) {
        // Handle Add To Cart error
        if (this.retryCount) {
            return window.location.reload()
        }
        this.retryCount = 1
        this.sendPrescriptionRequest(payload)
    }.bind(this))
    return true;
}

LensAdvizor.AddToCartHandler.prototype.bundleProducts = function (bundleId, items, isAddOnsAvailable, addOnsLength) {
    return items.map(function (item){
        if (item.properties._canSkip) {
            item.properties._bundleId = bundleId
            return item
        }

        if (this.lensAdvizor.options.variantConfig.addBaseProduct) {
            item.properties._bundleId = bundleId
        } else {
            item.properties._xBundleId = bundleId
        }

        if (item.properties._productType === 'frame' && (this.lensAdvizor.response.lens.add_ons_products || this.lensAdvizor.response.selectedPrescriptionType?.metafield?.addon_flow)) {
            item.properties._addOns = addOnsLength
        }
        return item
    }.bind(this))
}

LensAdvizor.AddToCartHandler.prototype.addContactLensToCart = function () {
    let odRightQuantity = 1
    let osLeftQuantity = this.lensAdvizor.singleContactLens ? 0 : 1

    const { manually } = this.lensAdvizor.response;

    var odRight = {...manually.od_right}
    var osLeft = {...manually.os_left}

    this.lensAdvizor.contactLensFormData.forEach(function(field){
        if (field.name.includes('la-odright')) {
            if (field.name.includes('quantity')) {
                odRightQuantity = parseInt(field.value)
            }
            odRight[field.name.replace('la-odright-', '')] = field.value
        } else {
            if (field.name.includes('quantity')) {
                osLeftQuantity = parseInt(field.value)
            }
            this.lensAdvizor.response.manually.os_left[field.name.replace('la-osleft-', '')] = field.value
        }
    }.bind(this))

    this.lensAdvizor.response.prescriptionType = 'contact_lenses'
    this.lensAdvizor.response.uniqueIdentifier = `contact_lenses__${this.lensAdvizor.productId}__${this.timestamp}`
    this.lensAdvizor.response.method = 'entered_manually'
    this.lensAdvizor.response.manually.contact_lenses = 'left'
    this.lensAdvizor.formBtn.firstElementChild.innerHTML = this.lensAdvizor.Translation.getTranslatedText('Processing')
    this.lensAdvizor.formBtn.firstElementChild.setAttribute("disabled", "disabled")

    const item = {
        quantity: osLeftQuantity,
        id: this.lensAdvizor.selectedOrDefaultVariant,
        properties: this.getContactLensProperties('os_left')
    }

    if (this.lensAdvizor.singleContactLens) {
        this.lensAdvizor.response.manually.os_left = osLeft
        this.lensAdvizor.response.manually.od_right = odRight
        this.lensAdvizor.response.manually.contact_lenses = 'right'
        this.timestamp = new Date().getTime()

        item.quantity = odRightQuantity
        item.properties = this.getContactLensProperties("od_right")
        delete item.properties["OD"]
        return this.addLensToCart(item, function() {
            const cart = this.lensAdvizor.makeRequest("GET", Shopify.routes.root + 'cart.js')
            return this.sendPrescriptionRequest(this.lensAdvizor.getPrescriptionRequestData(cart.token))
        }.bind(this))
    }

    return this.addLensToCart(item, function () {
        const cart = this.lensAdvizor.makeRequest("GET", Shopify.routes.root + 'cart.js')
        this.makePrescriptionRequest(this.lensAdvizor.getPrescriptionRequestData(cart.token))
        .then(response => response.json())
        .then(function () {
            this.lensAdvizor.response.manually.os_left = osLeft
            this.lensAdvizor.response.manually.od_right = odRight
            this.lensAdvizor.response.manually.contact_lenses = 'right'
            this.timestamp = new Date().getTime()
            this.lensAdvizor.response.uniqueIdentifier = `contact_lenses__${this.lensAdvizor.productId}__${this.timestamp}`

            item.quantity = odRightQuantity
            item.properties = this.getContactLensProperties("od_right")

            this.addLensToCart(item, function () {
                return this.sendPrescriptionRequest(this.lensAdvizor.getPrescriptionRequestData(cart.token))
            }.bind(this))
        }.bind(this))
    }.bind(this))
    return false;
}

LensAdvizor.AddToCartHandler.prototype.addLensToCart = function (item, callback) {
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
    }
    return this.addToCart({items: [item]}, callback, function (response) {
        document.dispatchEvent(new CustomEvent('LensAdvizor:action:exception', {
            detail: {
                message: response.description || this.lensAdvizor.Translation.getTranslatedText("Something went wrong while adding product!"),
                response: response
            }
        }));
        this.lensAdvizor.formBtn.firstElementChild.innerHTML = this.lensAdvizor.Translation.getTranslatedText("Add to cart")
        this.lensAdvizor.formBtn.firstElementChild.removeAttribute("disabled")
    }.bind(this))
}

LensAdvizor.AddToCartHandler.prototype.addToCart = function (data, successCallback, failureCallback) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
    .then(LensAdvizor.Utils.handleServerResponse)
    .then(response => JSON.parse(response))
    .then(responseJson => {
        document.dispatchEvent(new CustomEvent('LensAdvizor:addToCart:success', { detail: data, response: responseJson }));
        if (successCallback) {
            return successCallback(responseJson)
        }
        return responseJson
    })
    .catch(response => {
        let responseJson = JSON.parse(response)
        document.dispatchEvent(new CustomEvent('LensAdvizor:addToCart:error', { detail: {
            payload: data, response: responseJson.response
        }}));
        if (failureCallback) {
            return failureCallback(responseJson.response)
        }
        return response
    })
}

LensAdvizor.AddToCartHandler.prototype.getContactLensProperties = function (fieldType, withQuantity) {
    const metaDataFields = Object.keys(this.lensAdvizor.product.meta_data)

    const settings = this.lensAdvizor.getPrescriptionRequestData()[fieldType]
    const typeKey = fieldType.split("_")[0]
    const properties = {
        "_unique_identifier": this.lensAdvizor.response.uniqueIdentifier,
        [this.lensAdvizor.Translation.getTranslatedText("Prescription Type")]: this.lensAdvizor.getPrescriptionTitle(),
        [this.lensAdvizor.Translation.getTranslatedText("Method")]: this.lensAdvizor.getPrescriptionMethodDisplayName(this.lensAdvizor.response.method),
        [this.lensAdvizor.Translation.getTranslatedText(typeKey.toUpperCase())]: this.lensAdvizor.Translation.getTranslatedText(fieldType.replace('os', '').replace('od', '').title()),
    }

    if (!this.lensAdvizor.settings.hideManualPrescription) {
        for (let key in settings) {
            if (metaDataFields.includes(key)) {
                const translatedKey = this.lensAdvizor.Translation.getTranslatedText('Contacts_' + key)
                if (['d/n', 'sph', 'cyl'].includes(key) && settings[key] ) {
                    properties[translatedKey] = settings[key]
                } else if (key !== 'quantity' && settings[key]) {
                    properties[translatedKey] = settings[key]
                } else if (key === 'quantity' && withQuantity) {
                    properties[translatedKey] = settings[key]
                }
            }
        }
        if (this.lensAdvizor.response.prescription) {
            properties["_Prescription File"] = this.lensAdvizor.response.prescription.authenticateURL
        }
    }
    return {...properties, ...this.lensAdvizor.customBaseProductProperties}
}

LensAdvizor.Utils.handleServerResponse = function (response) {
    return response.json()
    .then((json) => {
        // Modify response to include status ok, success, and status text
        let modifiedJson = {
            success: response.ok,
            status: response.status,
            statusText: response.statusText ? response.statusText : json.error || '',
            response: json
        }
        // If request failed, reject and return modified json string as error
        if (! modifiedJson.success) return Promise.reject(JSON.stringify(modifiedJson))
        // If successful, continue by returning modified json string
        return JSON.stringify(modifiedJson)
    })
}

LensAdvizor.Utils.getCart = () => {
    return fetch(`${Shopify.routes.root}cart.json`)
    .then(res => res.json())
}

LensAdvizor.Utils.uuidv4 = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

LensAdvizor.Utils.getFieldKeys = obj => Object.keys(obj).filter((k) => obj != null)

LensAdvizor.UploadPrescription.prototype.getFormData = function () {
    let formData = new FormData()
    formData.append("filename", this.file.name)
    formData.append("domain", Shopify.shop)
    formData.append("content_type", this.file.type)
    return formData
}

LensAdvizor.UploadPrescription.prototype.upload = async function () {
    const self = this
    const uploadInformation = document.querySelector("#la-prescription-upload-message")
    if (this.file) {
        let signedResponse = await fetch(`${this.lensAdvizor.API_URL}/prescriptions/upload/`, {
            method: 'POST',
            body: this.getFormData(),
            api_version: 2
        })
        signedResponse = await signedResponse.json()
        const resizedFile = await this.getResizedFile()
        let uploadResponse = await fetch(signedResponse.uploadUrl, {
            method: 'PUT',
            mode: 'cors',
            body: resizedFile
        }).catch(err => {
            uploadInformation.innerHTML = `<span class="la-error">${this.lensAdvizor.Translation.getTranslatedText("Unable to upload prescription. Please try again.")}</span>`
            this.lensAdvizor.response.prescription = null
            this.fileField.value = ""
            this.lensAdvizor.loader.style.display = 'none'
        });
        
        if (uploadResponse) {
            if ([200, 201].includes(uploadResponse.status)) {
                this.lensAdvizor.response.prescription = {
                    fileUrl: signedResponse.filename,
                    authenticateURL: signedResponse.authenticateURL,
                    originalName: this.file.name,
                    type: this.file.type,
                    blob: URL.createObjectURL(this.file),
                    lastModified: this.file.lastModified,
                    size: this.file.size
                }
                uploadInformation.innerHTML = `${this.lensAdvizor.svg.check} ${this.file.name}`
                document.querySelector('.la-prescription-file-label span').innerHTML = this.lensAdvizor.Translation.getTranslatedText("Change File")
            } else {
                uploadInformation.innerHTML = `<span class="la-error">${this.lensAdvizor.Translation.getTranslatedText("Unable to upload prescription. Please try again.")}</span>`
                this.lensAdvizor.response.prescription = null
                this.fileField.value = ""
            }
        }
    }
    this.lensAdvizor.loader.style.display = 'none'
}

LensAdvizor.UploadPrescription.prototype.getResizedFile = function () {
    // Check if File is PDF return file
    // If File is Image then resize image size max to 1MB
    return new Promise((resolve, reject) => {
        if (this.file.type.includes("image")) {
            if (this.file.size >= 1000000) {
                const MAX_WIDTH = 1440;
                const MAX_HEIGHT = 1440;
                const MIME_TYPE = this.file.type;
                const QUALITY = 0.8;
    
                const blobURL = window.URL.createObjectURL(this.file);
                const img = new Image();
                img.src = blobURL;
    
                const file = this.file
                let that = this;

                img.onload = function (ev) {
                    URL.revokeObjectURL(this.src);
                    const [newWidth, newHeight] = calculateImageSize(img, MAX_WIDTH, MAX_HEIGHT);
                    const canvas = document.createElement("canvas");
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);
                    canvas.toBlob(blob => {
                        let uploadableFile = new File([blob], file.name, {type: file.type})
                        that.file = uploadableFile
                        resolve(that.file)
                    }, MIME_TYPE, QUALITY);
                };
            } else {
                resolve(this.file)
            }
    
            function calculateImageSize(img, maxWidth, maxHeight) {
                let width = img.width;
                let height = img.height;

                // Calculate the width and height, constraining the proportions
                if (width > height) {
                    if (width > maxWidth) {
                        height = Math.round((height * maxWidth) / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = Math.round((width * maxHeight) / height);
                        height = maxHeight;
                    }
                }
                return [width, height];
            }
        } else {
            resolve(this.file)
        }
    })
}

LensAdvizor.CartHandler.prototype.performOperation = function () {
    if (this.lensAdvizor.pageType == "cart") {
        document.dispatchEvent(new CustomEvent('LensAdvizor:init:complete'));
    } else {
        document.dispatchEvent(new CustomEvent('LensAdvizor:cart:init'));
    }
    this.addEventListeners()
}

LensAdvizor.CartHandler.prototype.addEventListeners = function () {
    this.addListnerForfetchAPI(window, window.fetch)
    this.addListnerForAjax()

    document.addEventListener("LensAdvizor:Cart:Updated", this.updateCart.bind(this))
    document.addEventListener("LensAdvizor:Cart:Stable", this.handleCartStablity.bind(this))
    this.updateCart()
}

LensAdvizor.CartHandler.prototype.updateCart = async function () {
    this.cart = this.getCartData()
    this.isProcessed = false

    let itemsUpdated = false

    if (this.lensAdvizor.settings.preventAddLensToCart) {
        var orphanLens = this.cart.items.filter(item => item.properties == null && item.vendor == "LensAdvizor" )
        orphanLens.forEach(lens => {
            this.lensAdvizor.makeRequest('POST', `${Shopify.routes.root}cart/change.js?id=${lens.key}&quantity=0`)
            itemsUpdated = true
        })
    }

    const isProcessed = this._isProcessed(this.cart)

    var bundleIds = Array.from(new Set(this.cart.items.map(item => item.properties !== null && item.properties._bundleId))).filter(obj => obj)
    var xBundleId = Array.from(new Set(this.cart.items.map(item => item.properties !== null && item.properties._xBundleId))).filter(obj => obj)
    const isDiscountAvailable = this.cart.items.filter(item => item.properties !== null && item.properties._bundleId && item.properties._apply_discount).length > 0
    if (this.lensAdvizor.options && this.lensAdvizor.options.settings.overideCart && !isDiscountAvailable) {
        this.checkoutUrl = '/checkout?discount=+'
    }
    if (isProcessed) {
        document.dispatchEvent(new CustomEvent('LensAdvizor:Cart:Stable'));
        return false;
    }

    await Promise.all(bundleIds.map(async (bundleId) => {
        return await this.updateBundleItem(bundleId)
    }))

    xBundleId.forEach(function(bundleId) {
        this.updateXBundleItem(bundleId)
    }.bind(this))

    if (this.isProcessed) {
        const cartData = this.getRequiredCartFields(this.getCartData())
        localStorage.setItem("_la_cart", JSON.stringify(cartData))
    }

    if (this.isProcessed && this.lensAdvizor.pageType == "cart" && !window.location.href.includes("hriks")) {
        window.location.reload()
    } else {
        document.dispatchEvent(new CustomEvent('LensAdvizor:Cart:Stable'));
    }
}

LensAdvizor.CartHandler.prototype.getRequiredCartFields = function(cartData) {
    return cartData.items.map((item) => {
        return {
            id: item.id,
            quantity: item.quantity,
            variant_id: item.variant_id,
            properties: item.properties,
            key: item.key,
            vendor: item.vendor
        }
    })
}

LensAdvizor.CartHandler.prototype.updateBundleItem = async function (bundleId) {
    const items = this.cart.items.filter(item => item.properties !== null && item.properties._bundleId === bundleId)
    const frame = items.find(item => item.properties._productType === 'frame')
    const lens = items.find(item => item.properties._productType === 'lens' || item.properties._productType === 'resolved_lens')
    const addOns = items.filter(item => item.properties._productType === 'addon' && !item.properties._canSkip)
    const isFrameOnly = frame?.properties?._unique_identifier?.startsWith('frame_only')

    if (bundleId !== undefined && (frame === undefined || !isFrameOnly || (isFrameOnly && frame.properties._addOns > 0))) {
        let isRequiredAddOnRemoved = frame === undefined || frame.properties._addOns !== addOns.length;
        let quantity = lens && frame && !isRequiredAddOnRemoved ? frame.quantity : 0
        if (frame && frame.properties._lens_variant_ids && frame.properties._lens_variant_ids.length !== items.filter(item => item.properties._productType === 'lens' || item.properties._productType === 'resolved_lens').length) {
            quantity = 0
        }

        if (isFrameOnly && frame.properties._addOns > 0) {
            quantity = frame && addOns.length == frame.properties._addOns ? frame.quantity : 0;
        }

        var cartItems = items;

        var updatePayload = {}
        var addPayload = []

        items.forEach(function(item){
            const { properties } = item;
            if (properties._productType === 'resolved_lens') {
                quantity *= 2
            }
            if (quantity === 0 || item.quantity !== frame.quantity || properties._productType === 'resolved_lens') {
                updatePayload[item.key] = quantity
                if (properties._canSkip && properties._bundleId && quantity == 0) {
                    addPayload.push({id: item.variant_id, quantity: item.quantity})
                }
            }
        })

        if (Object.keys(updatePayload).length > 0) {
            this.isProcessed = true
            await this.lensAdvizor.fetchRequest('POST', `${Shopify.routes.root}cart/update.js`, JSON.stringify({updates: updatePayload}))
        }
        if (Object.keys(addPayload).length > 0) {
            this.isProcessed = true
            await this.lensAdvizor.fetchRequest('POST', `${Shopify.routes.root}cart/add.js`, JSON.stringify({items: addPayload}))
        }
    }
}

LensAdvizor.CartHandler.prototype.updateXBundleItem = function (bundleId) {
    const items = this.cart.items.filter(item => item.properties !== null && item.properties._xBundleId === bundleId)
    const lens = items.find(item => item.properties._productType === 'lens' || item.properties._productType === 'resolved_lens')
    const addOns = items.filter(item => item.properties._productType === 'addon')

    let isRequiredAddOnRemoved = lens === undefined || lens.properties._addOns !== addOns.length;
    let quantity = lens ? lens.quantity : 0
    var payload = {}
    items.forEach(function(item){
        if (quantity === 0 || item.quantity !== lens.quantity) {
            payload[item.key] = quantity
        }
    })

    if (Object.keys(payload).length > 0) {
        this.isProcessed = true
        this.lensAdvizor.makeRequest('POST', `${Shopify.routes.root}cart/update.js`, JSON.stringify({updates: payload}), true)
    }
}

LensAdvizor.CartHandler.prototype.handleCartStablity = function () {

}

LensAdvizor.CartHandler.prototype.getCartData = function() {
    return this.lensAdvizor.makeRequest('GET', `${Shopify.routes.root}cart.js`)
}

LensAdvizor.CartHandler.prototype._isProcessed = function (data) {
    return localStorage.getItem('_la_cart') === JSON.stringify(this.getRequiredCartFields(data))
}

LensAdvizor.CartHandler.prototype.addListnerForAjax = function () {
    var self = this;

    setTimeout(function () {
        var proxied = window.XMLHttpRequest.prototype.send;
        window.XMLHttpRequest.prototype.send = function() {
            //Here is where you can add any code to process the request. 
            //If you want to pass the Ajax request object, pass the 'pointer' below
            var pointer = this
            var intervalId = window.setInterval(function(){
                if(pointer.readyState != 4){
                    return;
                }
                clearInterval(intervalId);
                if (pointer.responseURL.includes('change.js') && self.products && Object.keys(self.products.length > 0)) {
                    document.dispatchEvent(new CustomEvent('LensAdvizor:Cart:Updated'));
                }
            }, 1);//I found a delay of 1 to be sufficient, modify it as you need.
            return proxied.apply(this, [].slice.call(arguments));
        };
    }, 100)
}

LensAdvizor.CartHandler.prototype.addListnerForfetchAPI = function (ns, fetch) {
    if (typeof fetch !== "function") {
        return
    };
    ns.fetch = function () {
        const response = fetch.apply(this, arguments);
        response.then(res => {
            if (res.url.includes("cart/update") || res.url.includes("cart/change")) {
                res
                .clone()
                .json()
                .then(data => document.dispatchEvent(new CustomEvent('LensAdvizor:Cart:Updated')));
            }
        });
        return response;
    }
}

String.prototype.generateUnique = function () {
    return this.generateId().replace(/[^a-zA-Z0-9 ]/g, "-")
}